//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import BaseClient from './BaseClient';

export class AccountClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    login(login: UserLoginModel | null | undefined): Promise<UserLoginDetailsModel | null> {
        let url_ = this.baseUrl + "/api/v1/Account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogin(_response));
        });
    }

    protected processLogin(response: Response): Promise<UserLoginDetailsModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserLoginDetailsModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserLoginDetailsModel | null>(null as any);
    }

    refreshToken(): Promise<UserLoginDetailsModel | null> {
        let url_ = this.baseUrl + "/api/v1/Account/refreshToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefreshToken(_response));
        });
    }

    protected processRefreshToken(response: Response): Promise<UserLoginDetailsModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserLoginDetailsModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserLoginDetailsModel | null>(null as any);
    }

    logout(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Account/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogout(_response));
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    acceptEula(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Account/actions/acceptEula";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAcceptEula(_response));
        });
    }

    protected processAcceptEula(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AMS360SetupsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    aMS360Setups(ndtParameters: AMS360SetupsModel | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/ndt/epic/ams360setuptimings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ndtParameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAMS360Setups(_response));
        });
    }

    protected processAMS360Setups(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    listAll(): Promise<AMS360SetupsModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/ndt/epic";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListAll(_response));
        });
    }

    protected processListAll(response: Response): Promise<AMS360SetupsModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AMS360SetupsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AMS360SetupsModel[] | null>(null as any);
    }

    get(id: string): Promise<AMS360SetupsModel | null> {
        let url_ = this.baseUrl + "/api/v1/ndt/epic/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<AMS360SetupsModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AMS360SetupsModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AMS360SetupsModel | null>(null as any);
    }

    getTimings(ndtId: string, afterSequenceId: number | null, recordLimit: number | null): Promise<AMS360SetupsTimingModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/ndt/epic/timing?";
        if (ndtId === undefined || ndtId === null)
            throw new Error("The parameter 'ndtId' must be defined and cannot be null.");
        else
            url_ += "ndtId=" + encodeURIComponent("" + ndtId) + "&";
        if (afterSequenceId === undefined)
            throw new Error("The parameter 'afterSequenceId' must be defined.");
        else if(afterSequenceId !== null)
            url_ += "afterSequenceId=" + encodeURIComponent("" + afterSequenceId) + "&";
        if (recordLimit === undefined)
            throw new Error("The parameter 'recordLimit' must be defined.");
        else if(recordLimit !== null)
            url_ += "recordLimit=" + encodeURIComponent("" + recordLimit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTimings(_response));
        });
    }

    protected processGetTimings(response: Response): Promise<AMS360SetupsTimingModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AMS360SetupsTimingModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AMS360SetupsTimingModel[] | null>(null as any);
    }
}

export class ApiKeyClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUserKeys(userId: string): Promise<ApiKeyModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/apikey?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserKeys(_response));
        });
    }

    protected processGetUserKeys(response: Response): Promise<ApiKeyModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiKeyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiKeyModel[] | null>(null as any);
    }

    createUserKey(userId: string, name: string | null, lifetime: Date | null, currentUserId: string): Promise<ApiKeyModel | null> {
        let url_ = this.baseUrl + "/api/v1/apikey?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (name === undefined)
            throw new Error("The parameter 'name' must be defined.");
        else if(name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (lifetime === undefined)
            throw new Error("The parameter 'lifetime' must be defined.");
        else if(lifetime !== null)
            url_ += "lifetime=" + encodeURIComponent(lifetime ? "" + lifetime.toISOString() : "") + "&";
        if (currentUserId === undefined || currentUserId === null)
            throw new Error("The parameter 'currentUserId' must be defined and cannot be null.");
        else
            url_ += "currentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateUserKey(_response));
        });
    }

    protected processCreateUserKey(response: Response): Promise<ApiKeyModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ApiKeyModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiKeyModel | null>(null as any);
    }

    revokeUserKey(keyId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/apikey/revoke?";
        if (keyId === undefined || keyId === null)
            throw new Error("The parameter 'keyId' must be defined and cannot be null.");
        else
            url_ += "keyId=" + encodeURIComponent("" + keyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRevokeUserKey(_response));
        });
    }

    protected processRevokeUserKey(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ClientClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Promise<ConversionClientModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/Client";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ConversionClientModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionClientModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionClientModel[] | null>(null as any);
    }

    post(client: ConversionClientModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPost(_response));
        });
    }

    protected processPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDescription(): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/Client/GetDescription";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDescription(_response));
        });
    }

    protected processGetDescription(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    get(clientId: string): Promise<ConversionClientModel | null> {
        let url_ = this.baseUrl + "/api/v1/Client/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ConversionClientModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConversionClientModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionClientModel | null>(null as any);
    }

    put(clientId: string, client: ConversionClientModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Client/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ConversionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Promise<ConversionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/conversion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ConversionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionModel[] | null>(null as any);
    }

    post(conversion: ConversionModel | null | undefined): Promise<ConversionModel | null> {
        let url_ = this.baseUrl + "/api/v1/conversion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(conversion);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPost(_response));
        });
    }

    protected processPost(response: Response): Promise<ConversionModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConversionModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionModel | null>(null as any);
    }

    get(conversionId: string): Promise<ConversionModel | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/list/{conversionId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ConversionModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConversionModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionModel | null>(null as any);
    }

    delete(conversionId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/delete/{conversionId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    release(conversionId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/release/{conversionId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRelease(_response));
        });
    }

    protected processRelease(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    put(conversionId: string, conversion: ConversionModel | null | undefined): Promise<ConversionModel | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/new/{conversionId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(conversion);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<ConversionModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConversionModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionModel | null>(null as any);
    }

    listConversionsServers(): Promise<ConversionsServersListModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/server/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListConversionsServers(_response));
        });
    }

    protected processListConversionsServers(response: Response): Promise<ConversionsServersListModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionsServersListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionsServersListModel[] | null>(null as any);
    }

    getCheckConnection(environment: EnvironmentModel | null | undefined, email: string | null, connectiontype: string | null): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/conversion/conversion/check?";
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else if(email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (connectiontype === undefined)
            throw new Error("The parameter 'connectiontype' must be defined.");
        else if(connectiontype !== null)
            url_ += "connectiontype=" + encodeURIComponent("" + connectiontype) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(environment);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCheckConnection(_response));
        });
    }

    protected processGetCheckConnection(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCheckInternalConnection(environment: EnvironmentModel | null | undefined, connectiontype: string | null, type: string | null): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/conversion/conversion/internalCheck?";
        if (connectiontype === undefined)
            throw new Error("The parameter 'connectiontype' must be defined.");
        else if(connectiontype !== null)
            url_ += "connectiontype=" + encodeURIComponent("" + connectiontype) + "&";
        if (type === undefined)
            throw new Error("The parameter 'type' must be defined.");
        else if(type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(environment);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCheckInternalConnection(_response));
        });
    }

    protected processGetCheckInternalConnection(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCheckImagePath(imagePath: string | null, email: string | null): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/conversion/imagepath/check?";
        if (imagePath === undefined)
            throw new Error("The parameter 'imagePath' must be defined.");
        else if(imagePath !== null)
            url_ += "imagePath=" + encodeURIComponent("" + imagePath) + "&";
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else if(email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCheckImagePath(_response));
        });
    }

    protected processGetCheckImagePath(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    sendEmail(message: string | null, email: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/sendemail?";
        if (message === undefined)
            throw new Error("The parameter 'message' must be defined.");
        else if(message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else if(email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendEmail(_response));
        });
    }

    protected processSendEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getConnectionsAll(conversionId: string, connectionTypeId: number): Promise<EnvironmentModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/connections/{conversionId}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (connectionTypeId === undefined || connectionTypeId === null)
            throw new Error("The parameter 'connectionTypeId' must be defined and cannot be null.");
        else
            url_ += "connectionTypeId=" + encodeURIComponent("" + connectionTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConnectionsAll(_response));
        });
    }

    protected processGetConnectionsAll(response: Response): Promise<EnvironmentModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnvironmentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnvironmentModel[] | null>(null as any);
    }

    deleteConnection(conversionId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/delete/connections?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined and cannot be null.");
        else
            url_ += "conversionId=" + encodeURIComponent("" + conversionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteConnection(_response));
        });
    }

    protected processDeleteConnection(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    postConnection(connection: EnvironmentModel | null | undefined): Promise<EnvironmentModel | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/connections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(connection);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPostConnection(_response));
        });
    }

    protected processPostConnection(response: Response): Promise<EnvironmentModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EnvironmentModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnvironmentModel | null>(null as any);
    }

    putConnection(connectionId: string, connection: EnvironmentModel | null | undefined): Promise<EnvironmentModel | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/new/connections?";
        if (connectionId === undefined || connectionId === null)
            throw new Error("The parameter 'connectionId' must be defined and cannot be null.");
        else
            url_ += "connectionId=" + encodeURIComponent("" + connectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(connection);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPutConnection(_response));
        });
    }

    protected processPutConnection(response: Response): Promise<EnvironmentModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EnvironmentModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnvironmentModel | null>(null as any);
    }

    getUIController(): Promise<UIControllerModel | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/uicontroller";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUIController(_response));
        });
    }

    protected processGetUIController(response: Response): Promise<UIControllerModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UIControllerModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UIControllerModel | null>(null as any);
    }

    updateUIController(request: UIControllerModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/uicontrollerupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateUIController(_response));
        });
    }

    protected processUpdateUIController(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMergeTable(): Promise<MergeTableModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/mergetable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMergeTable(_response));
        });
    }

    protected processGetMergeTable(response: Response): Promise<MergeTableModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MergeTableModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergeTableModel[] | null>(null as any);
    }

    restartLoader(action: string | null): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/restartimageloader?";
        if (action === undefined)
            throw new Error("The parameter 'action' must be defined.");
        else if(action !== null)
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRestartLoader(_response));
        });
    }

    protected processRestartLoader(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    databaseReports(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/actions/databasereport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDatabaseReports(_response));
        });
    }

    protected processDatabaseReports(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    sendDatabaseReports(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/actions/senddatabasereport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendDatabaseReports(_response));
        });
    }

    protected processSendDatabaseReports(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    businessUnitValidate(environment: EnvironmentModel | null | undefined, type: string | null, values: string | null, table: string | null): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/conversion/businessunitvalidate?";
        if (type === undefined)
            throw new Error("The parameter 'type' must be defined.");
        else if(type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (values === undefined)
            throw new Error("The parameter 'values' must be defined.");
        else if(values !== null)
            url_ += "values=" + encodeURIComponent("" + values) + "&";
        if (table === undefined)
            throw new Error("The parameter 'table' must be defined.");
        else if(table !== null)
            url_ += "table=" + encodeURIComponent("" + table) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(environment);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBusinessUnitValidate(_response));
        });
    }

    protected processBusinessUnitValidate(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    businessUnitPolicyCount(environment: EnvironmentModel | null | undefined, type: string | null, agency: string | null, branch: string | null, department: string | null): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/conversion/businessunitpolicycount?";
        if (type === undefined)
            throw new Error("The parameter 'type' must be defined.");
        else if(type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (agency === undefined)
            throw new Error("The parameter 'agency' must be defined.");
        else if(agency !== null)
            url_ += "agency=" + encodeURIComponent("" + agency) + "&";
        if (branch === undefined)
            throw new Error("The parameter 'branch' must be defined.");
        else if(branch !== null)
            url_ += "branch=" + encodeURIComponent("" + branch) + "&";
        if (department === undefined)
            throw new Error("The parameter 'department' must be defined.");
        else if(department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(environment);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBusinessUnitPolicyCount(_response));
        });
    }

    protected processBusinessUnitPolicyCount(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    getProjectClassification(): Promise<ProjectClassificationModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/projectClassification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectClassification(_response));
        });
    }

    protected processGetProjectClassification(response: Response): Promise<ProjectClassificationModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectClassificationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectClassificationModel[] | null>(null as any);
    }

    postProjectClassification(client: ProjectClassificationModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/addProjectClassification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPostProjectClassification(_response));
        });
    }

    protected processPostProjectClassification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteProjectClassification(client: ProjectClassificationModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/deleteProjectClassification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteProjectClassification(_response));
        });
    }

    protected processDeleteProjectClassification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getConversions(): Promise<ConversionDisplayDto[] | null> {
        let url_ = this.baseUrl + "/api/v2/conversion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConversions(_response));
        });
    }

    protected processGetConversions(response: Response): Promise<ConversionDisplayDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionDisplayDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionDisplayDto[] | null>(null as any);
    }
}

export class ConversionOptionsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSchema(conversionId: string): Promise<ConversionOptionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/options/schema";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSchema(_response));
        });
    }

    protected processGetSchema(response: Response): Promise<ConversionOptionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionOptionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionOptionModel[] | null>(null as any);
    }

    getCustomizations(conversionId: string): Promise<OptionCustomizationModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/options/customizations";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomizations(_response));
        });
    }

    protected processGetCustomizations(response: Response): Promise<OptionCustomizationModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OptionCustomizationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionCustomizationModel[] | null>(null as any);
    }

    get(conversionId: string): Promise<ConversionOptionValueModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/options";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ConversionOptionValueModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionOptionValueModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionOptionValueModel[] | null>(null as any);
    }

    update(conversionId: string, values: ConversionOptionValueModel[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/options";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(values);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ConversionReportsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    run(conversionId: string, reportId: string, startDate: Date | null, endDate: Date | null): Promise<ConversionReportContentModel | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/reports/{reportId}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (startDate === undefined)
            throw new Error("The parameter 'startDate' must be defined.");
        else if(startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined)
            throw new Error("The parameter 'endDate' must be defined.");
        else if(endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRun(_response));
        });
    }

    protected processRun(response: Response): Promise<ConversionReportContentModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConversionReportContentModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionReportContentModel | null>(null as any);
    }

    exportToExcel(conversionId: string, reportId: string, startDate: Date | null, endDate: Date | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/reports/{reportId}/excel?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (startDate === undefined)
            throw new Error("The parameter 'startDate' must be defined.");
        else if(startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined)
            throw new Error("The parameter 'endDate' must be defined.");
        else if(endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportToExcel(_response));
        });
    }

    protected processExportToExcel(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ConversionTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Promise<ConversionTypeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/ConversionType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ConversionTypeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionTypeModel[] | null>(null as any);
    }

    updateConversionTypeActive(conversionTypeId: string, isActive: boolean): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ConversionType/activeToggle?";
        if (conversionTypeId === undefined || conversionTypeId === null)
            throw new Error("The parameter 'conversionTypeId' must be defined and cannot be null.");
        else
            url_ += "conversionTypeId=" + encodeURIComponent("" + conversionTypeId) + "&";
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined and cannot be null.");
        else
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateConversionTypeActive(_response));
        });
    }

    protected processUpdateConversionTypeActive(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ExecutionsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    listExecutions(conversionId: string): Promise<ExecutionsModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/executions/{conversionId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListExecutions(_response));
        });
    }

    protected processListExecutions(response: Response): Promise<ExecutionsModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExecutionsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExecutionsModel[] | null>(null as any);
    }

    listExecutionErrorDetail(conversionId: string, packageName: string | null): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/executions/{conversionId}/errordetails?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (packageName === undefined)
            throw new Error("The parameter 'packageName' must be defined.");
        else if(packageName !== null)
            url_ += "packageName=" + encodeURIComponent("" + packageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListExecutionErrorDetail(_response));
        });
    }

    protected processListExecutionErrorDetail(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    listExecutionsTierBoolean(conversionId: string): Promise<ExecutionsTierBooleanModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/executions/{conversionId}/tiers";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListExecutionsTierBoolean(_response));
        });
    }

    protected processListExecutionsTierBoolean(response: Response): Promise<ExecutionsTierBooleanModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExecutionsTierBooleanModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExecutionsTierBooleanModel[] | null>(null as any);
    }

    listExecutionsAllTierBoolean(conversionId: string): Promise<ExecutionsAllTierBooleanModel | null> {
        let url_ = this.baseUrl + "/api/v1/executions/{conversionId}/all";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListExecutionsAllTierBoolean(_response));
        });
    }

    protected processListExecutionsAllTierBoolean(response: Response): Promise<ExecutionsAllTierBooleanModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExecutionsAllTierBooleanModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExecutionsAllTierBooleanModel | null>(null as any);
    }

    listUpdatedExecutions(applicationId: string): Promise<ExecutionsModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/executions/{applicationId}/update";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListUpdatedExecutions(_response));
        });
    }

    protected processListUpdatedExecutions(response: Response): Promise<ExecutionsModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExecutionsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExecutionsModel[] | null>(null as any);
    }

    listDelayedExecutions(): Promise<ExecutionsModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/executions/delay";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListDelayedExecutions(_response));
        });
    }

    protected processListDelayedExecutions(response: Response): Promise<ExecutionsModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExecutionsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExecutionsModel[] | null>(null as any);
    }

    listExecutionMessages(executionsId: string): Promise<ExecutionMessagesModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/executions/messages/{executionsId}";
        if (executionsId === undefined || executionsId === null)
            throw new Error("The parameter 'executionsId' must be defined.");
        url_ = url_.replace("{executionsId}", encodeURIComponent("" + executionsId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListExecutionMessages(_response));
        });
    }

    protected processListExecutionMessages(response: Response): Promise<ExecutionMessagesModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExecutionMessagesModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExecutionMessagesModel[] | null>(null as any);
    }

    imageLoaderStatus(applicationId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/executions/{applicationId}/imageloader";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImageLoaderStatus(_response));
        });
    }

    protected processImageLoaderStatus(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    listRunningExecutions(): Promise<ExecutionsModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/executions/running";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListRunningExecutions(_response));
        });
    }

    protected processListRunningExecutions(response: Response): Promise<ExecutionsModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExecutionsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExecutionsModel[] | null>(null as any);
    }

    killRunningExecution(executionId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/executions/kill/{executionId}";
        if (executionId === undefined || executionId === null)
            throw new Error("The parameter 'executionId' must be defined.");
        url_ = url_.replace("{executionId}", encodeURIComponent("" + executionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKillRunningExecution(_response));
        });
    }

    protected processKillRunningExecution(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    listLoggingValues(): Promise<LoggingValuesModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/executions/loggingValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListLoggingValues(_response));
        });
    }

    protected processListLoggingValues(response: Response): Promise<LoggingValuesModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LoggingValuesModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoggingValuesModel[] | null>(null as any);
    }
}

export class FileUploadClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string): Promise<FileUploadModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/FileUpload";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<FileUploadModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileUploadModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileUploadModel[] | null>(null as any);
    }

    uploadImage(conversionId: string, fileUploadModel: FileUploadPostModel | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/FileUpload";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileUploadModel !== null && fileUploadModel !== undefined)
            content_.append("fileUploadModel", JSON.stringify(fileUploadModel));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadImage(_response));
        });
    }

    protected processUploadImage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getOne(fileUploadId: string): Promise<FileUploadModel | null> {
        let url_ = this.baseUrl + "/api/v1/FileUpload/{fileUploadId}";
        if (fileUploadId === undefined || fileUploadId === null)
            throw new Error("The parameter 'fileUploadId' must be defined.");
        url_ = url_.replace("{fileUploadId}", encodeURIComponent("" + fileUploadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOne(_response));
        });
    }

    protected processGetOne(response: Response): Promise<FileUploadModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileUploadModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileUploadModel | null>(null as any);
    }

    getBlob(fileUploadId: string): Promise<FileUploadBlobModel | null> {
        let url_ = this.baseUrl + "/api/v1/FileUpload/{fileUploadId}/blob";
        if (fileUploadId === undefined || fileUploadId === null)
            throw new Error("The parameter 'fileUploadId' must be defined.");
        url_ = url_.replace("{fileUploadId}", encodeURIComponent("" + fileUploadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBlob(_response));
        });
    }

    protected processGetBlob(response: Response): Promise<FileUploadBlobModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileUploadBlobModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileUploadBlobModel | null>(null as any);
    }

    getAllTypes(): Promise<FileUploadTypeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/FileUpload/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllTypes(_response));
        });
    }

    protected processGetAllTypes(response: Response): Promise<FileUploadTypeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileUploadTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileUploadTypeModel[] | null>(null as any);
    }

    getType(fileUploadTypeId: string): Promise<FileUploadTypeModel | null> {
        let url_ = this.baseUrl + "/api/v1/FileUpload/types/{fileUploadTypeId}";
        if (fileUploadTypeId === undefined || fileUploadTypeId === null)
            throw new Error("The parameter 'fileUploadTypeId' must be defined.");
        url_ = url_.replace("{fileUploadTypeId}", encodeURIComponent("" + fileUploadTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetType(_response));
        });
    }

    protected processGetType(response: Response): Promise<FileUploadTypeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileUploadTypeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileUploadTypeModel | null>(null as any);
    }
}

export class GenericClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    runAction(conversionId: string, userId: string, entity: string, actionName: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/{entity}/actions/{actionName}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        if (actionName === undefined || actionName === null)
            throw new Error("The parameter 'actionName' must be defined.");
        url_ = url_.replace("{actionName}", encodeURIComponent("" + actionName));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunAction(_response));
        });
    }

    protected processRunAction(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    migrateEntity(conversionId: string, userId: string, entity: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/{entity}/actions/extract?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMigrateEntity(_response));
        });
    }

    protected processMigrateEntity(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    runConversionRefreshAction(conversionId: string, userId: string, type: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/actions/refreshdata?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (type === undefined)
            throw new Error("The parameter 'type' must be defined.");
        else if(type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunConversionRefreshAction(_response));
        });
    }

    protected processRunConversionRefreshAction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    runMergeAction(conversionId: string, userId: string, type: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/actions/mergedata?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (type === undefined)
            throw new Error("The parameter 'type' must be defined.");
        else if(type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunMergeAction(_response));
        });
    }

    protected processRunMergeAction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    runUndoMigrationAction(conversionId: string, userId: string, tierId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/actions/undomigration?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tierId === undefined)
            throw new Error("The parameter 'tierId' must be defined.");
        else if(tierId !== null)
            url_ += "tierId=" + encodeURIComponent("" + tierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunUndoMigrationAction(_response));
        });
    }

    protected processRunUndoMigrationAction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    copyMappings(conversionId: string, userId: string, entity: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/{entity}/actions/copymappings?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCopyMappings(_response));
        });
    }

    protected processCopyMappings(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    clearMappings(conversionId: string, userId: string, entity: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/{entity}/actions/clearmappings?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClearMappings(_response));
        });
    }

    protected processClearMappings(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    runMigrateAllAction(conversionId: string, userId: string, tierId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/actions/migrateall?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tierId === undefined)
            throw new Error("The parameter 'tierId' must be defined.");
        else if(tierId !== null)
            url_ += "tierId=" + encodeURIComponent("" + tierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunMigrateAllAction(_response));
        });
    }

    protected processRunMigrateAllAction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    runMiniSubmitAction(conversionId: string, userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/actions/minisubmit?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunMiniSubmitAction(_response));
        });
    }

    protected processRunMiniSubmitAction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    runMiniValidationAction(conversionId: string, userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/actions/minivalidation?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunMiniValidationAction(_response));
        });
    }

    protected processRunMiniValidationAction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    listMiniConversionDelayedStart(conversionId: string): Promise<MiniConversionDelayedStartModel | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/miniConversionDelayedStart";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListMiniConversionDelayedStart(_response));
        });
    }

    protected processListMiniConversionDelayedStart(response: Response): Promise<MiniConversionDelayedStartModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MiniConversionDelayedStartModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MiniConversionDelayedStartModel | null>(null as any);
    }

    autoMappings(conversionId: string, userId: string, entity: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/actions/automap/{entity}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAutoMappings(_response));
        });
    }

    protected processAutoMappings(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSourceAll(conversionId: string, entity: string, columnTake: number | null, take: number | null, offset: number | null, filterColumns: string[] | null | undefined, sortColumn: string | null, sortDirection: SortDirection, filter: string | null): Promise<DynamicEntityListModel | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/source/{entity}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        if (columnTake === undefined)
            throw new Error("The parameter 'columnTake' must be defined.");
        else if(columnTake !== null)
            url_ += "columnTake=" + encodeURIComponent("" + columnTake) + "&";
        if (take === undefined)
            throw new Error("The parameter 'take' must be defined.");
        else if(take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (offset === undefined)
            throw new Error("The parameter 'offset' must be defined.");
        else if(offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (filterColumns !== undefined && filterColumns !== null)
            filterColumns && filterColumns.forEach(item => { url_ += "filterColumns=" + encodeURIComponent("" + item) + "&"; });
        if (sortColumn === undefined)
            throw new Error("The parameter 'sortColumn' must be defined.");
        else if(sortColumn !== null)
            url_ += "sort=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === undefined || sortDirection === null)
            throw new Error("The parameter 'sortDirection' must be defined and cannot be null.");
        else
            url_ += "direction=" + encodeURIComponent("" + sortDirection) + "&";
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSourceAll(_response));
        });
    }

    protected processGetSourceAll(response: Response): Promise<DynamicEntityListModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DynamicEntityListModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicEntityListModel | null>(null as any);
    }

    getStageAll(conversionId: string, entity: string, columnTake: number | null, take: number | null, offset: number | null, sortColumn: string | null, sortDirection: SortDirection, filter: string | null): Promise<DynamicEntityListModel | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/source/{entity}/stage?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        if (columnTake === undefined)
            throw new Error("The parameter 'columnTake' must be defined.");
        else if(columnTake !== null)
            url_ += "columnTake=" + encodeURIComponent("" + columnTake) + "&";
        if (take === undefined)
            throw new Error("The parameter 'take' must be defined.");
        else if(take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (offset === undefined)
            throw new Error("The parameter 'offset' must be defined.");
        else if(offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (sortColumn === undefined)
            throw new Error("The parameter 'sortColumn' must be defined.");
        else if(sortColumn !== null)
            url_ += "sort=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === undefined || sortDirection === null)
            throw new Error("The parameter 'sortDirection' must be defined and cannot be null.");
        else
            url_ += "direction=" + encodeURIComponent("" + sortDirection) + "&";
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStageAll(_response));
        });
    }

    protected processGetStageAll(response: Response): Promise<DynamicEntityListModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DynamicEntityListModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicEntityListModel | null>(null as any);
    }

    getMultipleSourceAll(conversionId: string, entity: string, table: number, columnTake: number | null, take: number | null, offset: number | null, sortColumn: string | null, sortDirection: SortDirection, filter: string | null): Promise<DynamicEntityListModel | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/source/{entity}/multiple?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        if (table === undefined || table === null)
            throw new Error("The parameter 'table' must be defined and cannot be null.");
        else
            url_ += "table=" + encodeURIComponent("" + table) + "&";
        if (columnTake === undefined)
            throw new Error("The parameter 'columnTake' must be defined.");
        else if(columnTake !== null)
            url_ += "columnTake=" + encodeURIComponent("" + columnTake) + "&";
        if (take === undefined)
            throw new Error("The parameter 'take' must be defined.");
        else if(take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (offset === undefined)
            throw new Error("The parameter 'offset' must be defined.");
        else if(offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (sortColumn === undefined)
            throw new Error("The parameter 'sortColumn' must be defined.");
        else if(sortColumn !== null)
            url_ += "sort=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === undefined || sortDirection === null)
            throw new Error("The parameter 'sortDirection' must be defined and cannot be null.");
        else
            url_ += "direction=" + encodeURIComponent("" + sortDirection) + "&";
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMultipleSourceAll(_response));
        });
    }

    protected processGetMultipleSourceAll(response: Response): Promise<DynamicEntityListModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DynamicEntityListModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicEntityListModel | null>(null as any);
    }

    getTargetAll(conversionId: string, entity: string, columnTake: number | null, take: number | null, offset: number | null, sortColumn: string | null, sortDirection: SortDirection, filter: string | null): Promise<DynamicEntityListModel | null> {
        let url_ = this.baseUrl + "/api/v1/conversion/{conversionId}/target/{entity}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        if (columnTake === undefined)
            throw new Error("The parameter 'columnTake' must be defined.");
        else if(columnTake !== null)
            url_ += "columnTake=" + encodeURIComponent("" + columnTake) + "&";
        if (take === undefined)
            throw new Error("The parameter 'take' must be defined.");
        else if(take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (offset === undefined)
            throw new Error("The parameter 'offset' must be defined.");
        else if(offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (sortColumn === undefined)
            throw new Error("The parameter 'sortColumn' must be defined.");
        else if(sortColumn !== null)
            url_ += "sort=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === undefined || sortDirection === null)
            throw new Error("The parameter 'sortDirection' must be defined and cannot be null.");
        else
            url_ += "direction=" + encodeURIComponent("" + sortDirection) + "&";
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTargetAll(_response));
        });
    }

    protected processGetTargetAll(response: Response): Promise<DynamicEntityListModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DynamicEntityListModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicEntityListModel | null>(null as any);
    }
}

export class MergeMapClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(conversionId: string, entity: string | null): Promise<MergeMapModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined)
            throw new Error("The parameter 'entity' must be defined.");
        else if(entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<MergeMapModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MergeMapModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergeMapModel[] | null>(null as any);
    }

    getEntity(conversionId: string, id: string, entity: string | null): Promise<MergeMapModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap/entity/{id}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entity === undefined)
            throw new Error("The parameter 'entity' must be defined.");
        else if(entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEntity(_response));
        });
    }

    protected processGetEntity(response: Response): Promise<MergeMapModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MergeMapModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergeMapModel[] | null>(null as any);
    }

    getRef(conversionId: string, entity: string | null): Promise<MergeMapRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap/ref?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined)
            throw new Error("The parameter 'entity' must be defined.");
        else if(entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<MergeMapRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MergeMapRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergeMapRefModel[] | null>(null as any);
    }

    put(conversionId: string, conversionTypeId: string, mergeMapId: string, mergeMap: MergeMapModel | null | undefined, entity: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap/{mergeMapId}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (mergeMapId === undefined || mergeMapId === null)
            throw new Error("The parameter 'mergeMapId' must be defined.");
        url_ = url_.replace("{mergeMapId}", encodeURIComponent("" + mergeMapId));
        if (conversionTypeId === undefined || conversionTypeId === null)
            throw new Error("The parameter 'conversionTypeId' must be defined and cannot be null.");
        else
            url_ += "conversionTypeId=" + encodeURIComponent("" + conversionTypeId) + "&";
        if (entity === undefined)
            throw new Error("The parameter 'entity' must be defined.");
        else if(entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mergeMap);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getStageTables(type: string | null, conversionId: string): Promise<StageTablesModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap/stageTables?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (type === undefined)
            throw new Error("The parameter 'type' must be defined.");
        else if(type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStageTables(_response));
        });
    }

    protected processGetStageTables(response: Response): Promise<StageTablesModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StageTablesModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StageTablesModel[] | null>(null as any);
    }

    mergeMapLog(conversionId: string): Promise<MergeMapLogModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap/mergemaplog";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMergeMapLog(_response));
        });
    }

    protected processMergeMapLog(response: Response): Promise<MergeMapLogModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MergeMapLogModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergeMapLogModel[] | null>(null as any);
    }

    getByCode(conversionId: string, entity: string | null, code: string): Promise<MergeMapModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap/{code}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        if (entity === undefined)
            throw new Error("The parameter 'entity' must be defined.");
        else if(entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByCode(_response));
        });
    }

    protected processGetByCode(response: Response): Promise<MergeMapModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MergeMapModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergeMapModel[] | null>(null as any);
    }

    putPrimary(conversionId: string, mergeMapId: string, entity: string | null, code: string, count: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap/primary/{code}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        if (mergeMapId === undefined || mergeMapId === null)
            throw new Error("The parameter 'mergeMapId' must be defined and cannot be null.");
        else
            url_ += "mergeMapId=" + encodeURIComponent("" + mergeMapId) + "&";
        if (entity === undefined)
            throw new Error("The parameter 'entity' must be defined.");
        else if(entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        if (count === undefined || count === null)
            throw new Error("The parameter 'count' must be defined and cannot be null.");
        else
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPutPrimary(_response));
        });
    }

    protected processPutPrimary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLogTimings(conversionId: string): Promise<TimingsModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap/timings";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLogTimings(_response));
        });
    }

    protected processGetLogTimings(response: Response): Promise<TimingsModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimingsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimingsModel[] | null>(null as any);
    }

    getLogTimeActions(type: string | null, conversionId: string): Promise<TimingsModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap/timeactions?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (type === undefined)
            throw new Error("The parameter 'type' must be defined.");
        else if(type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLogTimeActions(_response));
        });
    }

    protected processGetLogTimeActions(response: Response): Promise<TimingsModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimingsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimingsModel[] | null>(null as any);
    }

    clearBusinessUnits(conversionId: string, shortName: string, entity: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap/clearbu/{shortName}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (shortName === undefined || shortName === null)
            throw new Error("The parameter 'shortName' must be defined.");
        url_ = url_.replace("{shortName}", encodeURIComponent("" + shortName));
        if (entity === undefined)
            throw new Error("The parameter 'entity' must be defined.");
        else if(entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClearBusinessUnits(_response));
        });
    }

    protected processClearBusinessUnits(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    mergeLock(conversionId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap/mergeLock";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMergeLock(_response));
        });
    }

    protected processMergeLock(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCurrentMergeRun(conversionId: string): Promise<CurrentMergeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap/currentMerge";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCurrentMergeRun(_response));
        });
    }

    protected processGetCurrentMergeRun(response: Response): Promise<CurrentMergeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentMergeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrentMergeModel | null>(null as any);
    }

    getMostRecentPackage(conversionId: string): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/MergeMap/mostRecentPackage";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMostRecentPackage(_response));
        });
    }

    protected processGetMostRecentPackage(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }
}

export class ActionTypesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null, type: string | null): Promise<ActionTypeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ActionTypes?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (type === undefined)
            throw new Error("The parameter 'type' must be defined.");
        else if(type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ActionTypeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActionTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionTypeModel[] | null>(null as any);
    }

    put(conversionId: string, actiontypesId: number, actionTypes: ActionTypeModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ActionTypes/{actiontypesId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (actiontypesId === undefined || actiontypesId === null)
            throw new Error("The parameter 'actiontypesId' must be defined.");
        url_ = url_.replace("{actiontypesId}", encodeURIComponent("" + actiontypesId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(actionTypes);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<ActionTypeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ActionTypes/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<ActionTypeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActionTypeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionTypeRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: number): Promise<ActionTypeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ActionTypes/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ActionTypeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ActionTypeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionTypeModel | null>(null as any);
    }
}

export class ActivitiesMiniConversionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string): Promise<ActivitiesMiniConversionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ActivitiesMiniConversion";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ActivitiesMiniConversionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivitiesMiniConversionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivitiesMiniConversionModel[] | null>(null as any);
    }
}

export class ActivitiesMiniConversionCountClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCount(conversionId: string): Promise<ActivitiesMiniConversionCountModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ActivitiesMiniConversionCount";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCount(_response));
        });
    }

    protected processGetCount(response: Response): Promise<ActivitiesMiniConversionCountModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivitiesMiniConversionCountModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivitiesMiniConversionCountModel[] | null>(null as any);
    }
}

export class ActivitiesMiniConversionValidationResultsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getResults(conversionId: string): Promise<ActivitiesMiniConversionValidationResultsModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ActivitiesMiniConversionValidationResults";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetResults(_response));
        });
    }

    protected processGetResults(response: Response): Promise<ActivitiesMiniConversionValidationResultsModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivitiesMiniConversionValidationResultsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivitiesMiniConversionValidationResultsModel[] | null>(null as any);
    }
}

export class BranchClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<BranchModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Branch?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<BranchModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchModel[] | null>(null as any);
    }

    getByDestinationCode(conversionId: string, destinationCode: string): Promise<BranchModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Branch/destinationCode/{destinationCode}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (destinationCode === undefined || destinationCode === null)
            throw new Error("The parameter 'destinationCode' must be defined.");
        url_ = url_.replace("{destinationCode}", encodeURIComponent("" + destinationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByDestinationCode(_response));
        });
    }

    protected processGetByDestinationCode(response: Response): Promise<BranchModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchModel[] | null>(null as any);
    }

    put(conversionId: string, branchId: string, branch: BranchModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Branch/{branchId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(branch);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updatePrimary(conversionId: string, destinationCode: string | null, branchId: string, rows: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Branch/destinationCode/{branchId}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (destinationCode === undefined)
            throw new Error("The parameter 'destinationCode' must be defined.");
        else if(destinationCode !== null)
            url_ += "destinationCode=" + encodeURIComponent("" + destinationCode) + "&";
        if (rows === undefined || rows === null)
            throw new Error("The parameter 'rows' must be defined and cannot be null.");
        else
            url_ += "rows=" + encodeURIComponent("" + rows) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePrimary(_response));
        });
    }

    protected processUpdatePrimary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<BranchRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Branch/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<BranchRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<BranchModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Branch/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<BranchModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BranchModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchModel | null>(null as any);
    }
}

export class BrokerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<BrokerModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Broker?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<BrokerModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrokerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerModel[] | null>(null as any);
    }

    getByDestinationCode(conversionId: string, destinationCode: string): Promise<BrokerModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Broker/destinationCode/{destinationCode}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (destinationCode === undefined || destinationCode === null)
            throw new Error("The parameter 'destinationCode' must be defined.");
        url_ = url_.replace("{destinationCode}", encodeURIComponent("" + destinationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByDestinationCode(_response));
        });
    }

    protected processGetByDestinationCode(response: Response): Promise<BrokerModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrokerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerModel[] | null>(null as any);
    }

    put(conversionId: string, brokerId: string, broker: BrokerModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Broker/{brokerId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (brokerId === undefined || brokerId === null)
            throw new Error("The parameter 'brokerId' must be defined.");
        url_ = url_.replace("{brokerId}", encodeURIComponent("" + brokerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(broker);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<BrokerRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Broker/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<BrokerRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrokerRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerRefModel[] | null>(null as any);
    }

    updatePrimary(conversionId: string, destinationCode: string | null, brokerId: string, rows: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Broker/destinationCode/{brokerId}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (brokerId === undefined || brokerId === null)
            throw new Error("The parameter 'brokerId' must be defined.");
        url_ = url_.replace("{brokerId}", encodeURIComponent("" + brokerId));
        if (destinationCode === undefined)
            throw new Error("The parameter 'destinationCode' must be defined.");
        else if(destinationCode !== null)
            url_ += "destinationCode=" + encodeURIComponent("" + destinationCode) + "&";
        if (rows === undefined || rows === null)
            throw new Error("The parameter 'rows' must be defined and cannot be null.");
        else
            url_ += "rows=" + encodeURIComponent("" + rows) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePrimary(_response));
        });
    }

    protected processUpdatePrimary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    get(conversionId: string, id: string): Promise<BrokerModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Broker/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<BrokerModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BrokerModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerModel | null>(null as any);
    }
}

export class ClaimTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<ClaimTypeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ClaimType?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ClaimTypeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClaimTypeModel[] | null>(null as any);
    }

    put(conversionId: string, claimTypeId: number, claimType: ClaimTypeModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ClaimType/{claimTypeId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (claimTypeId === undefined || claimTypeId === null)
            throw new Error("The parameter 'claimTypeId' must be defined.");
        url_ = url_.replace("{claimTypeId}", encodeURIComponent("" + claimTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(claimType);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<ClaimTypeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ClaimType/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<ClaimTypeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimTypeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClaimTypeRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: number): Promise<ClaimTypeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ClaimType/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ClaimTypeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ClaimTypeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClaimTypeModel | null>(null as any);
    }
}

export class ClientMergeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string): Promise<ClientMergeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ClientMerge";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ClientMergeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientMergeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientMergeModel[] | null>(null as any);
    }
}

export class CompanyClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<CompanyModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Company?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CompanyModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyModel[] | null>(null as any);
    }

    getAllByDestinationCode(conversionId: string, destinationCode: string, type: string, typeId: number): Promise<CompanyModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Company/destinationCode/{type}/{destinationCode}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (destinationCode === undefined || destinationCode === null)
            throw new Error("The parameter 'destinationCode' must be defined.");
        url_ = url_.replace("{destinationCode}", encodeURIComponent("" + destinationCode));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (typeId === undefined || typeId === null)
            throw new Error("The parameter 'typeId' must be defined and cannot be null.");
        else
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllByDestinationCode(_response));
        });
    }

    protected processGetAllByDestinationCode(response: Response): Promise<CompanyModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyModel[] | null>(null as any);
    }

    getAllRefs(conversionId: string): Promise<CompanyRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Company/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllRefs(_response));
        });
    }

    protected processGetAllRefs(response: Response): Promise<CompanyRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyRefModel[] | null>(null as any);
    }

    getAllTypeRefs(conversionId: string): Promise<CompanyTypeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Company/ref/type";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllTypeRefs(_response));
        });
    }

    protected processGetAllTypeRefs(response: Response): Promise<CompanyTypeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyTypeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyTypeRefModel[] | null>(null as any);
    }

    put(conversionId: string, companyId: number, company: CompanyModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Company/{companyId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(company);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    get(conversionId: string, id: number): Promise<CompanyModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Company/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<CompanyModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompanyModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyModel | null>(null as any);
    }

    updatePrimary(conversionId: string, destinationCode: string | null, companyId: number, typeId: number, rows: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Company/destinationCode/isPrimary?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (destinationCode === undefined)
            throw new Error("The parameter 'destinationCode' must be defined.");
        else if(destinationCode !== null)
            url_ += "destinationCode=" + encodeURIComponent("" + destinationCode) + "&";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined and cannot be null.");
        else
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (typeId === undefined || typeId === null)
            throw new Error("The parameter 'typeId' must be defined and cannot be null.");
        else
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        if (rows === undefined || rows === null)
            throw new Error("The parameter 'rows' must be defined and cannot be null.");
        else
            url_ += "rows=" + encodeURIComponent("" + rows) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePrimary(_response));
        });
    }

    protected processUpdatePrimary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateParentPrimary(conversionId: string, parentDestinationCode: string | null, parentSourceCode: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Company/parentDestinationCode/isPrimary?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (parentDestinationCode === undefined)
            throw new Error("The parameter 'parentDestinationCode' must be defined.");
        else if(parentDestinationCode !== null)
            url_ += "parentDestinationCode=" + encodeURIComponent("" + parentDestinationCode) + "&";
        if (parentSourceCode === undefined)
            throw new Error("The parameter 'parentSourceCode' must be defined.");
        else if(parentSourceCode !== null)
            url_ += "parentSourceCode=" + encodeURIComponent("" + parentSourceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateParentPrimary(_response));
        });
    }

    protected processUpdateParentPrimary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    companyUnique(conversionId: string, shortName: string | null, sourceCode: string | null, sourceName: string | null, type: string): Promise<UniqueModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Company/companyUnique/{type}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (shortName === undefined)
            throw new Error("The parameter 'shortName' must be defined.");
        else if(shortName !== null)
            url_ += "shortName=" + encodeURIComponent("" + shortName) + "&";
        if (sourceCode === undefined)
            throw new Error("The parameter 'sourceCode' must be defined.");
        else if(sourceCode !== null)
            url_ += "sourceCode=" + encodeURIComponent("" + sourceCode) + "&";
        if (sourceName === undefined)
            throw new Error("The parameter 'sourceName' must be defined.");
        else if(sourceName !== null)
            url_ += "sourceName=" + encodeURIComponent("" + sourceName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCompanyUnique(_response));
        });
    }

    protected processCompanyUnique(response: Response): Promise<UniqueModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UniqueModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UniqueModel[] | null>(null as any);
    }

    getCompanies(conversionId: string): Promise<CompanyMapDto[] | null> {
        let url_ = this.baseUrl + "/api/v2/conversion/{conversionId}/Company/map";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCompanies(_response));
        });
    }

    protected processGetCompanies(response: Response): Promise<CompanyMapDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyMapDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyMapDto[] | null>(null as any);
    }

    putCompanies(conversionId: string, companyUpdate: CompanyUpdateMapDto | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/conversion/{conversionId}/Company/map";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(companyUpdate);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPutCompanies(_response));
        });
    }

    protected processPutCompanies(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<CompanyRefDto[] | null> {
        let url_ = this.baseUrl + "/api/v2/conversion/{conversionId}/Company/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<CompanyRefDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyRefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyRefDto[] | null>(null as any);
    }
}

export class ContactsMiniConversionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string): Promise<ContactsMiniConversionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ContactsMiniConversion";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ContactsMiniConversionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactsMiniConversionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactsMiniConversionModel[] | null>(null as any);
    }
}

export class ContactsMiniConversionCountClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCount(conversionId: string): Promise<ContactsMiniConversionCountModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ContactsMiniConversionCount";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCount(_response));
        });
    }

    protected processGetCount(response: Response): Promise<ContactsMiniConversionCountModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactsMiniConversionCountModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactsMiniConversionCountModel[] | null>(null as any);
    }
}

export class ContactsMiniConversionValidationResultsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getResults(conversionId: string): Promise<ContactsMiniConversionValidationResultsModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ContactsMiniConversionValidationResults";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetResults(_response));
        });
    }

    protected processGetResults(response: Response): Promise<ContactsMiniConversionValidationResultsModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactsMiniConversionValidationResultsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactsMiniConversionValidationResultsModel[] | null>(null as any);
    }
}

export class CustomerAcquisitionCodeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string): Promise<CustomerAcquisitionCodeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/CustomerAcquisitionCode";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CustomerAcquisitionCodeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAcquisitionCodeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerAcquisitionCodeModel[] | null>(null as any);
    }
}

export class CustomersMiniConversionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string): Promise<CustomersMiniConversionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/CustomersMiniConversion";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CustomersMiniConversionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomersMiniConversionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomersMiniConversionModel[] | null>(null as any);
    }
}

export class CustomersMiniConversionCountClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCount(conversionId: string): Promise<CustomersMiniConversionCountModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/CustomersMiniConversionCount";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCount(_response));
        });
    }

    protected processGetCount(response: Response): Promise<CustomersMiniConversionCountModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomersMiniConversionCountModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomersMiniConversionCountModel[] | null>(null as any);
    }
}

export class CustomersMiniConversionValidationResultsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getResults(conversionId: string): Promise<CustomersMiniConversionValidationResultsModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/CustomersMiniConversionValidationResults";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetResults(_response));
        });
    }

    protected processGetResults(response: Response): Promise<CustomersMiniConversionValidationResultsModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomersMiniConversionValidationResultsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomersMiniConversionValidationResultsModel[] | null>(null as any);
    }
}

export class DepartmentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<DepartmentModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Department?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<DepartmentModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentModel[] | null>(null as any);
    }

    getByDestinationCode(conversionId: string, destinationCode: string): Promise<DepartmentModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Department/destinationCode/{destinationCode}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (destinationCode === undefined || destinationCode === null)
            throw new Error("The parameter 'destinationCode' must be defined.");
        url_ = url_.replace("{destinationCode}", encodeURIComponent("" + destinationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByDestinationCode(_response));
        });
    }

    protected processGetByDestinationCode(response: Response): Promise<DepartmentModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentModel[] | null>(null as any);
    }

    put(conversionId: string, departmentId: string, department: DepartmentModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Department/{departmentId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (departmentId === undefined || departmentId === null)
            throw new Error("The parameter 'departmentId' must be defined.");
        url_ = url_.replace("{departmentId}", encodeURIComponent("" + departmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(department);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updatePrimary(conversionId: string, destinationCode: string | null, departmentId: string, rows: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Department/destinationCode/{departmentId}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (departmentId === undefined || departmentId === null)
            throw new Error("The parameter 'departmentId' must be defined.");
        url_ = url_.replace("{departmentId}", encodeURIComponent("" + departmentId));
        if (destinationCode === undefined)
            throw new Error("The parameter 'destinationCode' must be defined.");
        else if(destinationCode !== null)
            url_ += "destinationCode=" + encodeURIComponent("" + destinationCode) + "&";
        if (rows === undefined || rows === null)
            throw new Error("The parameter 'rows' must be defined and cannot be null.");
        else
            url_ += "rows=" + encodeURIComponent("" + rows) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePrimary(_response));
        });
    }

    protected processUpdatePrimary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<DepartmentRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Department/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<DepartmentRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<DepartmentModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Department/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<DepartmentModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DepartmentModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentModel | null>(null as any);
    }
}

export class DivisionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<DivisionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Division?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<DivisionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DivisionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DivisionModel[] | null>(null as any);
    }

    getByDestinationCode(conversionId: string, destinationCode: string): Promise<DivisionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Division/destinationCode/{destinationCode}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (destinationCode === undefined || destinationCode === null)
            throw new Error("The parameter 'destinationCode' must be defined.");
        url_ = url_.replace("{destinationCode}", encodeURIComponent("" + destinationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByDestinationCode(_response));
        });
    }

    protected processGetByDestinationCode(response: Response): Promise<DivisionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DivisionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DivisionModel[] | null>(null as any);
    }

    put(conversionId: string, divisionId: string, division: DivisionModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Division/{divisionId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (divisionId === undefined || divisionId === null)
            throw new Error("The parameter 'divisionId' must be defined.");
        url_ = url_.replace("{divisionId}", encodeURIComponent("" + divisionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(division);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updatePrimary(conversionId: string, destinationCode: string | null, divisionId: string, rows: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Division/destinationCode/{divisionId}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (divisionId === undefined || divisionId === null)
            throw new Error("The parameter 'divisionId' must be defined.");
        url_ = url_.replace("{divisionId}", encodeURIComponent("" + divisionId));
        if (destinationCode === undefined)
            throw new Error("The parameter 'destinationCode' must be defined.");
        else if(destinationCode !== null)
            url_ += "destinationCode=" + encodeURIComponent("" + destinationCode) + "&";
        if (rows === undefined || rows === null)
            throw new Error("The parameter 'rows' must be defined and cannot be null.");
        else
            url_ += "rows=" + encodeURIComponent("" + rows) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePrimary(_response));
        });
    }

    protected processUpdatePrimary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<DivisionRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Division/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<DivisionRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DivisionRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DivisionRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<DivisionModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Division/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<DivisionModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DivisionModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DivisionModel | null>(null as any);
    }
}

export class EmployeeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<EmployeeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Employee?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<EmployeeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeModel[] | null>(null as any);
    }

    get(conversionId: string, employeeId: number): Promise<EmployeeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Employee/{employeeId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<EmployeeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EmployeeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeModel | null>(null as any);
    }

    put(conversionId: string, employeeId: number, employee: EmployeeModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Employee/{employeeId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employee);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getByDestinationCode(conversionId: string, destinationCode: string): Promise<EmployeeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Employee/destinationCode/{destinationCode}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (destinationCode === undefined || destinationCode === null)
            throw new Error("The parameter 'destinationCode' must be defined.");
        url_ = url_.replace("{destinationCode}", encodeURIComponent("" + destinationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByDestinationCode(_response));
        });
    }

    protected processGetByDestinationCode(response: Response): Promise<EmployeeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeModel[] | null>(null as any);
    }

    updatePrimary(conversionId: string, destinationCode: string | null, employeeId: number, rows: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Employee/destinationCode/{employeeId}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (destinationCode === undefined)
            throw new Error("The parameter 'destinationCode' must be defined.");
        else if(destinationCode !== null)
            url_ += "destinationCode=" + encodeURIComponent("" + destinationCode) + "&";
        if (rows === undefined || rows === null)
            throw new Error("The parameter 'rows' must be defined and cannot be null.");
        else
            url_ += "rows=" + encodeURIComponent("" + rows) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePrimary(_response));
        });
    }

    protected processUpdatePrimary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<EmployeeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Employee/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<EmployeeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeRefModel[] | null>(null as any);
    }
}

export class EmployeeTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<EmployeeTypeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/EmployeeType?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<EmployeeTypeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeTypeModel[] | null>(null as any);
    }

    get(conversionId: string, employeeTypeId: string): Promise<EmployeeTypeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/EmployeeType/{employeeTypeId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (employeeTypeId === undefined || employeeTypeId === null)
            throw new Error("The parameter 'employeeTypeId' must be defined.");
        url_ = url_.replace("{employeeTypeId}", encodeURIComponent("" + employeeTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<EmployeeTypeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EmployeeTypeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeTypeModel | null>(null as any);
    }

    put(conversionId: string, employeeTypeId: string, employeeType: EmployeeTypeModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/EmployeeType/{employeeTypeId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (employeeTypeId === undefined || employeeTypeId === null)
            throw new Error("The parameter 'employeeTypeId' must be defined.");
        url_ = url_.replace("{employeeTypeId}", encodeURIComponent("" + employeeTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeType);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<EmployeeTypeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/EmployeeType/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<EmployeeTypeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeTypeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeTypeRefModel[] | null>(null as any);
    }
}

export class GroupClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<GroupModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Group?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<GroupModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupModel[] | null>(null as any);
    }

    getByDestinationCode(conversionId: string, destinationCode: string): Promise<GroupModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Group/destinationCode/{destinationCode}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (destinationCode === undefined || destinationCode === null)
            throw new Error("The parameter 'destinationCode' must be defined.");
        url_ = url_.replace("{destinationCode}", encodeURIComponent("" + destinationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByDestinationCode(_response));
        });
    }

    protected processGetByDestinationCode(response: Response): Promise<GroupModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupModel[] | null>(null as any);
    }

    put(conversionId: string, groupId: string, group: GroupModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Group/{groupId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(group);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updatePrimary(conversionId: string, destinationCode: string | null, groupId: string, rows: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Group/destinationCode/{groupId}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (destinationCode === undefined)
            throw new Error("The parameter 'destinationCode' must be defined.");
        else if(destinationCode !== null)
            url_ += "destinationCode=" + encodeURIComponent("" + destinationCode) + "&";
        if (rows === undefined || rows === null)
            throw new Error("The parameter 'rows' must be defined and cannot be null.");
        else
            url_ += "rows=" + encodeURIComponent("" + rows) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePrimary(_response));
        });
    }

    protected processUpdatePrimary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<GroupRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Group/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<GroupRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<GroupModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Group/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<GroupModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GroupModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupModel | null>(null as any);
    }
}

export class ImageQueueClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(numberOfRecordsToReturn: number | undefined, conversionId: string): Promise<QueueRecord[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ImageQueue";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(numberOfRecordsToReturn);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<QueueRecord[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QueueRecord.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueueRecord[] | null>(null as any);
    }

    put(conversionId: string, id: number, updateImageQueueRequest: UpdateImageQueueRequest | null | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ImageQueue/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateImageQueueRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    imageQueue(conversionId: string): Promise<ImageQueueModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ImageQueue/queue";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImageQueue(_response));
        });
    }

    protected processImageQueue(response: Response): Promise<ImageQueueModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImageQueueModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageQueueModel | null>(null as any);
    }

    imageLog(conversionId: string): Promise<ImageLogModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/ImageQueue/log";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImageLog(_response));
        });
    }

    protected processImageLog(response: Response): Promise<ImageLogModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageLogModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageLogModel[] | null>(null as any);
    }
}

export class KindOfLossClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<KindOfLossModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/KindOfLoss?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<KindOfLossModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KindOfLossModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KindOfLossModel[] | null>(null as any);
    }

    put(conversionId: string, kindoflossId: number, kindOfLoss: KindOfLossModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/KindOfLoss/{kindoflossId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (kindoflossId === undefined || kindoflossId === null)
            throw new Error("The parameter 'kindoflossId' must be defined.");
        url_ = url_.replace("{kindoflossId}", encodeURIComponent("" + kindoflossId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(kindOfLoss);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<KindOfLossRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/KindOfLoss/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<KindOfLossRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KindOfLossRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KindOfLossRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: number): Promise<KindOfLossModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/KindOfLoss/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<KindOfLossModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? KindOfLossModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KindOfLossModel | null>(null as any);
    }
}

export class LineOfBusinessClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<LineOfBusinessModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/LineOfBusiness?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<LineOfBusinessModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LineOfBusinessModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LineOfBusinessModel[] | null>(null as any);
    }

    put(conversionId: string, lineOfBusinessId: string, lineOfBusiness: LineOfBusinessModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/LineOfBusiness/{lineOfBusinessId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (lineOfBusinessId === undefined || lineOfBusinessId === null)
            throw new Error("The parameter 'lineOfBusinessId' must be defined.");
        url_ = url_.replace("{lineOfBusinessId}", encodeURIComponent("" + lineOfBusinessId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lineOfBusiness);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<LineOfBusinessRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/LineOfBusiness/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<LineOfBusinessRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LineOfBusinessRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LineOfBusinessRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<LineOfBusinessModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/LineOfBusiness/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<LineOfBusinessModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LineOfBusinessModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LineOfBusinessModel | null>(null as any);
    }
}

export class PoliciesMiniConversionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string): Promise<PoliciesMiniConversionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PoliciesMiniConversion";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PoliciesMiniConversionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PoliciesMiniConversionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PoliciesMiniConversionModel[] | null>(null as any);
    }
}

export class PoliciesMiniConversionCountClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCount(conversionId: string): Promise<PoliciesMiniConversionCountModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PoliciesMiniConversionCount";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCount(_response));
        });
    }

    protected processGetCount(response: Response): Promise<PoliciesMiniConversionCountModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PoliciesMiniConversionCountModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PoliciesMiniConversionCountModel[] | null>(null as any);
    }
}

export class PoliciesMiniConversionValidationResultsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getResults(conversionId: string): Promise<PoliciesMiniConversionValidationResultsModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PoliciesMiniConversionValidationResults";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetResults(_response));
        });
    }

    protected processGetResults(response: Response): Promise<PoliciesMiniConversionValidationResultsModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PoliciesMiniConversionValidationResultsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PoliciesMiniConversionValidationResultsModel[] | null>(null as any);
    }
}

export class PolicyDetailsCommercialPropertyCauseOfLossClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<PolicyDetailsCommercialPropertyCauseOfLossModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsCommercialPropertyCauseOfLoss?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PolicyDetailsCommercialPropertyCauseOfLossModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsCommercialPropertyCauseOfLossModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsCommercialPropertyCauseOfLossModel[] | null>(null as any);
    }

    put(conversionId: string, causeOfLoss: PolicyDetailsCommercialPropertyCauseOfLossModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsCommercialPropertyCauseOfLoss/CauseOfLossPut";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(causeOfLoss);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<PolicyDetailsCommercialPropertyCauseOfLossRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsCommercialPropertyCauseOfLoss/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<PolicyDetailsCommercialPropertyCauseOfLossRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsCommercialPropertyCauseOfLossRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsCommercialPropertyCauseOfLossRefModel[] | null>(null as any);
    }
}

export class PolicyDetailsDwellingFireCoverageCodeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<PolicyDetailsDwellingFireCoverageCodeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsDwellingFireCoverageCode?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PolicyDetailsDwellingFireCoverageCodeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsDwellingFireCoverageCodeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsDwellingFireCoverageCodeModel[] | null>(null as any);
    }

    put(conversionId: string, policyDetailsDwellingFireCoverageCodeId: string, policyDetailsDwellingFireCoverageCode: PolicyDetailsDwellingFireCoverageCodeModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsDwellingFireCoverageCode/{policyDetailsDwellingFireCoverageCodeId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (policyDetailsDwellingFireCoverageCodeId === undefined || policyDetailsDwellingFireCoverageCodeId === null)
            throw new Error("The parameter 'policyDetailsDwellingFireCoverageCodeId' must be defined.");
        url_ = url_.replace("{policyDetailsDwellingFireCoverageCodeId}", encodeURIComponent("" + policyDetailsDwellingFireCoverageCodeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policyDetailsDwellingFireCoverageCode);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllRefs(conversionId: string): Promise<PolicyDetailsDwellingFireCoverageCodeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsDwellingFireCoverageCode/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllRefs(_response));
        });
    }

    protected processGetAllRefs(response: Response): Promise<PolicyDetailsDwellingFireCoverageCodeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsDwellingFireCoverageCodeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsDwellingFireCoverageCodeRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<PolicyDetailsDwellingFireCoverageCodeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsDwellingFireCoverageCode/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PolicyDetailsDwellingFireCoverageCodeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PolicyDetailsDwellingFireCoverageCodeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsDwellingFireCoverageCodeModel | null>(null as any);
    }
}

export class PolicyDetailsDwellingFireFireTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<PolicyDetailsDwellingFireFireTypeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsDwellingFireFireType?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PolicyDetailsDwellingFireFireTypeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsDwellingFireFireTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsDwellingFireFireTypeModel[] | null>(null as any);
    }

    put(conversionId: string, policyDetailsDwellingFireFireTypeId: string, policyDetailsDwellingFireFireType: PolicyDetailsDwellingFireFireTypeModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsDwellingFireFireType/{policyDetailsDwellingFireFireTypeId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (policyDetailsDwellingFireFireTypeId === undefined || policyDetailsDwellingFireFireTypeId === null)
            throw new Error("The parameter 'policyDetailsDwellingFireFireTypeId' must be defined.");
        url_ = url_.replace("{policyDetailsDwellingFireFireTypeId}", encodeURIComponent("" + policyDetailsDwellingFireFireTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policyDetailsDwellingFireFireType);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllRefs(conversionId: string): Promise<PolicyDetailsDwellingFireFireTypeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsDwellingFireFireType/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllRefs(_response));
        });
    }

    protected processGetAllRefs(response: Response): Promise<PolicyDetailsDwellingFireFireTypeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsDwellingFireFireTypeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsDwellingFireFireTypeRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<PolicyDetailsDwellingFireFireTypeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsDwellingFireFireType/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PolicyDetailsDwellingFireFireTypeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PolicyDetailsDwellingFireFireTypeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsDwellingFireFireTypeModel | null>(null as any);
    }
}

export class PolicyDetailsHomeownersCoverageCodeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<PolicyDetailsHomeownersCoverageCodeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsHomeownersCoverageCode?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PolicyDetailsHomeownersCoverageCodeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsHomeownersCoverageCodeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsHomeownersCoverageCodeModel[] | null>(null as any);
    }

    put(conversionId: string, policyDetailsHomeownersCoverageCodeId: string, policyDetailsHomeownersCoverageCode: PolicyDetailsHomeownersCoverageCodeModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsHomeownersCoverageCode/{policyDetailsHomeownersCoverageCodeId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (policyDetailsHomeownersCoverageCodeId === undefined || policyDetailsHomeownersCoverageCodeId === null)
            throw new Error("The parameter 'policyDetailsHomeownersCoverageCodeId' must be defined.");
        url_ = url_.replace("{policyDetailsHomeownersCoverageCodeId}", encodeURIComponent("" + policyDetailsHomeownersCoverageCodeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policyDetailsHomeownersCoverageCode);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllRefs(conversionId: string): Promise<PolicyDetailsHomeownersCoverageCodeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsHomeownersCoverageCode/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllRefs(_response));
        });
    }

    protected processGetAllRefs(response: Response): Promise<PolicyDetailsHomeownersCoverageCodeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsHomeownersCoverageCodeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsHomeownersCoverageCodeRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<PolicyDetailsHomeownersCoverageCodeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsHomeownersCoverageCode/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PolicyDetailsHomeownersCoverageCodeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PolicyDetailsHomeownersCoverageCodeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsHomeownersCoverageCodeModel | null>(null as any);
    }
}

export class PolicyDetailsHomeownersFormTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<PolicyDetailsHomeownersFormTypeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsHomeownersFormType?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PolicyDetailsHomeownersFormTypeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsHomeownersFormTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsHomeownersFormTypeModel[] | null>(null as any);
    }

    put(conversionId: string, policyDetailsHomeownersFormTypeId: string, policyDetailsHomeownersFormType: PolicyDetailsHomeownersFormTypeModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsHomeownersFormType/{policyDetailsHomeownersFormTypeId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (policyDetailsHomeownersFormTypeId === undefined || policyDetailsHomeownersFormTypeId === null)
            throw new Error("The parameter 'policyDetailsHomeownersFormTypeId' must be defined.");
        url_ = url_.replace("{policyDetailsHomeownersFormTypeId}", encodeURIComponent("" + policyDetailsHomeownersFormTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policyDetailsHomeownersFormType);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllRefs(conversionId: string): Promise<PolicyDetailsHomeownersFormTypeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsHomeownersFormType/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllRefs(_response));
        });
    }

    protected processGetAllRefs(response: Response): Promise<PolicyDetailsHomeownersFormTypeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsHomeownersFormTypeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsHomeownersFormTypeRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<PolicyDetailsHomeownersFormTypeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsHomeownersFormType/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PolicyDetailsHomeownersFormTypeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PolicyDetailsHomeownersFormTypeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsHomeownersFormTypeModel | null>(null as any);
    }
}

export class PolicyDetailsPersonalAutoAntilockBrakeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<PolicyDetailsPersonalAutoAntilockBrakeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsPersonalAutoAntilockBrake?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PolicyDetailsPersonalAutoAntilockBrakeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsPersonalAutoAntilockBrakeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsPersonalAutoAntilockBrakeModel[] | null>(null as any);
    }

    put(conversionId: string, policyDetailsPersonalAutoAntilockBrakeId: string, policyDetailsPersonalAutoAntilockBrake: PolicyDetailsPersonalAutoAntilockBrakeModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsPersonalAutoAntilockBrake/{policyDetailsPersonalAutoAntilockBrakeId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (policyDetailsPersonalAutoAntilockBrakeId === undefined || policyDetailsPersonalAutoAntilockBrakeId === null)
            throw new Error("The parameter 'policyDetailsPersonalAutoAntilockBrakeId' must be defined.");
        url_ = url_.replace("{policyDetailsPersonalAutoAntilockBrakeId}", encodeURIComponent("" + policyDetailsPersonalAutoAntilockBrakeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policyDetailsPersonalAutoAntilockBrake);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllRefs(conversionId: string): Promise<PolicyDetailsPersonalAutoAntilockBrakeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsPersonalAutoAntilockBrake/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllRefs(_response));
        });
    }

    protected processGetAllRefs(response: Response): Promise<PolicyDetailsPersonalAutoAntilockBrakeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsPersonalAutoAntilockBrakeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsPersonalAutoAntilockBrakeRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<PolicyDetailsPersonalAutoAntilockBrakeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsPersonalAutoAntilockBrake/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PolicyDetailsPersonalAutoAntilockBrakeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PolicyDetailsPersonalAutoAntilockBrakeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsPersonalAutoAntilockBrakeModel | null>(null as any);
    }
}

export class PolicyDetailsPersonalAutoBodyTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<PolicyDetailsPersonalAutoBodyTypeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsPersonalAutoBodyType?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PolicyDetailsPersonalAutoBodyTypeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsPersonalAutoBodyTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsPersonalAutoBodyTypeModel[] | null>(null as any);
    }

    put(conversionId: string, policyDetailsPersonalAutoBodyTypeId: string, policyDetailsPersonalAutoBodyType: PolicyDetailsPersonalAutoBodyTypeModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsPersonalAutoBodyType/{policyDetailsPersonalAutoBodyTypeId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (policyDetailsPersonalAutoBodyTypeId === undefined || policyDetailsPersonalAutoBodyTypeId === null)
            throw new Error("The parameter 'policyDetailsPersonalAutoBodyTypeId' must be defined.");
        url_ = url_.replace("{policyDetailsPersonalAutoBodyTypeId}", encodeURIComponent("" + policyDetailsPersonalAutoBodyTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policyDetailsPersonalAutoBodyType);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllRefs(conversionId: string): Promise<PolicyDetailsPersonalAutoBodyTypeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsPersonalAutoBodyType/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllRefs(_response));
        });
    }

    protected processGetAllRefs(response: Response): Promise<PolicyDetailsPersonalAutoBodyTypeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsPersonalAutoBodyTypeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsPersonalAutoBodyTypeRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<PolicyDetailsPersonalAutoBodyTypeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsPersonalAutoBodyType/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PolicyDetailsPersonalAutoBodyTypeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PolicyDetailsPersonalAutoBodyTypeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsPersonalAutoBodyTypeModel | null>(null as any);
    }
}

export class PolicyDetailsPersonalAutoCoverageCodeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<PolicyDetailsPersonalAutoCoverageCodeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsPersonalAutoCoverageCode?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PolicyDetailsPersonalAutoCoverageCodeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsPersonalAutoCoverageCodeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsPersonalAutoCoverageCodeModel[] | null>(null as any);
    }

    getByDestinationCode(conversionId: string, destinationCode: string): Promise<PolicyDetailsPersonalAutoCoverageCodeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsPersonalAutoCoverageCode/destinationCode/{destinationCode}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (destinationCode === undefined || destinationCode === null)
            throw new Error("The parameter 'destinationCode' must be defined.");
        url_ = url_.replace("{destinationCode}", encodeURIComponent("" + destinationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByDestinationCode(_response));
        });
    }

    protected processGetByDestinationCode(response: Response): Promise<PolicyDetailsPersonalAutoCoverageCodeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsPersonalAutoCoverageCodeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsPersonalAutoCoverageCodeModel[] | null>(null as any);
    }

    put(conversionId: string, policyDetailsPersonalAutoCoverageCodeId: string, policyDetailsPersonalAutoCoverageCode: PolicyDetailsPersonalAutoCoverageCodeModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsPersonalAutoCoverageCode/{policyDetailsPersonalAutoCoverageCodeId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (policyDetailsPersonalAutoCoverageCodeId === undefined || policyDetailsPersonalAutoCoverageCodeId === null)
            throw new Error("The parameter 'policyDetailsPersonalAutoCoverageCodeId' must be defined.");
        url_ = url_.replace("{policyDetailsPersonalAutoCoverageCodeId}", encodeURIComponent("" + policyDetailsPersonalAutoCoverageCodeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policyDetailsPersonalAutoCoverageCode);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllRefs(conversionId: string): Promise<PolicyDetailsPersonalAutoCoverageCodeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsPersonalAutoCoverageCode/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllRefs(_response));
        });
    }

    protected processGetAllRefs(response: Response): Promise<PolicyDetailsPersonalAutoCoverageCodeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyDetailsPersonalAutoCoverageCodeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsPersonalAutoCoverageCodeRefModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<PolicyDetailsPersonalAutoCoverageCodeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyDetailsPersonalAutoCoverageCode/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PolicyDetailsPersonalAutoCoverageCodeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PolicyDetailsPersonalAutoCoverageCodeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetailsPersonalAutoCoverageCodeModel | null>(null as any);
    }
}

export class PolicyStatusTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<PolicyStatusTypeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyStatusType?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PolicyStatusTypeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyStatusTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyStatusTypeModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<PolicyStatusTypeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyStatusType/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PolicyStatusTypeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PolicyStatusTypeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyStatusTypeModel | null>(null as any);
    }

    put(conversionId: string, id: string, policyStatusType: PolicyStatusTypeModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyStatusType/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policyStatusType);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<PolicyStatusTypeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyStatusType/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<PolicyStatusTypeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyStatusTypeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyStatusTypeRefModel[] | null>(null as any);
    }
}

export class PolicyTransactionTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<PolicyTransactionTypeModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyTransactionType?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PolicyTransactionTypeModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyTransactionTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyTransactionTypeModel[] | null>(null as any);
    }

    get(conversionId: string, id: string): Promise<PolicyTransactionTypeModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyTransactionType/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PolicyTransactionTypeModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PolicyTransactionTypeModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyTransactionTypeModel | null>(null as any);
    }

    put(conversionId: string, id: string, policyTransactionType: PolicyTransactionTypeModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyTransactionType/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policyTransactionType);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<PolicyTransactionTypeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/PolicyTransactionType/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<PolicyTransactionTypeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyTransactionTypeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyTransactionTypeRefModel[] | null>(null as any);
    }
}

export class StatisticsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(conversionId: string, tier: string): Promise<StatisticsModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Statistics/{tier}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (tier === undefined || tier === null)
            throw new Error("The parameter 'tier' must be defined.");
        url_ = url_.replace("{tier}", encodeURIComponent("" + tier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<StatisticsModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatisticsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatisticsModel[] | null>(null as any);
    }
}

export class VendorClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string): Promise<VendorModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Vendor";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<VendorModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VendorModel[] | null>(null as any);
    }

    getRef(conversionId: string): Promise<VendorRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Vendor/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<VendorRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VendorRefModel[] | null>(null as any);
    }

    put(conversionId: string, id: number, vendor: VendorModel | null | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Vendor/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vendor);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    get(conversionId: string, id: number): Promise<VendorModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Vendor/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<VendorModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? VendorModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VendorModel | null>(null as any);
    }

    getByDestinationCode(conversionId: string, destinationCode: string): Promise<VendorModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Vendor/destinationCode/{destinationCode}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (destinationCode === undefined || destinationCode === null)
            throw new Error("The parameter 'destinationCode' must be defined.");
        url_ = url_.replace("{destinationCode}", encodeURIComponent("" + destinationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByDestinationCode(_response));
        });
    }

    protected processGetByDestinationCode(response: Response): Promise<VendorModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VendorModel[] | null>(null as any);
    }

    updatePrimary(conversionId: string, destinationCode: string | null, vendorId: number, rows: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/Vendor/destinationCode/{vendorId}?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (vendorId === undefined || vendorId === null)
            throw new Error("The parameter 'vendorId' must be defined.");
        url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
        if (destinationCode === undefined)
            throw new Error("The parameter 'destinationCode' must be defined.");
        else if(destinationCode !== null)
            url_ += "destinationCode=" + encodeURIComponent("" + destinationCode) + "&";
        if (rows === undefined || rows === null)
            throw new Error("The parameter 'rows' must be defined and cannot be null.");
        else
            url_ += "rows=" + encodeURIComponent("" + rows) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePrimary(_response));
        });
    }

    protected processUpdatePrimary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WorkGroupClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(conversionId: string, filter: string | null): Promise<WorkGroupModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/WorkGroup?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<WorkGroupModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkGroupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkGroupModel[] | null>(null as any);
    }

    get(conversionId: string, id: number): Promise<WorkGroupModel | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/WorkGroup/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<WorkGroupModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? WorkGroupModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkGroupModel | null>(null as any);
    }

    put(conversionId: string, id: number, workGroup: WorkGroupModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/WorkGroup/{id}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workGroup);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<EmployeeRefModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/{conversionId}/Stage/WorkGroup/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<EmployeeRefModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeRefModel[] | null>(null as any);
    }

    getWorkGroup(conversionId: string): Promise<WorkGroupDto[] | null> {
        let url_ = this.baseUrl + "/api/v2/conversion/{conversionId}/WorkGroup/map";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkGroup(_response));
        });
    }

    protected processGetWorkGroup(response: Response): Promise<WorkGroupDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkGroupDto[] | null>(null as any);
    }

    putWorkGroup(conversionId: string, workGroupUpdate: WorkGroupDto | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v2/conversion/{conversionId}/WorkGroup/map";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workGroupUpdate);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPutWorkGroup(_response));
        });
    }

    protected processPutWorkGroup(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getRef2(conversionId: string): Promise<EmployeeRefDto[] | null> {
        let url_ = this.baseUrl + "/api/v2/conversion/{conversionId}/WorkGroup/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef2(_response));
        });
    }

    protected processGetRef2(response: Response): Promise<EmployeeRefDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeRefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeRefDto[] | null>(null as any);
    }
}

export class ConversionCleanupReportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getReport(): Promise<ConversionCleanupReportResponse | null> {
        let url_ = this.baseUrl + "/api/v1/conversions/cleanup/report";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReport(_response));
        });
    }

    protected processGetReport(response: Response): Promise<ConversionCleanupReportResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConversionCleanupReportResponse.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionCleanupReportResponse | null>(null as any);
    }
}

export class ConversionReportArchiveClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getArchivedConversions(): Promise<ConversionReportArchiveSummaryModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/conversion-report-archive";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetArchivedConversions(_response));
        });
    }

    protected processGetArchivedConversions(response: Response): Promise<ConversionReportArchiveSummaryModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionReportArchiveSummaryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionReportArchiveSummaryModel[] | null>(null as any);
    }

    getArchivedItems(conversionId: string): Promise<ConversionReportArchiveItemModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/conversion-report-archive/{conversionId}";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetArchivedItems(_response));
        });
    }

    protected processGetArchivedItems(response: Response): Promise<ConversionReportArchiveItemModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionReportArchiveItemModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionReportArchiveItemModel[] | null>(null as any);
    }

    downloadArchivedFile(conversionId: string, reportKey: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/conversion-report-archive/{conversionId}/{reportKey}/download";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (reportKey === undefined || reportKey === null)
            throw new Error("The parameter 'reportKey' must be defined.");
        url_ = url_.replace("{reportKey}", encodeURIComponent("" + reportKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadArchivedFile(_response));
        });
    }

    protected processDownloadArchivedFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ConversionServerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    listAll(): Promise<ConversionServerModel[] | null> {
        let url_ = this.baseUrl + "/api/v2/server";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListAll(_response));
        });
    }

    protected processListAll(response: Response): Promise<ConversionServerModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionServerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionServerModel[] | null>(null as any);
    }

    listSource(): Promise<ConversionServerModel[] | null> {
        let url_ = this.baseUrl + "/api/v2/server/source";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListSource(_response));
        });
    }

    protected processListSource(response: Response): Promise<ConversionServerModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionServerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionServerModel[] | null>(null as any);
    }

    listStage(): Promise<ConversionServerModel[] | null> {
        let url_ = this.baseUrl + "/api/v2/server/stage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListStage(_response));
        });
    }

    protected processListStage(response: Response): Promise<ConversionServerModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionServerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionServerModel[] | null>(null as any);
    }

    listTarget(): Promise<ConversionServerModel[] | null> {
        let url_ = this.baseUrl + "/api/v2/server/target";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListTarget(_response));
        });
    }

    protected processListTarget(response: Response): Promise<ConversionServerModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionServerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionServerModel[] | null>(null as any);
    }
}

export class EpicSplitClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    byBusinessUnit(splitParameters: NewSplitByBusinessUnitModel | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/split/epic/byBusinessUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(splitParameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processByBusinessUnit(_response));
        });
    }

    protected processByBusinessUnit(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    listAll(): Promise<SplitByBusinessUnitModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/split/epic";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListAll(_response));
        });
    }

    protected processListAll(response: Response): Promise<SplitByBusinessUnitModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SplitByBusinessUnitModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SplitByBusinessUnitModel[] | null>(null as any);
    }

    get(id: string): Promise<SplitByBusinessUnitModel | null> {
        let url_ = this.baseUrl + "/api/v1/split/epic/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SplitByBusinessUnitModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SplitByBusinessUnitModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SplitByBusinessUnitModel | null>(null as any);
    }

    getTimings(splitId: string, afterSequenceId: number | null, recordLimit: number | null): Promise<SplitTimingModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/split/epic/{splitId}/timing?";
        if (splitId === undefined || splitId === null)
            throw new Error("The parameter 'splitId' must be defined.");
        url_ = url_.replace("{splitId}", encodeURIComponent("" + splitId));
        if (afterSequenceId === undefined)
            throw new Error("The parameter 'afterSequenceId' must be defined.");
        else if(afterSequenceId !== null)
            url_ += "afterSequenceId=" + encodeURIComponent("" + afterSequenceId) + "&";
        if (recordLimit === undefined)
            throw new Error("The parameter 'recordLimit' must be defined.");
        else if(recordLimit !== null)
            url_ += "recordLimit=" + encodeURIComponent("" + recordLimit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTimings(_response));
        });
    }

    protected processGetTimings(response: Response): Promise<SplitTimingModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SplitTimingModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SplitTimingModel[] | null>(null as any);
    }
}

export class ExcelMappingClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getEntities(): Promise<SelectOptionOfUInt64[] | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/entities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEntities(_response));
        });
    }

    protected processGetEntities(response: Response): Promise<SelectOptionOfUInt64[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectOptionOfUInt64.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectOptionOfUInt64[] | null>(null as any);
    }

    getClients(): Promise<SelectOptionOfGuid[] | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/clients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClients(_response));
        });
    }

    protected processGetClients(response: Response): Promise<SelectOptionOfGuid[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectOptionOfGuid.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectOptionOfGuid[] | null>(null as any);
    }

    getClient(clientId: string): Promise<SelectOptionOfGuid[] | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/clients/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClient(_response));
        });
    }

    protected processGetClient(response: Response): Promise<SelectOptionOfGuid[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectOptionOfGuid.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectOptionOfGuid[] | null>(null as any);
    }

    getTypes(clientId: string): Promise<SelectOptionOfGuid[] | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/clients/{clientId}/types";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTypes(_response));
        });
    }

    protected processGetTypes(response: Response): Promise<SelectOptionOfGuid[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectOptionOfGuid.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectOptionOfGuid[] | null>(null as any);
    }

    getConversions(clientId: string, conversionTypeId: string): Promise<SelectOptionOfGuid[] | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/clients/{clientId}/types/{conversionTypeId}/conversions";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (conversionTypeId === undefined || conversionTypeId === null)
            throw new Error("The parameter 'conversionTypeId' must be defined.");
        url_ = url_.replace("{conversionTypeId}", encodeURIComponent("" + conversionTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConversions(_response));
        });
    }

    protected processGetConversions(response: Response): Promise<SelectOptionOfGuid[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectOptionOfGuid.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectOptionOfGuid[] | null>(null as any);
    }

    getConversion(clientId: string, conversionTypeId: string, conversionId: string): Promise<SelectOptionOfGuid[] | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/clients/{clientId}/types/{conversionTypeId}/conversions/{conversionId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (conversionTypeId === undefined || conversionTypeId === null)
            throw new Error("The parameter 'conversionTypeId' must be defined.");
        url_ = url_.replace("{conversionTypeId}", encodeURIComponent("" + conversionTypeId));
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConversion(_response));
        });
    }

    protected processGetConversion(response: Response): Promise<SelectOptionOfGuid[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectOptionOfGuid.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectOptionOfGuid[] | null>(null as any);
    }

    getConversionRunningStatus(conversionId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/conversions/{conversionId}/map/checkConversionExists";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConversionRunningStatus(_response));
        });
    }

    protected processGetConversionRunningStatus(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getEntityMapping(conversionId: string, entity: SupportedEntities): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/conversions/{conversionId}/{entity}/map";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEntityMapping(_response));
        });
    }

    protected processGetEntityMapping(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateMapping(conversionId: string, entity: SupportedEntities, entityJson: any | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/conversions/{conversionId}/{entity}/map?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        if (entityJson === undefined)
            throw new Error("The parameter 'entityJson' must be defined.");
        else if(entityJson !== null)
            url_ += "entityJson=" + encodeURIComponent("" + entityJson) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateMapping(_response));
        });
    }

    protected processUpdateMapping(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getEntityReference(conversionId: string, entity: SupportedEntities): Promise<EmployeeRefDto[] | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/conversions/{conversionId}/{entity}/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEntityReference(_response));
        });
    }

    protected processGetEntityReference(response: Response): Promise<EmployeeRefDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeRefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeRefDto[] | null>(null as any);
    }

    getEntityMappingSize(conversionId: string, entity: SupportedEntities): Promise<TableSize | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/conversions/{conversionId}/{entity}/map/size";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEntityMappingSize(_response));
        });
    }

    protected processGetEntityMappingSize(response: Response): Promise<TableSize | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TableSize.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TableSize | null>(null as any);
    }

    getEntityReferenceSize(conversionId: string, entity: SupportedEntities): Promise<TableSize | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/conversions/{conversionId}/{entity}/ref/size";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEntityReferenceSize(_response));
        });
    }

    protected processGetEntityReferenceSize(response: Response): Promise<TableSize | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TableSize.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TableSize | null>(null as any);
    }

    getEntityMappingHeader(conversionId: string, entity: SupportedEntities): Promise<string[][] | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/conversions/{conversionId}/{entity}/map/header";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEntityMappingHeader(_response));
        });
    }

    protected processGetEntityMappingHeader(response: Response): Promise<string[][] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[][] | null>(null as any);
    }

    getEntityReferenceHeader(conversionId: string, entity: SupportedEntities): Promise<string[][] | null> {
        let url_ = this.baseUrl + "/api/v1/ExcelMapping/conversions/{conversionId}/{entity}/ref/header";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEntityReferenceHeader(_response));
        });
    }

    protected processGetEntityReferenceHeader(response: Response): Promise<string[][] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[][] | null>(null as any);
    }
}

export class RoleClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Promise<RoleModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/Role";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<RoleModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleModel[] | null>(null as any);
    }
}

export class UserClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Promise<UserModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<UserModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModel[] | null>(null as any);
    }

    post(user: UserModel | null | undefined): Promise<UserModel | null> {
        let url_ = this.baseUrl + "/api/v1/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPost(_response));
        });
    }

    protected processPost(response: Response): Promise<UserModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModel | null>(null as any);
    }

    get(userId: string): Promise<UserModel | null> {
        let url_ = this.baseUrl + "/api/v1/user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<UserModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModel | null>(null as any);
    }

    put(userId: string, user: UserModel | null | undefined): Promise<UserModel | null> {
        let url_ = this.baseUrl + "/api/v1/user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPut(_response));
        });
    }

    protected processPut(response: Response): Promise<UserModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModel | null>(null as any);
    }

    getAllClientId(): Promise<UserToConversionClientModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/user/clientId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllClientId(_response));
        });
    }

    protected processGetAllClientId(response: Response): Promise<UserToConversionClientModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserToConversionClientModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserToConversionClientModel[] | null>(null as any);
    }

    delete(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/delete/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    remove(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/remove/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemove(_response));
        });
    }

    protected processRemove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    editEmailList(userId: string, addedToList: boolean): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/editEmailList/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (addedToList === undefined || addedToList === null)
            throw new Error("The parameter 'addedToList' must be defined and cannot be null.");
        else
            url_ += "addedToList=" + encodeURIComponent("" + addedToList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditEmailList(_response));
        });
    }

    protected processEditEmailList(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    listGroupEmail(conversionId: string): Promise<UserModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/user/editGroupEmail?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined and cannot be null.");
        else
            url_ += "conversionId=" + encodeURIComponent("" + conversionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListGroupEmail(_response));
        });
    }

    protected processListGroupEmail(response: Response): Promise<UserModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModel[] | null>(null as any);
    }

    editGroupEmail(userId: string, conversionId: string, currentUserId: string, addedToList: boolean): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/editGroupEmail/{userId}/{conversionId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        if (currentUserId === undefined || currentUserId === null)
            throw new Error("The parameter 'currentUserId' must be defined and cannot be null.");
        else
            url_ += "currentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        if (addedToList === undefined || addedToList === null)
            throw new Error("The parameter 'addedToList' must be defined and cannot be null.");
        else
            url_ += "addedToList=" + encodeURIComponent("" + addedToList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditGroupEmail(_response));
        });
    }

    protected processEditGroupEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    listManageUsers(conversionId: string, clientId: string): Promise<UserModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/user/manageUsers?";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined and cannot be null.");
        else
            url_ += "conversionId=" + encodeURIComponent("" + conversionId) + "&";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListManageUsers(_response));
        });
    }

    protected processListManageUsers(response: Response): Promise<UserModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModel[] | null>(null as any);
    }
}

export class UserToClientClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(userId: string): Promise<ConversionClientModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/user/{userId}/client";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ConversionClientModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionClientModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionClientModel[] | null>(null as any);
    }

    patch(userId: string, request: UpdateUserToClientRequestModel | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/user/{userId}/client";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class UserToConversionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(userId: string): Promise<ConversionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/user/{userId}/conversion";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ConversionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionModel[] | null>(null as any);
    }

    patch(userId: string, request: UpdateUserToConversionRequestModel | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/user/{userId}/conversion";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPatch(_response));
        });
    }

    protected processPatch(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class UtilitiesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    publishSingleDb(model: PublishSingleDbModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Utilities/publishSingleDb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPublishSingleDb(_response));
        });
    }

    protected processPublishSingleDb(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    publishDBByConversionId(model: PublishDBByConversionIdModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Utilities/publishDBByConversionId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPublishDBByConversionId(_response));
        });
    }

    protected processPublishDBByConversionId(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    publishDBByConversionTypeId(model: PublishDBByConversionTypeIdModel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Utilities/publishDBByConversionTypeId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPublishDBByConversionTypeId(_response));
        });
    }

    protected processPublishDBByConversionTypeId(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getConfigurationValue(paramName: string | null): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/Utilities/appSettings?";
        if (paramName === undefined)
            throw new Error("The parameter 'paramName' must be defined.");
        else if(paramName !== null)
            url_ += "paramName=" + encodeURIComponent("" + paramName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfigurationValue(_response));
        });
    }

    protected processGetConfigurationValue(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }
}

export class LineofBusinessClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLineOfBusiness(conversionId: string): Promise<LineOfBusinessMapDto[] | null> {
        let url_ = this.baseUrl + "/api/v2/conversion/{conversionId}/LineofBusiness/map";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLineOfBusiness(_response));
        });
    }

    protected processGetLineOfBusiness(response: Response): Promise<LineOfBusinessMapDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LineOfBusinessMapDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LineOfBusinessMapDto[] | null>(null as any);
    }

    putLineOfBusiness(conversionId: string, lineOfBusinessUpdate: LineOfBusinessUpdateMapDto | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/conversion/{conversionId}/LineofBusiness/map";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lineOfBusinessUpdate);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPutLineOfBusiness(_response));
        });
    }

    protected processPutLineOfBusiness(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRef(conversionId: string): Promise<LineOfBusinessRefDto[] | null> {
        let url_ = this.baseUrl + "/api/v2/conversion/{conversionId}/LineofBusiness/ref";
        if (conversionId === undefined || conversionId === null)
            throw new Error("The parameter 'conversionId' must be defined.");
        url_ = url_.replace("{conversionId}", encodeURIComponent("" + conversionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRef(_response));
        });
    }

    protected processGetRef(response: Response): Promise<LineOfBusinessRefDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LineOfBusinessRefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LineOfBusinessRefDto[] | null>(null as any);
    }
}

export class UserLoginDetailsModel implements IUserLoginDetailsModel {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: string | undefined;
    expiration!: Date;
    isEulaAccepted!: boolean;
    emailAddress?: string | undefined;

    constructor(data?: IUserLoginDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.role = _data["role"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.isEulaAccepted = _data["isEulaAccepted"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): UserLoginDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["role"] = this.role;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["isEulaAccepted"] = this.isEulaAccepted;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IUserLoginDetailsModel {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: string | undefined;
    expiration: Date;
    isEulaAccepted: boolean;
    emailAddress?: string | undefined;
}

export class UserLoginModel implements IUserLoginModel {
    userName!: string;
    password!: string;

    constructor(data?: IUserLoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserLoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IUserLoginModel {
    userName: string;
    password: string;
}

export class AMS360SetupsModel implements IAMS360SetupsModel {
    actionId!: string;
    sourceServerId!: string;
    targetServerId!: string;
    executionId?: number | undefined;
    sourceServerName?: string | undefined;
    sourceDatabaseName?: string | undefined;
    targetServerName?: string | undefined;
    targetDatabaseName?: string | undefined;
    status?: string | undefined;
    errorMessage?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    estimatedFinish?: Date | undefined;
    estimatedFinishEarly?: Date | undefined;
    estimatedFinishLate?: Date | undefined;

    constructor(data?: IAMS360SetupsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionId = _data["actionId"];
            this.sourceServerId = _data["sourceServerId"];
            this.targetServerId = _data["targetServerId"];
            this.executionId = _data["executionId"];
            this.sourceServerName = _data["sourceServerName"];
            this.sourceDatabaseName = _data["sourceDatabaseName"];
            this.targetServerName = _data["targetServerName"];
            this.targetDatabaseName = _data["targetDatabaseName"];
            this.status = _data["status"];
            this.errorMessage = _data["errorMessage"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.estimatedFinish = _data["estimatedFinish"] ? new Date(_data["estimatedFinish"].toString()) : <any>undefined;
            this.estimatedFinishEarly = _data["estimatedFinishEarly"] ? new Date(_data["estimatedFinishEarly"].toString()) : <any>undefined;
            this.estimatedFinishLate = _data["estimatedFinishLate"] ? new Date(_data["estimatedFinishLate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AMS360SetupsModel {
        data = typeof data === 'object' ? data : {};
        let result = new AMS360SetupsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionId"] = this.actionId;
        data["sourceServerId"] = this.sourceServerId;
        data["targetServerId"] = this.targetServerId;
        data["executionId"] = this.executionId;
        data["sourceServerName"] = this.sourceServerName;
        data["sourceDatabaseName"] = this.sourceDatabaseName;
        data["targetServerName"] = this.targetServerName;
        data["targetDatabaseName"] = this.targetDatabaseName;
        data["status"] = this.status;
        data["errorMessage"] = this.errorMessage;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["estimatedFinish"] = this.estimatedFinish ? this.estimatedFinish.toISOString() : <any>undefined;
        data["estimatedFinishEarly"] = this.estimatedFinishEarly ? this.estimatedFinishEarly.toISOString() : <any>undefined;
        data["estimatedFinishLate"] = this.estimatedFinishLate ? this.estimatedFinishLate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAMS360SetupsModel {
    actionId: string;
    sourceServerId: string;
    targetServerId: string;
    executionId?: number | undefined;
    sourceServerName?: string | undefined;
    sourceDatabaseName?: string | undefined;
    targetServerName?: string | undefined;
    targetDatabaseName?: string | undefined;
    status?: string | undefined;
    errorMessage?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    estimatedFinish?: Date | undefined;
    estimatedFinishEarly?: Date | undefined;
    estimatedFinishLate?: Date | undefined;
}

export class AMS360SetupsTimingModel implements IAMS360SetupsTimingModel {
    id!: string;
    ndtId!: string;
    sequenceId!: number;
    tableName?: string | undefined;
    action?: string | undefined;
    recordCount?: number | undefined;
    startedOn?: Date | undefined;
    finishedOn?: Date | undefined;
    executionTimeInMilliseconds?: number | undefined;

    constructor(data?: IAMS360SetupsTimingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ndtId = _data["ndtId"];
            this.sequenceId = _data["sequenceId"];
            this.tableName = _data["tableName"];
            this.action = _data["action"];
            this.recordCount = _data["recordCount"];
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : <any>undefined;
            this.finishedOn = _data["finishedOn"] ? new Date(_data["finishedOn"].toString()) : <any>undefined;
            this.executionTimeInMilliseconds = _data["executionTimeInMilliseconds"];
        }
    }

    static fromJS(data: any): AMS360SetupsTimingModel {
        data = typeof data === 'object' ? data : {};
        let result = new AMS360SetupsTimingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ndtId"] = this.ndtId;
        data["sequenceId"] = this.sequenceId;
        data["tableName"] = this.tableName;
        data["action"] = this.action;
        data["recordCount"] = this.recordCount;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["finishedOn"] = this.finishedOn ? this.finishedOn.toISOString() : <any>undefined;
        data["executionTimeInMilliseconds"] = this.executionTimeInMilliseconds;
        return data;
    }
}

export interface IAMS360SetupsTimingModel {
    id: string;
    ndtId: string;
    sequenceId: number;
    tableName?: string | undefined;
    action?: string | undefined;
    recordCount?: number | undefined;
    startedOn?: Date | undefined;
    finishedOn?: Date | undefined;
    executionTimeInMilliseconds?: number | undefined;
}

export abstract class BaseEntityModel implements IBaseEntityModel {
    id?: string | undefined;
    createdById!: string;
    createdDate!: Date;
    lastEditorId!: string;
    lastEditedDate!: Date;
    rowVersion?: string | undefined;

    constructor(data?: IBaseEntityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastEditorId = _data["lastEditorId"];
            this.lastEditedDate = _data["lastEditedDate"] ? new Date(_data["lastEditedDate"].toString()) : <any>undefined;
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): BaseEntityModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntityModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastEditorId"] = this.lastEditorId;
        data["lastEditedDate"] = this.lastEditedDate ? this.lastEditedDate.toISOString() : <any>undefined;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IBaseEntityModel {
    id?: string | undefined;
    createdById: string;
    createdDate: Date;
    lastEditorId: string;
    lastEditedDate: Date;
    rowVersion?: string | undefined;
}

export class ApiKeyModel extends BaseEntityModel implements IApiKeyModel {
    apiKey?: string | undefined;
    userId!: string;
    name?: string | undefined;
    status?: string | undefined;
    usage?: Date | undefined;
    lifetime?: Date | undefined;
    revoke!: boolean;
    expired!: boolean;

    constructor(data?: IApiKeyModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.usage = _data["usage"] ? new Date(_data["usage"].toString()) : <any>undefined;
            this.lifetime = _data["lifetime"] ? new Date(_data["lifetime"].toString()) : <any>undefined;
            this.revoke = _data["revoke"];
            this.expired = _data["expired"];
        }
    }

    static fromJS(data: any): ApiKeyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApiKeyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["usage"] = this.usage ? this.usage.toISOString() : <any>undefined;
        data["lifetime"] = this.lifetime ? this.lifetime.toISOString() : <any>undefined;
        data["revoke"] = this.revoke;
        data["expired"] = this.expired;
        super.toJSON(data);
        return data;
    }
}

export interface IApiKeyModel extends IBaseEntityModel {
    apiKey?: string | undefined;
    userId: string;
    name?: string | undefined;
    status?: string | undefined;
    usage?: Date | undefined;
    lifetime?: Date | undefined;
    revoke: boolean;
    expired: boolean;
}

export class ConversionClientModel extends BaseEntityModel implements IConversionClientModel {
    description?: string | undefined;
    isMiniConvEnabled!: boolean;
    isNDTConvEnabled!: boolean;
    miniTargetHost?: string | undefined;
    miniTargetCatalog?: string | undefined;

    constructor(data?: IConversionClientModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
            this.isMiniConvEnabled = _data["isMiniConvEnabled"];
            this.isNDTConvEnabled = _data["isNDTConvEnabled"];
            this.miniTargetHost = _data["miniTargetHost"];
            this.miniTargetCatalog = _data["miniTargetCatalog"];
        }
    }

    static fromJS(data: any): ConversionClientModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionClientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isMiniConvEnabled"] = this.isMiniConvEnabled;
        data["isNDTConvEnabled"] = this.isNDTConvEnabled;
        data["miniTargetHost"] = this.miniTargetHost;
        data["miniTargetCatalog"] = this.miniTargetCatalog;
        super.toJSON(data);
        return data;
    }
}

export interface IConversionClientModel extends IBaseEntityModel {
    description?: string | undefined;
    isMiniConvEnabled: boolean;
    isNDTConvEnabled: boolean;
    miniTargetHost?: string | undefined;
    miniTargetCatalog?: string | undefined;
}

export class ConversionModel extends BaseEntityModel implements IConversionModel {
    description?: string | undefined;
    parentConversionId?: string | undefined;
    conversionTypeId!: string;
    conversionTypeDescription?: string | undefined;
    netsuiteProject?: string | undefined;
    vertaforeId?: string | undefined;
    goLiveDate?: Date | undefined;
    dateCompleted?: Date | undefined;
    source?: EnvironmentModel | undefined;
    target?: EnvironmentModel | undefined;
    staging?: EnvironmentModel | undefined;
    client?: ConversionClientModel | undefined;
    imagePath?: string | undefined;
    userCreated?: string | undefined;
    userEdited?: string | undefined;
    userCreatedEmail?: string | undefined;
    userEditedEmail?: string | undefined;
    epicVersion?: string | undefined;
    epicMode?: string | undefined;
    amsVersion?: string | undefined;
    isCertified?: boolean | undefined;
    amsCertified?: boolean | undefined;
    epicModeCertified?: boolean | undefined;
    refreshRan?: boolean | undefined;
    configurationSetting!: number;
    status?: number | undefined;
    projectClassificationId?: string | undefined;
    deletionException?: string | undefined;

    constructor(data?: IConversionModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
            this.parentConversionId = _data["parentConversionId"];
            this.conversionTypeId = _data["conversionTypeId"];
            this.conversionTypeDescription = _data["conversionTypeDescription"];
            this.netsuiteProject = _data["netsuiteProject"];
            this.vertaforeId = _data["vertaforeId"];
            this.goLiveDate = _data["goLiveDate"] ? new Date(_data["goLiveDate"].toString()) : <any>undefined;
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : <any>undefined;
            this.source = _data["source"] ? EnvironmentModel.fromJS(_data["source"]) : <any>undefined;
            this.target = _data["target"] ? EnvironmentModel.fromJS(_data["target"]) : <any>undefined;
            this.staging = _data["staging"] ? EnvironmentModel.fromJS(_data["staging"]) : <any>undefined;
            this.client = _data["client"] ? ConversionClientModel.fromJS(_data["client"]) : <any>undefined;
            this.imagePath = _data["imagePath"];
            this.userCreated = _data["userCreated"];
            this.userEdited = _data["userEdited"];
            this.userCreatedEmail = _data["userCreatedEmail"];
            this.userEditedEmail = _data["userEditedEmail"];
            this.epicVersion = _data["epicVersion"];
            this.epicMode = _data["epicMode"];
            this.amsVersion = _data["amsVersion"];
            this.isCertified = _data["isCertified"];
            this.amsCertified = _data["amsCertified"];
            this.epicModeCertified = _data["epicModeCertified"];
            this.refreshRan = _data["refreshRan"];
            this.configurationSetting = _data["configurationSetting"];
            this.status = _data["status"];
            this.projectClassificationId = _data["projectClassificationId"];
            this.deletionException = _data["deletionException"];
        }
    }

    static fromJS(data: any): ConversionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["parentConversionId"] = this.parentConversionId;
        data["conversionTypeId"] = this.conversionTypeId;
        data["conversionTypeDescription"] = this.conversionTypeDescription;
        data["netsuiteProject"] = this.netsuiteProject;
        data["vertaforeId"] = this.vertaforeId;
        data["goLiveDate"] = this.goLiveDate ? this.goLiveDate.toISOString() : <any>undefined;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : <any>undefined;
        data["source"] = this.source ? this.source.toJSON() : <any>undefined;
        data["target"] = this.target ? this.target.toJSON() : <any>undefined;
        data["staging"] = this.staging ? this.staging.toJSON() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["imagePath"] = this.imagePath;
        data["userCreated"] = this.userCreated;
        data["userEdited"] = this.userEdited;
        data["userCreatedEmail"] = this.userCreatedEmail;
        data["userEditedEmail"] = this.userEditedEmail;
        data["epicVersion"] = this.epicVersion;
        data["epicMode"] = this.epicMode;
        data["amsVersion"] = this.amsVersion;
        data["isCertified"] = this.isCertified;
        data["amsCertified"] = this.amsCertified;
        data["epicModeCertified"] = this.epicModeCertified;
        data["refreshRan"] = this.refreshRan;
        data["configurationSetting"] = this.configurationSetting;
        data["status"] = this.status;
        data["projectClassificationId"] = this.projectClassificationId;
        data["deletionException"] = this.deletionException;
        super.toJSON(data);
        return data;
    }
}

export interface IConversionModel extends IBaseEntityModel {
    description?: string | undefined;
    parentConversionId?: string | undefined;
    conversionTypeId: string;
    conversionTypeDescription?: string | undefined;
    netsuiteProject?: string | undefined;
    vertaforeId?: string | undefined;
    goLiveDate?: Date | undefined;
    dateCompleted?: Date | undefined;
    source?: EnvironmentModel | undefined;
    target?: EnvironmentModel | undefined;
    staging?: EnvironmentModel | undefined;
    client?: ConversionClientModel | undefined;
    imagePath?: string | undefined;
    userCreated?: string | undefined;
    userEdited?: string | undefined;
    userCreatedEmail?: string | undefined;
    userEditedEmail?: string | undefined;
    epicVersion?: string | undefined;
    epicMode?: string | undefined;
    amsVersion?: string | undefined;
    isCertified?: boolean | undefined;
    amsCertified?: boolean | undefined;
    epicModeCertified?: boolean | undefined;
    refreshRan?: boolean | undefined;
    configurationSetting: number;
    status?: number | undefined;
    projectClassificationId?: string | undefined;
    deletionException?: string | undefined;
}

export class EnvironmentModel implements IEnvironmentModel {
    id?: string | undefined;
    conversionId?: string | undefined;
    connectionTypeId?: number | undefined;
    host?: string | undefined;
    catalog?: string | undefined;
    login?: string | undefined;
    name?: string | undefined;
    password?: string | undefined;
    version?: string | undefined;
    compatibilityLevel?: string | undefined;

    constructor(data?: IEnvironmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conversionId = _data["conversionId"];
            this.connectionTypeId = _data["connectionTypeId"];
            this.host = _data["host"];
            this.catalog = _data["catalog"];
            this.login = _data["login"];
            this.name = _data["name"];
            this.password = _data["password"];
            this.version = _data["version"];
            this.compatibilityLevel = _data["compatibilityLevel"];
        }
    }

    static fromJS(data: any): EnvironmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conversionId"] = this.conversionId;
        data["connectionTypeId"] = this.connectionTypeId;
        data["host"] = this.host;
        data["catalog"] = this.catalog;
        data["login"] = this.login;
        data["name"] = this.name;
        data["password"] = this.password;
        data["version"] = this.version;
        data["compatibilityLevel"] = this.compatibilityLevel;
        return data;
    }
}

export interface IEnvironmentModel {
    id?: string | undefined;
    conversionId?: string | undefined;
    connectionTypeId?: number | undefined;
    host?: string | undefined;
    catalog?: string | undefined;
    login?: string | undefined;
    name?: string | undefined;
    password?: string | undefined;
    version?: string | undefined;
    compatibilityLevel?: string | undefined;
}

export class ConversionsServersListModel implements IConversionsServersListModel {
    id!: string;
    serverType!: number;
    serverInstanceName?: string | undefined;

    constructor(data?: IConversionsServersListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serverType = _data["serverType"];
            this.serverInstanceName = _data["serverInstanceName"];
        }
    }

    static fromJS(data: any): ConversionsServersListModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionsServersListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serverType"] = this.serverType;
        data["serverInstanceName"] = this.serverInstanceName;
        return data;
    }
}

export interface IConversionsServersListModel {
    id: string;
    serverType: number;
    serverInstanceName?: string | undefined;
}

export class UIControllerModel implements IUIControllerModel {
    copyMapMerge!: boolean;
    addToMain!: boolean;
    addToMainEpic!: boolean;

    constructor(data?: IUIControllerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.copyMapMerge = _data["copyMapMerge"];
            this.addToMain = _data["addToMain"];
            this.addToMainEpic = _data["addToMainEpic"];
        }
    }

    static fromJS(data: any): UIControllerModel {
        data = typeof data === 'object' ? data : {};
        let result = new UIControllerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["copyMapMerge"] = this.copyMapMerge;
        data["addToMain"] = this.addToMain;
        data["addToMainEpic"] = this.addToMainEpic;
        return data;
    }
}

export interface IUIControllerModel {
    copyMapMerge: boolean;
    addToMain: boolean;
    addToMainEpic: boolean;
}

export class MergeTableModel implements IMergeTableModel {
    stage?: string | undefined;
    length!: number;
    addToMain!: boolean;
    code!: boolean;

    constructor(data?: IMergeTableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stage = _data["stage"];
            this.length = _data["length"];
            this.addToMain = _data["addToMain"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): MergeTableModel {
        data = typeof data === 'object' ? data : {};
        let result = new MergeTableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage;
        data["length"] = this.length;
        data["addToMain"] = this.addToMain;
        data["code"] = this.code;
        return data;
    }
}

export interface IMergeTableModel {
    stage?: string | undefined;
    length: number;
    addToMain: boolean;
    code: boolean;
}

export class ProjectClassificationModel implements IProjectClassificationModel {
    id!: string;
    description?: string | undefined;
    retentionDays!: number;

    constructor(data?: IProjectClassificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.retentionDays = _data["retentionDays"];
        }
    }

    static fromJS(data: any): ProjectClassificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectClassificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["retentionDays"] = this.retentionDays;
        return data;
    }
}

export interface IProjectClassificationModel {
    id: string;
    description?: string | undefined;
    retentionDays: number;
}

export class ConversionOptionModel implements IConversionOptionModel {
    values?: ConversionOptionEnumModel[] | undefined;
    id!: string;
    name?: string | undefined;
    defaultValue?: string | undefined;
    type!: ConversionOptionType;
    isHidden!: boolean;
    isRequired!: boolean;
    conversionTypeId!: string;
    order!: number;

    constructor(data?: IConversionOptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ConversionOptionEnumModel.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.defaultValue = _data["defaultValue"];
            this.type = _data["type"];
            this.isHidden = _data["isHidden"];
            this.isRequired = _data["isRequired"];
            this.conversionTypeId = _data["conversionTypeId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): ConversionOptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionOptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["defaultValue"] = this.defaultValue;
        data["type"] = this.type;
        data["isHidden"] = this.isHidden;
        data["isRequired"] = this.isRequired;
        data["conversionTypeId"] = this.conversionTypeId;
        data["order"] = this.order;
        return data;
    }
}

export interface IConversionOptionModel {
    values?: ConversionOptionEnumModel[] | undefined;
    id: string;
    name?: string | undefined;
    defaultValue?: string | undefined;
    type: ConversionOptionType;
    isHidden: boolean;
    isRequired: boolean;
    conversionTypeId: string;
    order: number;
}

export class ConversionOptionEnumModel implements IConversionOptionEnumModel {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IConversionOptionEnumModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ConversionOptionEnumModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionOptionEnumModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IConversionOptionEnumModel {
    name?: string | undefined;
    value?: string | undefined;
}

export enum ConversionOptionType {
    Text = 1,
    Date = 2,
    List = 3,
    Radio = 4,
}

export class OptionCustomizationModel implements IOptionCustomizationModel {
    kind!: OptionCustomizationKind;
    details?: any | undefined;

    constructor(data?: IOptionCustomizationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): OptionCustomizationModel {
        data = typeof data === 'object' ? data : {};
        let result = new OptionCustomizationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["details"] = this.details;
        return data;
    }
}

export interface IOptionCustomizationModel {
    kind: OptionCustomizationKind;
    details?: any | undefined;
}

export enum OptionCustomizationKind {
    MakeNotRequiredIfZero = 0,
}

export class ConversionOptionValueModel extends BaseEntityModel implements IConversionOptionValueModel {
    conversionId!: string;
    value?: string | undefined;
    isLocked!: boolean;

    constructor(data?: IConversionOptionValueModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.conversionId = _data["conversionId"];
            this.value = _data["value"];
            this.isLocked = _data["isLocked"];
        }
    }

    static fromJS(data: any): ConversionOptionValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionOptionValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversionId"] = this.conversionId;
        data["value"] = this.value;
        data["isLocked"] = this.isLocked;
        super.toJSON(data);
        return data;
    }
}

export interface IConversionOptionValueModel extends IBaseEntityModel {
    conversionId: string;
    value?: string | undefined;
    isLocked: boolean;
}

export class ConversionReportContentModel implements IConversionReportContentModel {
    entities?: DynamicEntityModel[] | undefined;
    schema?: DynamicEntitySchemaModel | undefined;
    reportGeneratedDate!: Date;

    constructor(data?: IConversionReportContentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(DynamicEntityModel.fromJS(item));
            }
            this.schema = _data["schema"] ? DynamicEntitySchemaModel.fromJS(_data["schema"]) : <any>undefined;
            this.reportGeneratedDate = _data["reportGeneratedDate"] ? new Date(_data["reportGeneratedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConversionReportContentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionReportContentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        data["schema"] = this.schema ? this.schema.toJSON() : <any>undefined;
        data["reportGeneratedDate"] = this.reportGeneratedDate ? this.reportGeneratedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IConversionReportContentModel {
    entities?: DynamicEntityModel[] | undefined;
    schema?: DynamicEntitySchemaModel | undefined;
    reportGeneratedDate: Date;
}

export class DynamicEntityModel implements IDynamicEntityModel {
    values?: any[] | undefined;

    constructor(data?: IDynamicEntityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): DynamicEntityModel {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicEntityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IDynamicEntityModel {
    values?: any[] | undefined;
}

export class DynamicEntitySchemaModel implements IDynamicEntitySchemaModel {
    columns?: DynamicEntitySchemaColumnModel[] | undefined;

    constructor(data?: IDynamicEntitySchemaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(DynamicEntitySchemaColumnModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DynamicEntitySchemaModel {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicEntitySchemaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDynamicEntitySchemaModel {
    columns?: DynamicEntitySchemaColumnModel[] | undefined;
}

export class DynamicEntitySchemaColumnModel implements IDynamicEntitySchemaColumnModel {
    id?: string | undefined;
    name?: string | undefined;
    type!: DynamicEntityColumnType;

    constructor(data?: IDynamicEntitySchemaColumnModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DynamicEntitySchemaColumnModel {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicEntitySchemaColumnModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IDynamicEntitySchemaColumnModel {
    id?: string | undefined;
    name?: string | undefined;
    type: DynamicEntityColumnType;
}

export enum DynamicEntityColumnType {
    String = 0,
    Date = 1,
    Boolean = 2,
    Number = 3,
}

export class ConversionTypeModel extends BaseEntityModel implements IConversionTypeModel {
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: IConversionTypeModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ConversionTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

export interface IConversionTypeModel extends IBaseEntityModel {
    description?: string | undefined;
    isActive: boolean;
}

export class ExecutionsModel extends BaseEntityModel implements IExecutionsModel {
    conversionId!: string;
    userId!: string;
    executionId!: number;
    folderName?: string | undefined;
    projectName?: string | undefined;
    packageName?: string | undefined;
    title?: string | undefined;
    status!: number;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    estimatedFinish?: Date | undefined;
    estimatedFinishEarly?: Date | undefined;
    estimatedFinishLate?: Date | undefined;
    description?: string | undefined;
    isEmailSent!: boolean;
    clientDescription?: string | undefined;
    conversionDescription?: string | undefined;
    epicVersion?: string | undefined;
    epicMode?: string | undefined;
    amsVersion?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IExecutionsModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.conversionId = _data["conversionId"];
            this.userId = _data["userId"];
            this.executionId = _data["executionId"];
            this.folderName = _data["folderName"];
            this.projectName = _data["projectName"];
            this.packageName = _data["packageName"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.estimatedFinish = _data["estimatedFinish"] ? new Date(_data["estimatedFinish"].toString()) : <any>undefined;
            this.estimatedFinishEarly = _data["estimatedFinishEarly"] ? new Date(_data["estimatedFinishEarly"].toString()) : <any>undefined;
            this.estimatedFinishLate = _data["estimatedFinishLate"] ? new Date(_data["estimatedFinishLate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.isEmailSent = _data["isEmailSent"];
            this.clientDescription = _data["clientDescription"];
            this.conversionDescription = _data["conversionDescription"];
            this.epicVersion = _data["epicVersion"];
            this.epicMode = _data["epicMode"];
            this.amsVersion = _data["amsVersion"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ExecutionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversionId"] = this.conversionId;
        data["userId"] = this.userId;
        data["executionId"] = this.executionId;
        data["folderName"] = this.folderName;
        data["projectName"] = this.projectName;
        data["packageName"] = this.packageName;
        data["title"] = this.title;
        data["status"] = this.status;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["estimatedFinish"] = this.estimatedFinish ? this.estimatedFinish.toISOString() : <any>undefined;
        data["estimatedFinishEarly"] = this.estimatedFinishEarly ? this.estimatedFinishEarly.toISOString() : <any>undefined;
        data["estimatedFinishLate"] = this.estimatedFinishLate ? this.estimatedFinishLate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["isEmailSent"] = this.isEmailSent;
        data["clientDescription"] = this.clientDescription;
        data["conversionDescription"] = this.conversionDescription;
        data["epicVersion"] = this.epicVersion;
        data["epicMode"] = this.epicMode;
        data["amsVersion"] = this.amsVersion;
        data["emailAddress"] = this.emailAddress;
        super.toJSON(data);
        return data;
    }
}

export interface IExecutionsModel extends IBaseEntityModel {
    conversionId: string;
    userId: string;
    executionId: number;
    folderName?: string | undefined;
    projectName?: string | undefined;
    packageName?: string | undefined;
    title?: string | undefined;
    status: number;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    estimatedFinish?: Date | undefined;
    estimatedFinishEarly?: Date | undefined;
    estimatedFinishLate?: Date | undefined;
    description?: string | undefined;
    isEmailSent: boolean;
    clientDescription?: string | undefined;
    conversionDescription?: string | undefined;
    epicVersion?: string | undefined;
    epicMode?: string | undefined;
    amsVersion?: string | undefined;
    emailAddress?: string | undefined;
}

export class ExecutionsTierBooleanModel extends BaseEntityModel implements IExecutionsTierBooleanModel {
    tier2!: boolean;
    tier3!: boolean;
    tier4!: boolean;
    tier5!: boolean;

    constructor(data?: IExecutionsTierBooleanModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tier2 = _data["tier2"];
            this.tier3 = _data["tier3"];
            this.tier4 = _data["tier4"];
            this.tier5 = _data["tier5"];
        }
    }

    static fromJS(data: any): ExecutionsTierBooleanModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutionsTierBooleanModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tier2"] = this.tier2;
        data["tier3"] = this.tier3;
        data["tier4"] = this.tier4;
        data["tier5"] = this.tier5;
        super.toJSON(data);
        return data;
    }
}

export interface IExecutionsTierBooleanModel extends IBaseEntityModel {
    tier2: boolean;
    tier3: boolean;
    tier4: boolean;
    tier5: boolean;
}

export class ExecutionsAllTierBooleanModel implements IExecutionsAllTierBooleanModel {
    isLocked!: boolean;

    constructor(data?: IExecutionsAllTierBooleanModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isLocked = _data["isLocked"];
        }
    }

    static fromJS(data: any): ExecutionsAllTierBooleanModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutionsAllTierBooleanModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLocked"] = this.isLocked;
        return data;
    }
}

export interface IExecutionsAllTierBooleanModel {
    isLocked: boolean;
}

export class ExecutionMessagesModel extends BaseEntityModel implements IExecutionMessagesModel {
    executionsId!: string;
    message?: string | undefined;

    constructor(data?: IExecutionMessagesModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.executionsId = _data["executionsId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ExecutionMessagesModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutionMessagesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["executionsId"] = this.executionsId;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface IExecutionMessagesModel extends IBaseEntityModel {
    executionsId: string;
    message?: string | undefined;
}

export class LoggingValuesModel implements ILoggingValuesModel {
    id!: number;
    loggingValue!: number;
    loggingDescription?: string | undefined;

    constructor(data?: ILoggingValuesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.loggingValue = _data["loggingValue"];
            this.loggingDescription = _data["loggingDescription"];
        }
    }

    static fromJS(data: any): LoggingValuesModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoggingValuesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["loggingValue"] = this.loggingValue;
        data["loggingDescription"] = this.loggingDescription;
        return data;
    }
}

export interface ILoggingValuesModel {
    id: number;
    loggingValue: number;
    loggingDescription?: string | undefined;
}

export class FileUploadModel implements IFileUploadModel {
    id!: string;
    conversionId!: string;
    fileUploadTypeId!: string;
    contentType?: string | undefined;
    name?: string | undefined;
    uploadedOn!: Date;
    processingStatus?: string | undefined;

    constructor(data?: IFileUploadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conversionId = _data["conversionId"];
            this.fileUploadTypeId = _data["fileUploadTypeId"];
            this.contentType = _data["contentType"];
            this.name = _data["name"];
            this.uploadedOn = _data["uploadedOn"] ? new Date(_data["uploadedOn"].toString()) : <any>undefined;
            this.processingStatus = _data["processingStatus"];
        }
    }

    static fromJS(data: any): FileUploadModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conversionId"] = this.conversionId;
        data["fileUploadTypeId"] = this.fileUploadTypeId;
        data["contentType"] = this.contentType;
        data["name"] = this.name;
        data["uploadedOn"] = this.uploadedOn ? this.uploadedOn.toISOString() : <any>undefined;
        data["processingStatus"] = this.processingStatus;
        return data;
    }
}

export interface IFileUploadModel {
    id: string;
    conversionId: string;
    fileUploadTypeId: string;
    contentType?: string | undefined;
    name?: string | undefined;
    uploadedOn: Date;
    processingStatus?: string | undefined;
}

export class FileUploadBlobModel implements IFileUploadBlobModel {
    id!: string;
    data?: string | undefined;

    constructor(data?: IFileUploadBlobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): FileUploadBlobModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadBlobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["data"] = this.data;
        return data;
    }
}

export interface IFileUploadBlobModel {
    id: string;
    data?: string | undefined;
}

export class FileUploadPostModel implements IFileUploadPostModel {
    contentType?: string | undefined;
    data?: any | undefined;
    fileUploadTypeId!: string;
    name?: string | undefined;

    constructor(data?: IFileUploadPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentType = _data["contentType"];
            this.data = _data["data"];
            this.fileUploadTypeId = _data["fileUploadTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileUploadPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["data"] = this.data;
        data["fileUploadTypeId"] = this.fileUploadTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface IFileUploadPostModel {
    contentType?: string | undefined;
    data?: any | undefined;
    fileUploadTypeId: string;
    name?: string | undefined;
}

export class FileUploadTypeModel implements IFileUploadTypeModel {
    id!: string;
    description?: string | undefined;

    constructor(data?: IFileUploadTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FileUploadTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IFileUploadTypeModel {
    id: string;
    description?: string | undefined;
}

export class MiniConversionDelayedStartModel implements IMiniConversionDelayedStartModel {
    id?: string | undefined;
    isDelayedStart!: boolean;
    executeAfterTime?: Date | undefined;

    constructor(data?: IMiniConversionDelayedStartModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDelayedStart = _data["isDelayedStart"];
            this.executeAfterTime = _data["executeAfterTime"] ? new Date(_data["executeAfterTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MiniConversionDelayedStartModel {
        data = typeof data === 'object' ? data : {};
        let result = new MiniConversionDelayedStartModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDelayedStart"] = this.isDelayedStart;
        data["executeAfterTime"] = this.executeAfterTime ? this.executeAfterTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMiniConversionDelayedStartModel {
    id?: string | undefined;
    isDelayedStart: boolean;
    executeAfterTime?: Date | undefined;
}

export class MergeMapModel implements IMergeMapModel {
    id!: string;
    agencyNo?: string | undefined;
    code?: string | undefined;
    parentShortName?: string | undefined;
    parentName?: string | undefined;
    parentCoCode?: string | undefined;
    shortName?: string | undefined;
    naic?: string | undefined;
    name?: string | undefined;
    category?: number | undefined;
    categoryDesc?: string | undefined;
    type?: string | undefined;
    mappedValue?: string | undefined;
    mappedValueLast?: string | undefined;
    status?: string | undefined;
    statusRef?: string | undefined;
    referenceId?: string | undefined;
    parentId?: string | undefined;
    clientCount?: number | undefined;
    policyCount?: number | undefined;
    isDrop!: boolean;
    isPrimary!: boolean;
    isUserMapped?: boolean | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isHide?: string | undefined;
    isHideRef?: string | undefined;
    isMappingDefault!: boolean;
    mappedValueType?: string | undefined;

    constructor(data?: IMergeMapModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agencyNo = _data["agencyNo"];
            this.code = _data["code"];
            this.parentShortName = _data["parentShortName"];
            this.parentName = _data["parentName"];
            this.parentCoCode = _data["parentCoCode"];
            this.shortName = _data["shortName"];
            this.naic = _data["naic"];
            this.name = _data["name"];
            this.category = _data["category"];
            this.categoryDesc = _data["categoryDesc"];
            this.type = _data["type"];
            this.mappedValue = _data["mappedValue"];
            this.mappedValueLast = _data["mappedValueLast"];
            this.status = _data["status"];
            this.statusRef = _data["statusRef"];
            this.referenceId = _data["referenceId"];
            this.parentId = _data["parentId"];
            this.clientCount = _data["clientCount"];
            this.policyCount = _data["policyCount"];
            this.isDrop = _data["isDrop"];
            this.isPrimary = _data["isPrimary"];
            this.isUserMapped = _data["isUserMapped"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isHide = _data["isHide"];
            this.isHideRef = _data["isHideRef"];
            this.isMappingDefault = _data["isMappingDefault"];
            this.mappedValueType = _data["mappedValueType"];
        }
    }

    static fromJS(data: any): MergeMapModel {
        data = typeof data === 'object' ? data : {};
        let result = new MergeMapModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agencyNo"] = this.agencyNo;
        data["code"] = this.code;
        data["parentShortName"] = this.parentShortName;
        data["parentName"] = this.parentName;
        data["parentCoCode"] = this.parentCoCode;
        data["shortName"] = this.shortName;
        data["naic"] = this.naic;
        data["name"] = this.name;
        data["category"] = this.category;
        data["categoryDesc"] = this.categoryDesc;
        data["type"] = this.type;
        data["mappedValue"] = this.mappedValue;
        data["mappedValueLast"] = this.mappedValueLast;
        data["status"] = this.status;
        data["statusRef"] = this.statusRef;
        data["referenceId"] = this.referenceId;
        data["parentId"] = this.parentId;
        data["clientCount"] = this.clientCount;
        data["policyCount"] = this.policyCount;
        data["isDrop"] = this.isDrop;
        data["isPrimary"] = this.isPrimary;
        data["isUserMapped"] = this.isUserMapped;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isHide"] = this.isHide;
        data["isHideRef"] = this.isHideRef;
        data["isMappingDefault"] = this.isMappingDefault;
        data["mappedValueType"] = this.mappedValueType;
        return data;
    }
}

export interface IMergeMapModel {
    id: string;
    agencyNo?: string | undefined;
    code?: string | undefined;
    parentShortName?: string | undefined;
    parentName?: string | undefined;
    parentCoCode?: string | undefined;
    shortName?: string | undefined;
    naic?: string | undefined;
    name?: string | undefined;
    category?: number | undefined;
    categoryDesc?: string | undefined;
    type?: string | undefined;
    mappedValue?: string | undefined;
    mappedValueLast?: string | undefined;
    status?: string | undefined;
    statusRef?: string | undefined;
    referenceId?: string | undefined;
    parentId?: string | undefined;
    clientCount?: number | undefined;
    policyCount?: number | undefined;
    isDrop: boolean;
    isPrimary: boolean;
    isUserMapped?: boolean | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isHide?: string | undefined;
    isHideRef?: string | undefined;
    isMappingDefault: boolean;
    mappedValueType?: string | undefined;
}

export class MergeMapRefModel implements IMergeMapRefModel {
    id!: string;
    code?: string | undefined;
    shortName?: string | undefined;
    name?: string | undefined;
    category?: number | undefined;
    status?: string | undefined;
    isHide?: string | undefined;
    type?: string | undefined;
    naic?: string | undefined;
    parentCoCode?: string | undefined;
    parentShortName?: string | undefined;
    parentId?: string | undefined;

    constructor(data?: IMergeMapRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.shortName = _data["shortName"];
            this.name = _data["name"];
            this.category = _data["category"];
            this.status = _data["status"];
            this.isHide = _data["isHide"];
            this.type = _data["type"];
            this.naic = _data["naic"];
            this.parentCoCode = _data["parentCoCode"];
            this.parentShortName = _data["parentShortName"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): MergeMapRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new MergeMapRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["shortName"] = this.shortName;
        data["name"] = this.name;
        data["category"] = this.category;
        data["status"] = this.status;
        data["isHide"] = this.isHide;
        data["type"] = this.type;
        data["naic"] = this.naic;
        data["parentCoCode"] = this.parentCoCode;
        data["parentShortName"] = this.parentShortName;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IMergeMapRefModel {
    id: string;
    code?: string | undefined;
    shortName?: string | undefined;
    name?: string | undefined;
    category?: number | undefined;
    status?: string | undefined;
    isHide?: string | undefined;
    type?: string | undefined;
    naic?: string | undefined;
    parentCoCode?: string | undefined;
    parentShortName?: string | undefined;
    parentId?: string | undefined;
}

export class StageTablesModel implements IStageTablesModel {
    name?: string | undefined;
    columnTake!: number;

    constructor(data?: IStageTablesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.columnTake = _data["columnTake"];
        }
    }

    static fromJS(data: any): StageTablesModel {
        data = typeof data === 'object' ? data : {};
        let result = new StageTablesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["columnTake"] = this.columnTake;
        return data;
    }
}

export interface IStageTablesModel {
    name?: string | undefined;
    columnTake: number;
}

export class MergeMapLogModel implements IMergeMapLogModel {
    tableName?: string | undefined;
    mapCount!: number;
    totalCount!: number;
    percentMapped?: number | undefined;

    constructor(data?: IMergeMapLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableName = _data["tableName"];
            this.mapCount = _data["mapCount"];
            this.totalCount = _data["totalCount"];
            this.percentMapped = _data["percentMapped"];
        }
    }

    static fromJS(data: any): MergeMapLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new MergeMapLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["mapCount"] = this.mapCount;
        data["totalCount"] = this.totalCount;
        data["percentMapped"] = this.percentMapped;
        return data;
    }
}

export interface IMergeMapLogModel {
    tableName?: string | undefined;
    mapCount: number;
    totalCount: number;
    percentMapped?: number | undefined;
}

export class TimingsModel extends BaseEntityModel implements ITimingsModel {
    mergeRunId?: string | undefined;
    logSequenceId!: number;
    action?: string | undefined;
    agencyNo?: string | undefined;
    tableName?: string | undefined;
    recordCount?: number | undefined;
    startTimestamp?: Date | undefined;
    finishTimestamp?: Date | undefined;
    executionTimeInMilliseconds?: number | undefined;
    isRunning?: number | undefined;
    status?: number | undefined;
    mergeSequenceId!: number;

    constructor(data?: ITimingsModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mergeRunId = _data["mergeRunId"];
            this.logSequenceId = _data["logSequenceId"];
            this.action = _data["action"];
            this.agencyNo = _data["agencyNo"];
            this.tableName = _data["tableName"];
            this.recordCount = _data["recordCount"];
            this.startTimestamp = _data["startTimestamp"] ? new Date(_data["startTimestamp"].toString()) : <any>undefined;
            this.finishTimestamp = _data["finishTimestamp"] ? new Date(_data["finishTimestamp"].toString()) : <any>undefined;
            this.executionTimeInMilliseconds = _data["executionTimeInMilliseconds"];
            this.isRunning = _data["isRunning"];
            this.status = _data["status"];
            this.mergeSequenceId = _data["mergeSequenceId"];
        }
    }

    static fromJS(data: any): TimingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mergeRunId"] = this.mergeRunId;
        data["logSequenceId"] = this.logSequenceId;
        data["action"] = this.action;
        data["agencyNo"] = this.agencyNo;
        data["tableName"] = this.tableName;
        data["recordCount"] = this.recordCount;
        data["startTimestamp"] = this.startTimestamp ? this.startTimestamp.toISOString() : <any>undefined;
        data["finishTimestamp"] = this.finishTimestamp ? this.finishTimestamp.toISOString() : <any>undefined;
        data["executionTimeInMilliseconds"] = this.executionTimeInMilliseconds;
        data["isRunning"] = this.isRunning;
        data["status"] = this.status;
        data["mergeSequenceId"] = this.mergeSequenceId;
        super.toJSON(data);
        return data;
    }
}

export interface ITimingsModel extends IBaseEntityModel {
    mergeRunId?: string | undefined;
    logSequenceId: number;
    action?: string | undefined;
    agencyNo?: string | undefined;
    tableName?: string | undefined;
    recordCount?: number | undefined;
    startTimestamp?: Date | undefined;
    finishTimestamp?: Date | undefined;
    executionTimeInMilliseconds?: number | undefined;
    isRunning?: number | undefined;
    status?: number | undefined;
    mergeSequenceId: number;
}

export class CurrentMergeModel implements ICurrentMergeModel {
    id?: string | undefined;
    sequenceNumber!: number;
    mapStartTimestamp?: Date | undefined;
    mapFinishTimestamp?: Date | undefined;
    mapFailed!: boolean;
    stageStartTimestamp?: Date | undefined;
    stageFinishTimestamp?: Date | undefined;
    stageFailed!: boolean;
    validateStartTimestamp?: Date | undefined;
    validateFinishTimestamp?: Date | undefined;
    validateFailed!: boolean;
    loadStartTimestamp?: Date | undefined;
    loadFinishTimestamp?: Date | undefined;
    loadFailed!: boolean;
    rollbackStartTimestamp?: Date | undefined;
    rollbackFinishTimestamp?: Date | undefined;
    rollbackFailed!: boolean;
    reportStartTimestamp?: Date | undefined;
    reportFinishTimestamp?: Date | undefined;
    reportFailed!: boolean;
    clearFailureLock!: boolean;
    hasError!: boolean;
    isLocked!: boolean;
    wasRolledBack!: boolean;

    constructor(data?: ICurrentMergeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.mapStartTimestamp = _data["mapStartTimestamp"] ? new Date(_data["mapStartTimestamp"].toString()) : <any>undefined;
            this.mapFinishTimestamp = _data["mapFinishTimestamp"] ? new Date(_data["mapFinishTimestamp"].toString()) : <any>undefined;
            this.mapFailed = _data["mapFailed"];
            this.stageStartTimestamp = _data["stageStartTimestamp"] ? new Date(_data["stageStartTimestamp"].toString()) : <any>undefined;
            this.stageFinishTimestamp = _data["stageFinishTimestamp"] ? new Date(_data["stageFinishTimestamp"].toString()) : <any>undefined;
            this.stageFailed = _data["stageFailed"];
            this.validateStartTimestamp = _data["validateStartTimestamp"] ? new Date(_data["validateStartTimestamp"].toString()) : <any>undefined;
            this.validateFinishTimestamp = _data["validateFinishTimestamp"] ? new Date(_data["validateFinishTimestamp"].toString()) : <any>undefined;
            this.validateFailed = _data["validateFailed"];
            this.loadStartTimestamp = _data["loadStartTimestamp"] ? new Date(_data["loadStartTimestamp"].toString()) : <any>undefined;
            this.loadFinishTimestamp = _data["loadFinishTimestamp"] ? new Date(_data["loadFinishTimestamp"].toString()) : <any>undefined;
            this.loadFailed = _data["loadFailed"];
            this.rollbackStartTimestamp = _data["rollbackStartTimestamp"] ? new Date(_data["rollbackStartTimestamp"].toString()) : <any>undefined;
            this.rollbackFinishTimestamp = _data["rollbackFinishTimestamp"] ? new Date(_data["rollbackFinishTimestamp"].toString()) : <any>undefined;
            this.rollbackFailed = _data["rollbackFailed"];
            this.reportStartTimestamp = _data["reportStartTimestamp"] ? new Date(_data["reportStartTimestamp"].toString()) : <any>undefined;
            this.reportFinishTimestamp = _data["reportFinishTimestamp"] ? new Date(_data["reportFinishTimestamp"].toString()) : <any>undefined;
            this.reportFailed = _data["reportFailed"];
            this.clearFailureLock = _data["clearFailureLock"];
            this.hasError = _data["hasError"];
            this.isLocked = _data["isLocked"];
            this.wasRolledBack = _data["wasRolledBack"];
        }
    }

    static fromJS(data: any): CurrentMergeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentMergeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequenceNumber"] = this.sequenceNumber;
        data["mapStartTimestamp"] = this.mapStartTimestamp ? this.mapStartTimestamp.toISOString() : <any>undefined;
        data["mapFinishTimestamp"] = this.mapFinishTimestamp ? this.mapFinishTimestamp.toISOString() : <any>undefined;
        data["mapFailed"] = this.mapFailed;
        data["stageStartTimestamp"] = this.stageStartTimestamp ? this.stageStartTimestamp.toISOString() : <any>undefined;
        data["stageFinishTimestamp"] = this.stageFinishTimestamp ? this.stageFinishTimestamp.toISOString() : <any>undefined;
        data["stageFailed"] = this.stageFailed;
        data["validateStartTimestamp"] = this.validateStartTimestamp ? this.validateStartTimestamp.toISOString() : <any>undefined;
        data["validateFinishTimestamp"] = this.validateFinishTimestamp ? this.validateFinishTimestamp.toISOString() : <any>undefined;
        data["validateFailed"] = this.validateFailed;
        data["loadStartTimestamp"] = this.loadStartTimestamp ? this.loadStartTimestamp.toISOString() : <any>undefined;
        data["loadFinishTimestamp"] = this.loadFinishTimestamp ? this.loadFinishTimestamp.toISOString() : <any>undefined;
        data["loadFailed"] = this.loadFailed;
        data["rollbackStartTimestamp"] = this.rollbackStartTimestamp ? this.rollbackStartTimestamp.toISOString() : <any>undefined;
        data["rollbackFinishTimestamp"] = this.rollbackFinishTimestamp ? this.rollbackFinishTimestamp.toISOString() : <any>undefined;
        data["rollbackFailed"] = this.rollbackFailed;
        data["reportStartTimestamp"] = this.reportStartTimestamp ? this.reportStartTimestamp.toISOString() : <any>undefined;
        data["reportFinishTimestamp"] = this.reportFinishTimestamp ? this.reportFinishTimestamp.toISOString() : <any>undefined;
        data["reportFailed"] = this.reportFailed;
        data["clearFailureLock"] = this.clearFailureLock;
        data["hasError"] = this.hasError;
        data["isLocked"] = this.isLocked;
        data["wasRolledBack"] = this.wasRolledBack;
        return data;
    }
}

export interface ICurrentMergeModel {
    id?: string | undefined;
    sequenceNumber: number;
    mapStartTimestamp?: Date | undefined;
    mapFinishTimestamp?: Date | undefined;
    mapFailed: boolean;
    stageStartTimestamp?: Date | undefined;
    stageFinishTimestamp?: Date | undefined;
    stageFailed: boolean;
    validateStartTimestamp?: Date | undefined;
    validateFinishTimestamp?: Date | undefined;
    validateFailed: boolean;
    loadStartTimestamp?: Date | undefined;
    loadFinishTimestamp?: Date | undefined;
    loadFailed: boolean;
    rollbackStartTimestamp?: Date | undefined;
    rollbackFinishTimestamp?: Date | undefined;
    rollbackFailed: boolean;
    reportStartTimestamp?: Date | undefined;
    reportFinishTimestamp?: Date | undefined;
    reportFailed: boolean;
    clearFailureLock: boolean;
    hasError: boolean;
    isLocked: boolean;
    wasRolledBack: boolean;
}

export class ActionTypeModel implements IActionTypeModel {
    id!: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    isDrop!: boolean;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IActionTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.destinationCode = _data["destinationCode"];
            this.isDrop = _data["isDrop"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): ActionTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActionTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["destinationCode"] = this.destinationCode;
        data["isDrop"] = this.isDrop;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IActionTypeModel {
    id: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    isDrop: boolean;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class ActionTypeRefModel implements IActionTypeRefModel {
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    isHide?: string | undefined;

    constructor(data?: IActionTypeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.isHide = _data["isHide"];
        }
    }

    static fromJS(data: any): ActionTypeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActionTypeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["isHide"] = this.isHide;
        return data;
    }
}

export interface IActionTypeRefModel {
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    isHide?: string | undefined;
}

export class ActivitiesMiniConversionModel implements IActivitiesMiniConversionModel {
    rowNumber!: number;
    customerRefNum?: string | undefined;
    policyRefNum?: string | undefined;
    transactionDate?: string | undefined;
    employeeCode?: string | undefined;
    action?: string | undefined;
    description?: string | undefined;
    fileName?: string | undefined;
    timeStamp!: Date;

    constructor(data?: IActivitiesMiniConversionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.customerRefNum = _data["customerRefNum"];
            this.policyRefNum = _data["policyRefNum"];
            this.transactionDate = _data["transactionDate"];
            this.employeeCode = _data["employeeCode"];
            this.action = _data["action"];
            this.description = _data["description"];
            this.fileName = _data["fileName"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivitiesMiniConversionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitiesMiniConversionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["customerRefNum"] = this.customerRefNum;
        data["policyRefNum"] = this.policyRefNum;
        data["transactionDate"] = this.transactionDate;
        data["employeeCode"] = this.employeeCode;
        data["action"] = this.action;
        data["description"] = this.description;
        data["fileName"] = this.fileName;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IActivitiesMiniConversionModel {
    rowNumber: number;
    customerRefNum?: string | undefined;
    policyRefNum?: string | undefined;
    transactionDate?: string | undefined;
    employeeCode?: string | undefined;
    action?: string | undefined;
    description?: string | undefined;
    fileName?: string | undefined;
    timeStamp: Date;
}

export class ActivitiesMiniConversionCountModel implements IActivitiesMiniConversionCountModel {
    recordsCount!: number;

    constructor(data?: IActivitiesMiniConversionCountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsCount = _data["recordsCount"];
        }
    }

    static fromJS(data: any): ActivitiesMiniConversionCountModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitiesMiniConversionCountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsCount"] = this.recordsCount;
        return data;
    }
}

export interface IActivitiesMiniConversionCountModel {
    recordsCount: number;
}

export class ActivitiesMiniConversionValidationResultsModel implements IActivitiesMiniConversionValidationResultsModel {
    errorCount!: number;
    warningCount!: number;
    infoCount!: number;

    constructor(data?: IActivitiesMiniConversionValidationResultsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCount = _data["errorCount"];
            this.warningCount = _data["warningCount"];
            this.infoCount = _data["infoCount"];
        }
    }

    static fromJS(data: any): ActivitiesMiniConversionValidationResultsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitiesMiniConversionValidationResultsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCount"] = this.errorCount;
        data["warningCount"] = this.warningCount;
        data["infoCount"] = this.infoCount;
        return data;
    }
}

export interface IActivitiesMiniConversionValidationResultsModel {
    errorCount: number;
    warningCount: number;
    infoCount: number;
}

export class BranchModel implements IBranchModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop!: boolean;
    isPrimary?: boolean | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IBranchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.isDrop = _data["isDrop"];
            this.isPrimary = _data["isPrimary"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): BranchModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["isDrop"] = this.isDrop;
        data["isPrimary"] = this.isPrimary;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IBranchModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop: boolean;
    isPrimary?: boolean | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class BranchRefModel implements IBranchRefModel {
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;

    constructor(data?: IBranchRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): BranchRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface IBranchRefModel {
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
}

export class BrokerModel implements IBrokerModel {
    id!: string;
    sourceId!: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    isNetCommission?: boolean | undefined;
    isCompany?: boolean | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    clientCount!: number;
    policyCount!: number;
    isMapped!: boolean;
    isDrop!: boolean;
    isPrimary!: boolean;
    isAddToMain!: boolean;
    isUserMapped!: boolean;
    rowVersion?: string | undefined;

    constructor(data?: IBrokerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.isNetCommission = _data["isNetCommission"];
            this.isCompany = _data["isCompany"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.clientCount = _data["clientCount"];
            this.policyCount = _data["policyCount"];
            this.isMapped = _data["isMapped"];
            this.isDrop = _data["isDrop"];
            this.isPrimary = _data["isPrimary"];
            this.isAddToMain = _data["isAddToMain"];
            this.isUserMapped = _data["isUserMapped"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): BrokerModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrokerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["isNetCommission"] = this.isNetCommission;
        data["isCompany"] = this.isCompany;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["clientCount"] = this.clientCount;
        data["policyCount"] = this.policyCount;
        data["isMapped"] = this.isMapped;
        data["isDrop"] = this.isDrop;
        data["isPrimary"] = this.isPrimary;
        data["isAddToMain"] = this.isAddToMain;
        data["isUserMapped"] = this.isUserMapped;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IBrokerModel {
    id: string;
    sourceId: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    isNetCommission?: boolean | undefined;
    isCompany?: boolean | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    clientCount: number;
    policyCount: number;
    isMapped: boolean;
    isDrop: boolean;
    isPrimary: boolean;
    isAddToMain: boolean;
    isUserMapped: boolean;
    rowVersion?: string | undefined;
}

export class BrokerRefModel implements IBrokerRefModel {
    sourceCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    isNetCommission!: boolean;
    isCompany!: boolean;

    constructor(data?: IBrokerRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.isNetCommission = _data["isNetCommission"];
            this.isCompany = _data["isCompany"];
        }
    }

    static fromJS(data: any): BrokerRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrokerRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["isNetCommission"] = this.isNetCommission;
        data["isCompany"] = this.isCompany;
        return data;
    }
}

export interface IBrokerRefModel {
    sourceCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    isNetCommission: boolean;
    isCompany: boolean;
}

export class ClaimTypeModel implements IClaimTypeModel {
    id!: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    isUserDrop!: boolean;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IClaimTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.destinationCode = _data["destinationCode"];
            this.isUserDrop = _data["isUserDrop"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): ClaimTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["destinationCode"] = this.destinationCode;
        data["isUserDrop"] = this.isUserDrop;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IClaimTypeModel {
    id: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    isUserDrop: boolean;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class ClaimTypeRefModel implements IClaimTypeRefModel {
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;

    constructor(data?: IClaimTypeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): ClaimTypeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimTypeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface IClaimTypeRefModel {
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
}

export class ClientMergeModel implements IClientMergeModel {
    id!: string;
    rowNumber!: number;
    clientCode?: string | undefined;
    mergeIntoCode?: string | undefined;

    constructor(data?: IClientMergeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowNumber = _data["rowNumber"];
            this.clientCode = _data["clientCode"];
            this.mergeIntoCode = _data["mergeIntoCode"];
        }
    }

    static fromJS(data: any): ClientMergeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientMergeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowNumber"] = this.rowNumber;
        data["clientCode"] = this.clientCode;
        data["mergeIntoCode"] = this.mergeIntoCode;
        return data;
    }
}

export interface IClientMergeModel {
    id: string;
    rowNumber: number;
    clientCode?: string | undefined;
    mergeIntoCode?: string | undefined;
}

export class CompanyModel implements ICompanyModel {
    id!: number;
    parentSourceCode?: string | undefined;
    parentSourceDescription?: string | undefined;
    parentNaic?: string | undefined;
    companyCount!: number;
    writingSourceCode?: string | undefined;
    writingSourceDescription?: string | undefined;
    writingNaic?: string | undefined;
    referenceId?: number | undefined;
    parentReferenceId?: number | undefined;
    parentDestinationCode?: string | undefined;
    parentDestinationDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    parentCode?: string | undefined;
    parentId?: number | undefined;
    parentTypeId!: number;
    isDrop!: boolean;
    isPrimary?: boolean | undefined;
    parentIsPrimary?: boolean | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    typeId!: number;
    isUserMapped!: boolean;

    constructor(data?: ICompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentSourceCode = _data["parentSourceCode"];
            this.parentSourceDescription = _data["parentSourceDescription"];
            this.parentNaic = _data["parentNaic"];
            this.companyCount = _data["companyCount"];
            this.writingSourceCode = _data["writingSourceCode"];
            this.writingSourceDescription = _data["writingSourceDescription"];
            this.writingNaic = _data["writingNaic"];
            this.referenceId = _data["referenceId"];
            this.parentReferenceId = _data["parentReferenceId"];
            this.parentDestinationCode = _data["parentDestinationCode"];
            this.parentDestinationDescription = _data["parentDestinationDescription"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.parentCode = _data["parentCode"];
            this.parentId = _data["parentId"];
            this.parentTypeId = _data["parentTypeId"];
            this.isDrop = _data["isDrop"];
            this.isPrimary = _data["isPrimary"];
            this.parentIsPrimary = _data["parentIsPrimary"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.typeId = _data["typeId"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): CompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentSourceCode"] = this.parentSourceCode;
        data["parentSourceDescription"] = this.parentSourceDescription;
        data["parentNaic"] = this.parentNaic;
        data["companyCount"] = this.companyCount;
        data["writingSourceCode"] = this.writingSourceCode;
        data["writingSourceDescription"] = this.writingSourceDescription;
        data["writingNaic"] = this.writingNaic;
        data["referenceId"] = this.referenceId;
        data["parentReferenceId"] = this.parentReferenceId;
        data["parentDestinationCode"] = this.parentDestinationCode;
        data["parentDestinationDescription"] = this.parentDestinationDescription;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["parentCode"] = this.parentCode;
        data["parentId"] = this.parentId;
        data["parentTypeId"] = this.parentTypeId;
        data["isDrop"] = this.isDrop;
        data["isPrimary"] = this.isPrimary;
        data["parentIsPrimary"] = this.parentIsPrimary;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["typeId"] = this.typeId;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface ICompanyModel {
    id: number;
    parentSourceCode?: string | undefined;
    parentSourceDescription?: string | undefined;
    parentNaic?: string | undefined;
    companyCount: number;
    writingSourceCode?: string | undefined;
    writingSourceDescription?: string | undefined;
    writingNaic?: string | undefined;
    referenceId?: number | undefined;
    parentReferenceId?: number | undefined;
    parentDestinationCode?: string | undefined;
    parentDestinationDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    parentCode?: string | undefined;
    parentId?: number | undefined;
    parentTypeId: number;
    isDrop: boolean;
    isPrimary?: boolean | undefined;
    parentIsPrimary?: boolean | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    typeId: number;
    isUserMapped: boolean;
}

export class CompanyRefModel implements ICompanyRefModel {
    id!: number;
    code?: string | undefined;
    parentCode?: string | undefined;
    typeId!: number;
    shortName?: string | undefined;
    name?: string | undefined;
    naic?: string | undefined;

    constructor(data?: ICompanyRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.parentCode = _data["parentCode"];
            this.typeId = _data["typeId"];
            this.shortName = _data["shortName"];
            this.name = _data["name"];
            this.naic = _data["naic"];
        }
    }

    static fromJS(data: any): CompanyRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["parentCode"] = this.parentCode;
        data["typeId"] = this.typeId;
        data["shortName"] = this.shortName;
        data["name"] = this.name;
        data["naic"] = this.naic;
        return data;
    }
}

export interface ICompanyRefModel {
    id: number;
    code?: string | undefined;
    parentCode?: string | undefined;
    typeId: number;
    shortName?: string | undefined;
    name?: string | undefined;
    naic?: string | undefined;
}

export class CompanyTypeRefModel implements ICompanyTypeRefModel {
    id!: number;
    description?: string | undefined;
    code!: string;

    constructor(data?: ICompanyTypeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CompanyTypeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyTypeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["code"] = this.code;
        return data;
    }
}

export interface ICompanyTypeRefModel {
    id: number;
    description?: string | undefined;
    code: string;
}

export class UniqueModel implements IUniqueModel {
    uniqueCode!: boolean;
    uniqueNAIC!: boolean;
    uniqueName!: boolean;

    constructor(data?: IUniqueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueCode = _data["uniqueCode"];
            this.uniqueNAIC = _data["uniqueNAIC"];
            this.uniqueName = _data["uniqueName"];
        }
    }

    static fromJS(data: any): UniqueModel {
        data = typeof data === 'object' ? data : {};
        let result = new UniqueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueCode"] = this.uniqueCode;
        data["uniqueNAIC"] = this.uniqueNAIC;
        data["uniqueName"] = this.uniqueName;
        return data;
    }
}

export interface IUniqueModel {
    uniqueCode: boolean;
    uniqueNAIC: boolean;
    uniqueName: boolean;
}

export class ContactsMiniConversionModel implements IContactsMiniConversionModel {
    rowNumber!: number;
    customerRefNum?: string | undefined;
    name?: string | undefined;
    responsibilities?: string | undefined;
    title?: string | undefined;
    officer?: string | undefined;
    director?: string | undefined;
    displayOnOverviewPage?: string | undefined;
    preferredMethod?: string | undefined;
    notes?: string | undefined;
    formal?: string | undefined;
    informal?: string | undefined;
    residence?: string | undefined;
    residenceExt?: string | undefined;
    business?: string | undefined;
    businessExt?: string | undefined;
    fax?: string | undefined;
    faxExt?: string | undefined;
    cell?: string | undefined;
    cellExt?: string | undefined;
    pager?: string | undefined;
    pagerExt?: string | undefined;
    email?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    zip?: string | undefined;
    county?: string | undefined;
    fileName?: string | undefined;
    timeStamp!: Date;

    constructor(data?: IContactsMiniConversionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.customerRefNum = _data["customerRefNum"];
            this.name = _data["name"];
            this.responsibilities = _data["responsibilities"];
            this.title = _data["title"];
            this.officer = _data["officer"];
            this.director = _data["director"];
            this.displayOnOverviewPage = _data["displayOnOverviewPage"];
            this.preferredMethod = _data["preferredMethod"];
            this.notes = _data["notes"];
            this.formal = _data["formal"];
            this.informal = _data["informal"];
            this.residence = _data["residence"];
            this.residenceExt = _data["residenceExt"];
            this.business = _data["business"];
            this.businessExt = _data["businessExt"];
            this.fax = _data["fax"];
            this.faxExt = _data["faxExt"];
            this.cell = _data["cell"];
            this.cellExt = _data["cellExt"];
            this.pager = _data["pager"];
            this.pagerExt = _data["pagerExt"];
            this.email = _data["email"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.zip = _data["zip"];
            this.county = _data["county"];
            this.fileName = _data["fileName"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactsMiniConversionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsMiniConversionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["customerRefNum"] = this.customerRefNum;
        data["name"] = this.name;
        data["responsibilities"] = this.responsibilities;
        data["title"] = this.title;
        data["officer"] = this.officer;
        data["director"] = this.director;
        data["displayOnOverviewPage"] = this.displayOnOverviewPage;
        data["preferredMethod"] = this.preferredMethod;
        data["notes"] = this.notes;
        data["formal"] = this.formal;
        data["informal"] = this.informal;
        data["residence"] = this.residence;
        data["residenceExt"] = this.residenceExt;
        data["business"] = this.business;
        data["businessExt"] = this.businessExt;
        data["fax"] = this.fax;
        data["faxExt"] = this.faxExt;
        data["cell"] = this.cell;
        data["cellExt"] = this.cellExt;
        data["pager"] = this.pager;
        data["pagerExt"] = this.pagerExt;
        data["email"] = this.email;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["zip"] = this.zip;
        data["county"] = this.county;
        data["fileName"] = this.fileName;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IContactsMiniConversionModel {
    rowNumber: number;
    customerRefNum?: string | undefined;
    name?: string | undefined;
    responsibilities?: string | undefined;
    title?: string | undefined;
    officer?: string | undefined;
    director?: string | undefined;
    displayOnOverviewPage?: string | undefined;
    preferredMethod?: string | undefined;
    notes?: string | undefined;
    formal?: string | undefined;
    informal?: string | undefined;
    residence?: string | undefined;
    residenceExt?: string | undefined;
    business?: string | undefined;
    businessExt?: string | undefined;
    fax?: string | undefined;
    faxExt?: string | undefined;
    cell?: string | undefined;
    cellExt?: string | undefined;
    pager?: string | undefined;
    pagerExt?: string | undefined;
    email?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    zip?: string | undefined;
    county?: string | undefined;
    fileName?: string | undefined;
    timeStamp: Date;
}

export class ContactsMiniConversionCountModel implements IContactsMiniConversionCountModel {
    recordsCount!: number;

    constructor(data?: IContactsMiniConversionCountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsCount = _data["recordsCount"];
        }
    }

    static fromJS(data: any): ContactsMiniConversionCountModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsMiniConversionCountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsCount"] = this.recordsCount;
        return data;
    }
}

export interface IContactsMiniConversionCountModel {
    recordsCount: number;
}

export class ContactsMiniConversionValidationResultsModel implements IContactsMiniConversionValidationResultsModel {
    errorCount!: number;
    warningCount!: number;
    infoCount!: number;

    constructor(data?: IContactsMiniConversionValidationResultsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCount = _data["errorCount"];
            this.warningCount = _data["warningCount"];
            this.infoCount = _data["infoCount"];
        }
    }

    static fromJS(data: any): ContactsMiniConversionValidationResultsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsMiniConversionValidationResultsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCount"] = this.errorCount;
        data["warningCount"] = this.warningCount;
        data["infoCount"] = this.infoCount;
        return data;
    }
}

export interface IContactsMiniConversionValidationResultsModel {
    errorCount: number;
    warningCount: number;
    infoCount: number;
}

export class CustomerAcquisitionCodeModel implements ICustomerAcquisitionCodeModel {
    id!: string;
    rowNumber!: number;
    sourceCode?: string | undefined;
    acquisitionCode?: string | undefined;
    acquisitionDescription?: string | undefined;

    constructor(data?: ICustomerAcquisitionCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowNumber = _data["rowNumber"];
            this.sourceCode = _data["sourceCode"];
            this.acquisitionCode = _data["acquisitionCode"];
            this.acquisitionDescription = _data["acquisitionDescription"];
        }
    }

    static fromJS(data: any): CustomerAcquisitionCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAcquisitionCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowNumber"] = this.rowNumber;
        data["sourceCode"] = this.sourceCode;
        data["acquisitionCode"] = this.acquisitionCode;
        data["acquisitionDescription"] = this.acquisitionDescription;
        return data;
    }
}

export interface ICustomerAcquisitionCodeModel {
    id: string;
    rowNumber: number;
    sourceCode?: string | undefined;
    acquisitionCode?: string | undefined;
    acquisitionDescription?: string | undefined;
}

export class CustomersMiniConversionModel implements ICustomersMiniConversionModel {
    rowNumber!: number;
    customerRefNum?: string | undefined;
    firmName?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    email?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    dob?: string | undefined;
    division?: string | undefined;
    branch?: string | undefined;
    department?: string | undefined;
    group?: string | undefined;
    exec?: string | undefined;
    rep?: string | undefined;
    broker?: string | undefined;
    resPhone?: string | undefined;
    busPhone?: string | undefined;
    sic?: string | undefined;
    naics?: string | undefined;
    formalSal?: string | undefined;
    informalSal?: string | undefined;
    personal?: string | undefined;
    commercial?: string | undefined;
    financial?: string | undefined;
    health?: string | undefined;
    life?: string | undefined;
    nonPropCas?: string | undefined;
    benefits?: string | undefined;
    fileName?: string | undefined;
    timeStamp!: Date;

    constructor(data?: ICustomersMiniConversionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.customerRefNum = _data["customerRefNum"];
            this.firmName = _data["firmName"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.dob = _data["dob"];
            this.division = _data["division"];
            this.branch = _data["branch"];
            this.department = _data["department"];
            this.group = _data["group"];
            this.exec = _data["exec"];
            this.rep = _data["rep"];
            this.broker = _data["broker"];
            this.resPhone = _data["resPhone"];
            this.busPhone = _data["busPhone"];
            this.sic = _data["sic"];
            this.naics = _data["naics"];
            this.formalSal = _data["formalSal"];
            this.informalSal = _data["informalSal"];
            this.personal = _data["personal"];
            this.commercial = _data["commercial"];
            this.financial = _data["financial"];
            this.health = _data["health"];
            this.life = _data["life"];
            this.nonPropCas = _data["nonPropCas"];
            this.benefits = _data["benefits"];
            this.fileName = _data["fileName"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomersMiniConversionModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersMiniConversionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["customerRefNum"] = this.customerRefNum;
        data["firmName"] = this.firmName;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["dob"] = this.dob;
        data["division"] = this.division;
        data["branch"] = this.branch;
        data["department"] = this.department;
        data["group"] = this.group;
        data["exec"] = this.exec;
        data["rep"] = this.rep;
        data["broker"] = this.broker;
        data["resPhone"] = this.resPhone;
        data["busPhone"] = this.busPhone;
        data["sic"] = this.sic;
        data["naics"] = this.naics;
        data["formalSal"] = this.formalSal;
        data["informalSal"] = this.informalSal;
        data["personal"] = this.personal;
        data["commercial"] = this.commercial;
        data["financial"] = this.financial;
        data["health"] = this.health;
        data["life"] = this.life;
        data["nonPropCas"] = this.nonPropCas;
        data["benefits"] = this.benefits;
        data["fileName"] = this.fileName;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomersMiniConversionModel {
    rowNumber: number;
    customerRefNum?: string | undefined;
    firmName?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    email?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    dob?: string | undefined;
    division?: string | undefined;
    branch?: string | undefined;
    department?: string | undefined;
    group?: string | undefined;
    exec?: string | undefined;
    rep?: string | undefined;
    broker?: string | undefined;
    resPhone?: string | undefined;
    busPhone?: string | undefined;
    sic?: string | undefined;
    naics?: string | undefined;
    formalSal?: string | undefined;
    informalSal?: string | undefined;
    personal?: string | undefined;
    commercial?: string | undefined;
    financial?: string | undefined;
    health?: string | undefined;
    life?: string | undefined;
    nonPropCas?: string | undefined;
    benefits?: string | undefined;
    fileName?: string | undefined;
    timeStamp: Date;
}

export class CustomersMiniConversionCountModel implements ICustomersMiniConversionCountModel {
    recordsCount!: number;

    constructor(data?: ICustomersMiniConversionCountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsCount = _data["recordsCount"];
        }
    }

    static fromJS(data: any): CustomersMiniConversionCountModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersMiniConversionCountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsCount"] = this.recordsCount;
        return data;
    }
}

export interface ICustomersMiniConversionCountModel {
    recordsCount: number;
}

export class CustomersMiniConversionValidationResultsModel implements ICustomersMiniConversionValidationResultsModel {
    errorCount!: number;
    warningCount!: number;
    infoCount!: number;

    constructor(data?: ICustomersMiniConversionValidationResultsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCount = _data["errorCount"];
            this.warningCount = _data["warningCount"];
            this.infoCount = _data["infoCount"];
        }
    }

    static fromJS(data: any): CustomersMiniConversionValidationResultsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersMiniConversionValidationResultsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCount"] = this.errorCount;
        data["warningCount"] = this.warningCount;
        data["infoCount"] = this.infoCount;
        return data;
    }
}

export interface ICustomersMiniConversionValidationResultsModel {
    errorCount: number;
    warningCount: number;
    infoCount: number;
}

export class DepartmentModel implements IDepartmentModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop!: boolean;
    isPrimary?: boolean | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IDepartmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.isDrop = _data["isDrop"];
            this.isPrimary = _data["isPrimary"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): DepartmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["isDrop"] = this.isDrop;
        data["isPrimary"] = this.isPrimary;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IDepartmentModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop: boolean;
    isPrimary?: boolean | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class DepartmentRefModel implements IDepartmentRefModel {
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;

    constructor(data?: IDepartmentRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): DepartmentRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface IDepartmentRefModel {
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
}

export class DivisionModel implements IDivisionModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop!: boolean;
    isPrimary?: boolean | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IDivisionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.isDrop = _data["isDrop"];
            this.isPrimary = _data["isPrimary"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): DivisionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["isDrop"] = this.isDrop;
        data["isPrimary"] = this.isPrimary;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IDivisionModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop: boolean;
    isPrimary?: boolean | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class DivisionRefModel implements IDivisionRefModel {
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;

    constructor(data?: IDivisionRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): DivisionRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface IDivisionRefModel {
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
}

export class EmployeeModel implements IEmployeeModel {
    id!: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    isRep?: boolean | undefined;
    isProd?: boolean | undefined;
    isTeleMarketer?: boolean | undefined;
    lobCount!: number;
    clientCount!: number;
    isOther?: boolean | undefined;
    status?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    businessNumber?: string | undefined;
    email?: string | undefined;
    email2?: string | undefined;
    mobileNumber?: string | undefined;
    residenceNumber?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    isDrop!: boolean;
    isPrimary!: boolean;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;
    isAddToMain!: boolean;

    constructor(data?: IEmployeeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.isRep = _data["isRep"];
            this.isProd = _data["isProd"];
            this.isTeleMarketer = _data["isTeleMarketer"];
            this.lobCount = _data["lobCount"];
            this.clientCount = _data["clientCount"];
            this.isOther = _data["isOther"];
            this.status = _data["status"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.businessNumber = _data["businessNumber"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.mobileNumber = _data["mobileNumber"];
            this.residenceNumber = _data["residenceNumber"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.isDrop = _data["isDrop"];
            this.isPrimary = _data["isPrimary"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
            this.isAddToMain = _data["isAddToMain"];
        }
    }

    static fromJS(data: any): EmployeeModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["isRep"] = this.isRep;
        data["isProd"] = this.isProd;
        data["isTeleMarketer"] = this.isTeleMarketer;
        data["lobCount"] = this.lobCount;
        data["clientCount"] = this.clientCount;
        data["isOther"] = this.isOther;
        data["status"] = this.status;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["businessNumber"] = this.businessNumber;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["mobileNumber"] = this.mobileNumber;
        data["residenceNumber"] = this.residenceNumber;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["isDrop"] = this.isDrop;
        data["isPrimary"] = this.isPrimary;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        data["isAddToMain"] = this.isAddToMain;
        return data;
    }
}

export interface IEmployeeModel {
    id: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    isRep?: boolean | undefined;
    isProd?: boolean | undefined;
    isTeleMarketer?: boolean | undefined;
    lobCount: number;
    clientCount: number;
    isOther?: boolean | undefined;
    status?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    businessNumber?: string | undefined;
    email?: string | undefined;
    email2?: string | undefined;
    mobileNumber?: string | undefined;
    residenceNumber?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    isDrop: boolean;
    isPrimary: boolean;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
    isAddToMain: boolean;
}

export class EmployeeRefModel implements IEmployeeRefModel {
    sourceCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    isRep!: boolean;
    isProd!: boolean;
    isTeleMarketer!: boolean;
    isOther!: boolean;
    status?: string | undefined;

    constructor(data?: IEmployeeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.isRep = _data["isRep"];
            this.isProd = _data["isProd"];
            this.isTeleMarketer = _data["isTeleMarketer"];
            this.isOther = _data["isOther"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EmployeeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["isRep"] = this.isRep;
        data["isProd"] = this.isProd;
        data["isTeleMarketer"] = this.isTeleMarketer;
        data["isOther"] = this.isOther;
        data["status"] = this.status;
        return data;
    }
}

export interface IEmployeeRefModel {
    sourceCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    isRep: boolean;
    isProd: boolean;
    isTeleMarketer: boolean;
    isOther: boolean;
    status?: string | undefined;
}

export class EmployeeTypeModel implements IEmployeeTypeModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    isDrop!: boolean;
    isPrimary?: boolean | undefined;
    rank!: number;
    rowVersion?: string | undefined;
    isMapped!: boolean;

    constructor(data?: IEmployeeTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.referenceId = _data["referenceId"];
            this.destinationCode = _data["destinationCode"];
            this.isDrop = _data["isDrop"];
            this.isPrimary = _data["isPrimary"];
            this.rank = _data["rank"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
        }
    }

    static fromJS(data: any): EmployeeTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["referenceId"] = this.referenceId;
        data["destinationCode"] = this.destinationCode;
        data["isDrop"] = this.isDrop;
        data["isPrimary"] = this.isPrimary;
        data["rank"] = this.rank;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        return data;
    }
}

export interface IEmployeeTypeModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    isDrop: boolean;
    isPrimary?: boolean | undefined;
    rank: number;
    rowVersion?: string | undefined;
    isMapped: boolean;
}

export class EmployeeTypeRefModel implements IEmployeeTypeRefModel {
    id!: string;
    description?: string | undefined;

    constructor(data?: IEmployeeTypeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EmployeeTypeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeTypeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IEmployeeTypeRefModel {
    id: string;
    description?: string | undefined;
}

export class EntityListModelOfDynamicEntityModel implements IEntityListModelOfDynamicEntityModel {
    entities?: DynamicEntityModel[] | undefined;
    count!: number;

    constructor(data?: IEntityListModelOfDynamicEntityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(DynamicEntityModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): EntityListModelOfDynamicEntityModel {
        data = typeof data === 'object' ? data : {};
        let result = new EntityListModelOfDynamicEntityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IEntityListModelOfDynamicEntityModel {
    entities?: DynamicEntityModel[] | undefined;
    count: number;
}

export class DynamicEntityListModel extends EntityListModelOfDynamicEntityModel implements IDynamicEntityListModel {
    schema?: DynamicEntitySchemaModel | undefined;

    constructor(data?: IDynamicEntityListModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.schema = _data["schema"] ? DynamicEntitySchemaModel.fromJS(_data["schema"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DynamicEntityListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicEntityListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schema"] = this.schema ? this.schema.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDynamicEntityListModel extends IEntityListModelOfDynamicEntityModel {
    schema?: DynamicEntitySchemaModel | undefined;
}

export enum SortDirection {
    None = 0,
    Ascending = 1,
    Descending = 2,
}

export class GroupModel implements IGroupModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop!: boolean;
    isPrimary?: boolean | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.isDrop = _data["isDrop"];
            this.isPrimary = _data["isPrimary"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): GroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["isDrop"] = this.isDrop;
        data["isPrimary"] = this.isPrimary;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IGroupModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop: boolean;
    isPrimary?: boolean | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class GroupRefModel implements IGroupRefModel {
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;

    constructor(data?: IGroupRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): GroupRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface IGroupRefModel {
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
}

export class QueueRecord implements IQueueRecord {
    id!: number;
    srcFilePath?: string | undefined;
    imageId!: string;
    isCrawled!: boolean;
    isError!: boolean;
    isWarning!: boolean;

    constructor(data?: IQueueRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.srcFilePath = _data["srcFilePath"];
            this.imageId = _data["imageId"];
            this.isCrawled = _data["isCrawled"];
            this.isError = _data["isError"];
            this.isWarning = _data["isWarning"];
        }
    }

    static fromJS(data: any): QueueRecord {
        data = typeof data === 'object' ? data : {};
        let result = new QueueRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["srcFilePath"] = this.srcFilePath;
        data["imageId"] = this.imageId;
        data["isCrawled"] = this.isCrawled;
        data["isError"] = this.isError;
        data["isWarning"] = this.isWarning;
        return data;
    }
}

export interface IQueueRecord {
    id: number;
    srcFilePath?: string | undefined;
    imageId: string;
    isCrawled: boolean;
    isError: boolean;
    isWarning: boolean;
}

export class UpdateImageQueueRequest implements IUpdateImageQueueRequest {
    id!: number;
    isCrawled!: boolean;
    isError!: boolean;
    isWarning!: boolean;
    message?: string | undefined;

    constructor(data?: IUpdateImageQueueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isCrawled = _data["isCrawled"];
            this.isError = _data["isError"];
            this.isWarning = _data["isWarning"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): UpdateImageQueueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImageQueueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCrawled"] = this.isCrawled;
        data["isError"] = this.isError;
        data["isWarning"] = this.isWarning;
        data["message"] = this.message;
        return data;
    }
}

export interface IUpdateImageQueueRequest {
    id: number;
    isCrawled: boolean;
    isError: boolean;
    isWarning: boolean;
    message?: string | undefined;
}

export class ImageQueueModel implements IImageQueueModel {
    total!: number;
    staged!: number;
    error!: number;
    uploaded!: number;

    constructor(data?: IImageQueueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.staged = _data["staged"];
            this.error = _data["error"];
            this.uploaded = _data["uploaded"];
        }
    }

    static fromJS(data: any): ImageQueueModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImageQueueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["staged"] = this.staged;
        data["error"] = this.error;
        data["uploaded"] = this.uploaded;
        return data;
    }
}

export interface IImageQueueModel {
    total: number;
    staged: number;
    error: number;
    uploaded: number;
}

export class ImageLogModel implements IImageLogModel {
    id!: string;
    pathToSourceImage?: string | undefined;
    description?: string | undefined;
    message?: string | undefined;
    isCrawled!: boolean;
    isError!: boolean;
    isWarning!: boolean;
    dateCreated!: Date;
    readyForProcessingDate!: Date;

    constructor(data?: IImageLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pathToSourceImage = _data["pathToSourceImage"];
            this.description = _data["description"];
            this.message = _data["message"];
            this.isCrawled = _data["isCrawled"];
            this.isError = _data["isError"];
            this.isWarning = _data["isWarning"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.readyForProcessingDate = _data["readyForProcessingDate"] ? new Date(_data["readyForProcessingDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ImageLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImageLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pathToSourceImage"] = this.pathToSourceImage;
        data["description"] = this.description;
        data["message"] = this.message;
        data["isCrawled"] = this.isCrawled;
        data["isError"] = this.isError;
        data["isWarning"] = this.isWarning;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["readyForProcessingDate"] = this.readyForProcessingDate ? this.readyForProcessingDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IImageLogModel {
    id: string;
    pathToSourceImage?: string | undefined;
    description?: string | undefined;
    message?: string | undefined;
    isCrawled: boolean;
    isError: boolean;
    isWarning: boolean;
    dateCreated: Date;
    readyForProcessingDate: Date;
}

export class KindOfLossModel implements IKindOfLossModel {
    id!: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    referenceId?: number | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IKindOfLossModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.referenceId = _data["referenceId"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): KindOfLossModel {
        data = typeof data === 'object' ? data : {};
        let result = new KindOfLossModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["referenceId"] = this.referenceId;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IKindOfLossModel {
    id: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    referenceId?: number | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class KindOfLossRefModel implements IKindOfLossRefModel {
    id!: number;
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;

    constructor(data?: IKindOfLossRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): KindOfLossRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new KindOfLossRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface IKindOfLossRefModel {
    id: number;
    sourceCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
}

export class LineOfBusinessModel implements ILineOfBusinessModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    type?: string | undefined;
    lobCount!: number;
    referenceId?: string | undefined;
    isDrop!: boolean;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isUserMapped!: boolean;

    constructor(data?: ILineOfBusinessModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.type = _data["type"];
            this.lobCount = _data["lobCount"];
            this.referenceId = _data["referenceId"];
            this.isDrop = _data["isDrop"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): LineOfBusinessModel {
        data = typeof data === 'object' ? data : {};
        let result = new LineOfBusinessModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["type"] = this.type;
        data["lobCount"] = this.lobCount;
        data["referenceId"] = this.referenceId;
        data["isDrop"] = this.isDrop;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface ILineOfBusinessModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    type?: string | undefined;
    lobCount: number;
    referenceId?: string | undefined;
    isDrop: boolean;
    rowVersion?: string | undefined;
    isMapped: boolean;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isUserMapped: boolean;
}

export class LineOfBusinessRefModel implements ILineOfBusinessRefModel {
    id!: string;
    categoryId!: number;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: ILineOfBusinessRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): LineOfBusinessRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new LineOfBusinessRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface ILineOfBusinessRefModel {
    id: string;
    categoryId: number;
    code?: string | undefined;
    description?: string | undefined;
}

export class PoliciesMiniConversionModel implements IPoliciesMiniConversionModel {
    rowNumber!: number;
    customerRefNum?: string | undefined;
    policyRefNum?: string | undefined;
    policyNo?: string | undefined;
    effectiveDate?: string | undefined;
    expirationDate?: string | undefined;
    division?: string | undefined;
    branch?: string | undefined;
    department?: string | undefined;
    group?: string | undefined;
    typeOfBusiness?: string | undefined;
    transactionType?: string | undefined;
    description?: string | undefined;
    billMethod?: string | undefined;
    payPlan?: string | undefined;
    parentCompany?: string | undefined;
    writingCompany?: string | undefined;
    executive?: string | undefined;
    rep?: string | undefined;
    broker?: string | undefined;
    lineOfBusiness?: string | undefined;
    premium?: string | undefined;
    howBilled?: string | undefined;
    fileName?: string | undefined;
    timeStamp!: Date;

    constructor(data?: IPoliciesMiniConversionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.customerRefNum = _data["customerRefNum"];
            this.policyRefNum = _data["policyRefNum"];
            this.policyNo = _data["policyNo"];
            this.effectiveDate = _data["effectiveDate"];
            this.expirationDate = _data["expirationDate"];
            this.division = _data["division"];
            this.branch = _data["branch"];
            this.department = _data["department"];
            this.group = _data["group"];
            this.typeOfBusiness = _data["typeOfBusiness"];
            this.transactionType = _data["transactionType"];
            this.description = _data["description"];
            this.billMethod = _data["billMethod"];
            this.payPlan = _data["payPlan"];
            this.parentCompany = _data["parentCompany"];
            this.writingCompany = _data["writingCompany"];
            this.executive = _data["executive"];
            this.rep = _data["rep"];
            this.broker = _data["broker"];
            this.lineOfBusiness = _data["lineOfBusiness"];
            this.premium = _data["premium"];
            this.howBilled = _data["howBilled"];
            this.fileName = _data["fileName"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PoliciesMiniConversionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PoliciesMiniConversionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["customerRefNum"] = this.customerRefNum;
        data["policyRefNum"] = this.policyRefNum;
        data["policyNo"] = this.policyNo;
        data["effectiveDate"] = this.effectiveDate;
        data["expirationDate"] = this.expirationDate;
        data["division"] = this.division;
        data["branch"] = this.branch;
        data["department"] = this.department;
        data["group"] = this.group;
        data["typeOfBusiness"] = this.typeOfBusiness;
        data["transactionType"] = this.transactionType;
        data["description"] = this.description;
        data["billMethod"] = this.billMethod;
        data["payPlan"] = this.payPlan;
        data["parentCompany"] = this.parentCompany;
        data["writingCompany"] = this.writingCompany;
        data["executive"] = this.executive;
        data["rep"] = this.rep;
        data["broker"] = this.broker;
        data["lineOfBusiness"] = this.lineOfBusiness;
        data["premium"] = this.premium;
        data["howBilled"] = this.howBilled;
        data["fileName"] = this.fileName;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPoliciesMiniConversionModel {
    rowNumber: number;
    customerRefNum?: string | undefined;
    policyRefNum?: string | undefined;
    policyNo?: string | undefined;
    effectiveDate?: string | undefined;
    expirationDate?: string | undefined;
    division?: string | undefined;
    branch?: string | undefined;
    department?: string | undefined;
    group?: string | undefined;
    typeOfBusiness?: string | undefined;
    transactionType?: string | undefined;
    description?: string | undefined;
    billMethod?: string | undefined;
    payPlan?: string | undefined;
    parentCompany?: string | undefined;
    writingCompany?: string | undefined;
    executive?: string | undefined;
    rep?: string | undefined;
    broker?: string | undefined;
    lineOfBusiness?: string | undefined;
    premium?: string | undefined;
    howBilled?: string | undefined;
    fileName?: string | undefined;
    timeStamp: Date;
}

export class PoliciesMiniConversionCountModel implements IPoliciesMiniConversionCountModel {
    recordsCount!: number;

    constructor(data?: IPoliciesMiniConversionCountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsCount = _data["recordsCount"];
        }
    }

    static fromJS(data: any): PoliciesMiniConversionCountModel {
        data = typeof data === 'object' ? data : {};
        let result = new PoliciesMiniConversionCountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsCount"] = this.recordsCount;
        return data;
    }
}

export interface IPoliciesMiniConversionCountModel {
    recordsCount: number;
}

export class PoliciesMiniConversionValidationResultsModel implements IPoliciesMiniConversionValidationResultsModel {
    errorCount!: number;
    warningCount!: number;
    infoCount!: number;

    constructor(data?: IPoliciesMiniConversionValidationResultsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCount = _data["errorCount"];
            this.warningCount = _data["warningCount"];
            this.infoCount = _data["infoCount"];
        }
    }

    static fromJS(data: any): PoliciesMiniConversionValidationResultsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PoliciesMiniConversionValidationResultsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCount"] = this.errorCount;
        data["warningCount"] = this.warningCount;
        data["infoCount"] = this.infoCount;
        return data;
    }
}

export interface IPoliciesMiniConversionValidationResultsModel {
    errorCount: number;
    warningCount: number;
    infoCount: number;
}

export class PolicyDetailsCommercialPropertyCauseOfLossModel implements IPolicyDetailsCommercialPropertyCauseOfLossModel {
    id!: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IPolicyDetailsCommercialPropertyCauseOfLossModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): PolicyDetailsCommercialPropertyCauseOfLossModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsCommercialPropertyCauseOfLossModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IPolicyDetailsCommercialPropertyCauseOfLossModel {
    id: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class PolicyDetailsCommercialPropertyCauseOfLossRefModel implements IPolicyDetailsCommercialPropertyCauseOfLossRefModel {
    id!: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;

    constructor(data?: IPolicyDetailsCommercialPropertyCauseOfLossRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
        }
    }

    static fromJS(data: any): PolicyDetailsCommercialPropertyCauseOfLossRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsCommercialPropertyCauseOfLossRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        return data;
    }
}

export interface IPolicyDetailsCommercialPropertyCauseOfLossRefModel {
    id: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
}

export class PolicyDetailsDwellingFireCoverageCodeModel implements IPolicyDetailsDwellingFireCoverageCodeModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IPolicyDetailsDwellingFireCoverageCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.referenceId = _data["referenceId"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): PolicyDetailsDwellingFireCoverageCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsDwellingFireCoverageCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["referenceId"] = this.referenceId;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IPolicyDetailsDwellingFireCoverageCodeModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class PolicyDetailsDwellingFireCoverageCodeRefModel implements IPolicyDetailsDwellingFireCoverageCodeRefModel {
    id!: string;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPolicyDetailsDwellingFireCoverageCodeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PolicyDetailsDwellingFireCoverageCodeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsDwellingFireCoverageCodeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IPolicyDetailsDwellingFireCoverageCodeRefModel {
    id: string;
    code?: string | undefined;
    description?: string | undefined;
}

export class PolicyDetailsDwellingFireFireTypeModel implements IPolicyDetailsDwellingFireFireTypeModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IPolicyDetailsDwellingFireFireTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.referenceId = _data["referenceId"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): PolicyDetailsDwellingFireFireTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsDwellingFireFireTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["referenceId"] = this.referenceId;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IPolicyDetailsDwellingFireFireTypeModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class PolicyDetailsDwellingFireFireTypeRefModel implements IPolicyDetailsDwellingFireFireTypeRefModel {
    id!: string;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPolicyDetailsDwellingFireFireTypeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PolicyDetailsDwellingFireFireTypeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsDwellingFireFireTypeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IPolicyDetailsDwellingFireFireTypeRefModel {
    id: string;
    code?: string | undefined;
    description?: string | undefined;
}

export class PolicyDetailsHomeownersCoverageCodeModel implements IPolicyDetailsHomeownersCoverageCodeModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IPolicyDetailsHomeownersCoverageCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.referenceId = _data["referenceId"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): PolicyDetailsHomeownersCoverageCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsHomeownersCoverageCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["referenceId"] = this.referenceId;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IPolicyDetailsHomeownersCoverageCodeModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class PolicyDetailsHomeownersCoverageCodeRefModel implements IPolicyDetailsHomeownersCoverageCodeRefModel {
    id!: string;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPolicyDetailsHomeownersCoverageCodeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PolicyDetailsHomeownersCoverageCodeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsHomeownersCoverageCodeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IPolicyDetailsHomeownersCoverageCodeRefModel {
    id: string;
    code?: string | undefined;
    description?: string | undefined;
}

export class PolicyDetailsHomeownersFormTypeModel implements IPolicyDetailsHomeownersFormTypeModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IPolicyDetailsHomeownersFormTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.referenceId = _data["referenceId"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): PolicyDetailsHomeownersFormTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsHomeownersFormTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["referenceId"] = this.referenceId;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IPolicyDetailsHomeownersFormTypeModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class PolicyDetailsHomeownersFormTypeRefModel implements IPolicyDetailsHomeownersFormTypeRefModel {
    id!: string;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPolicyDetailsHomeownersFormTypeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PolicyDetailsHomeownersFormTypeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsHomeownersFormTypeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IPolicyDetailsHomeownersFormTypeRefModel {
    id: string;
    code?: string | undefined;
    description?: string | undefined;
}

export class PolicyDetailsPersonalAutoAntilockBrakeModel implements IPolicyDetailsPersonalAutoAntilockBrakeModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IPolicyDetailsPersonalAutoAntilockBrakeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.referenceId = _data["referenceId"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): PolicyDetailsPersonalAutoAntilockBrakeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsPersonalAutoAntilockBrakeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["referenceId"] = this.referenceId;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IPolicyDetailsPersonalAutoAntilockBrakeModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class PolicyDetailsPersonalAutoAntilockBrakeRefModel implements IPolicyDetailsPersonalAutoAntilockBrakeRefModel {
    id!: string;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPolicyDetailsPersonalAutoAntilockBrakeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PolicyDetailsPersonalAutoAntilockBrakeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsPersonalAutoAntilockBrakeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IPolicyDetailsPersonalAutoAntilockBrakeRefModel {
    id: string;
    code?: string | undefined;
    description?: string | undefined;
}

export class PolicyDetailsPersonalAutoBodyTypeModel implements IPolicyDetailsPersonalAutoBodyTypeModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IPolicyDetailsPersonalAutoBodyTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.referenceId = _data["referenceId"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): PolicyDetailsPersonalAutoBodyTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsPersonalAutoBodyTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["referenceId"] = this.referenceId;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IPolicyDetailsPersonalAutoBodyTypeModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class PolicyDetailsPersonalAutoBodyTypeRefModel implements IPolicyDetailsPersonalAutoBodyTypeRefModel {
    id!: string;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPolicyDetailsPersonalAutoBodyTypeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PolicyDetailsPersonalAutoBodyTypeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsPersonalAutoBodyTypeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IPolicyDetailsPersonalAutoBodyTypeRefModel {
    id: string;
    code?: string | undefined;
    description?: string | undefined;
}

export class PolicyDetailsPersonalAutoCoverageCodeModel implements IPolicyDetailsPersonalAutoCoverageCodeModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IPolicyDetailsPersonalAutoCoverageCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.referenceId = _data["referenceId"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): PolicyDetailsPersonalAutoCoverageCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsPersonalAutoCoverageCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["referenceId"] = this.referenceId;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IPolicyDetailsPersonalAutoCoverageCodeModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class PolicyDetailsPersonalAutoCoverageCodeRefModel implements IPolicyDetailsPersonalAutoCoverageCodeRefModel {
    id!: string;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPolicyDetailsPersonalAutoCoverageCodeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PolicyDetailsPersonalAutoCoverageCodeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailsPersonalAutoCoverageCodeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IPolicyDetailsPersonalAutoCoverageCodeRefModel {
    id: string;
    code?: string | undefined;
    description?: string | undefined;
}

export class PolicyStatusTypeModel implements IPolicyStatusTypeModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    preEffectiveReferenceId?: string | undefined;
    effectiveReferenceId?: string | undefined;
    expiredReferenceId?: string | undefined;
    preEffective?: string | undefined;
    effective?: string | undefined;
    expired?: string | undefined;
    isDrop!: boolean;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IPolicyStatusTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.preEffectiveReferenceId = _data["preEffectiveReferenceId"];
            this.effectiveReferenceId = _data["effectiveReferenceId"];
            this.expiredReferenceId = _data["expiredReferenceId"];
            this.preEffective = _data["preEffective"];
            this.effective = _data["effective"];
            this.expired = _data["expired"];
            this.isDrop = _data["isDrop"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): PolicyStatusTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyStatusTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["preEffectiveReferenceId"] = this.preEffectiveReferenceId;
        data["effectiveReferenceId"] = this.effectiveReferenceId;
        data["expiredReferenceId"] = this.expiredReferenceId;
        data["preEffective"] = this.preEffective;
        data["effective"] = this.effective;
        data["expired"] = this.expired;
        data["isDrop"] = this.isDrop;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IPolicyStatusTypeModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    preEffectiveReferenceId?: string | undefined;
    effectiveReferenceId?: string | undefined;
    expiredReferenceId?: string | undefined;
    preEffective?: string | undefined;
    effective?: string | undefined;
    expired?: string | undefined;
    isDrop: boolean;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class PolicyStatusTypeRefModel implements IPolicyStatusTypeRefModel {
    id!: string;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPolicyStatusTypeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PolicyStatusTypeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyStatusTypeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IPolicyStatusTypeRefModel {
    id: string;
    code?: string | undefined;
    description?: string | undefined;
}

export class PolicyTransactionTypeModel implements IPolicyTransactionTypeModel {
    id!: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    isDrop!: boolean;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IPolicyTransactionTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.referenceId = _data["referenceId"];
            this.destinationCode = _data["destinationCode"];
            this.isDrop = _data["isDrop"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): PolicyTransactionTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyTransactionTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["referenceId"] = this.referenceId;
        data["destinationCode"] = this.destinationCode;
        data["isDrop"] = this.isDrop;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IPolicyTransactionTypeModel {
    id: string;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    referenceId?: string | undefined;
    destinationCode?: string | undefined;
    isDrop: boolean;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class PolicyTransactionTypeRefModel implements IPolicyTransactionTypeRefModel {
    id!: string;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPolicyTransactionTypeRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PolicyTransactionTypeRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyTransactionTypeRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IPolicyTransactionTypeRefModel {
    id: string;
    code?: string | undefined;
    description?: string | undefined;
}

export class StatisticsModel implements IStatisticsModel {
    entityType?: string | undefined;
    mapped?: number | undefined;
    notMapped?: number | undefined;
    isDropped?: number | undefined;
    isValid?: number | undefined;
    total?: number | undefined;
    entityName?: string | undefined;

    constructor(data?: IStatisticsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.mapped = _data["mapped"];
            this.notMapped = _data["notMapped"];
            this.isDropped = _data["isDropped"];
            this.isValid = _data["isValid"];
            this.total = _data["total"];
            this.entityName = _data["entityName"];
        }
    }

    static fromJS(data: any): StatisticsModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["mapped"] = this.mapped;
        data["notMapped"] = this.notMapped;
        data["isDropped"] = this.isDropped;
        data["isValid"] = this.isValid;
        data["total"] = this.total;
        data["entityName"] = this.entityName;
        return data;
    }
}

export interface IStatisticsModel {
    entityType?: string | undefined;
    mapped?: number | undefined;
    notMapped?: number | undefined;
    isDropped?: number | undefined;
    isValid?: number | undefined;
    total?: number | undefined;
    entityName?: string | undefined;
}

export class VendorModel implements IVendorModel {
    id!: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop!: boolean;
    isCompany?: boolean | undefined;
    isPrimary!: boolean;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isAddToMain!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IVendorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.isDrop = _data["isDrop"];
            this.isCompany = _data["isCompany"];
            this.isPrimary = _data["isPrimary"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isAddToMain = _data["isAddToMain"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): VendorModel {
        data = typeof data === 'object' ? data : {};
        let result = new VendorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["isDrop"] = this.isDrop;
        data["isCompany"] = this.isCompany;
        data["isPrimary"] = this.isPrimary;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isAddToMain"] = this.isAddToMain;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IVendorModel {
    id: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop: boolean;
    isCompany?: boolean | undefined;
    isPrimary: boolean;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isAddToMain: boolean;
    isUserMapped: boolean;
}

export class VendorRefModel implements IVendorRefModel {
    sourceCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    displayName?: string | undefined;
    isCompany?: boolean | undefined;

    constructor(data?: IVendorRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.displayName = _data["displayName"];
            this.isCompany = _data["isCompany"];
        }
    }

    static fromJS(data: any): VendorRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new VendorRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["displayName"] = this.displayName;
        data["isCompany"] = this.isCompany;
        return data;
    }
}

export interface IVendorRefModel {
    sourceCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    displayName?: string | undefined;
    isCompany?: boolean | undefined;
}

export class WorkGroupModel implements IWorkGroupModel {
    id!: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop!: boolean;
    exclude!: boolean;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IWorkGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.isDrop = _data["isDrop"];
            this.exclude = _data["exclude"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): WorkGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["isDrop"] = this.isDrop;
        data["exclude"] = this.exclude;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IWorkGroupModel {
    id: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop: boolean;
    exclude: boolean;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export class ConversionCleanupReportResponse implements IConversionCleanupReportResponse {
    retentionDays!: number;
    records?: ConversionCleanupReportModel[] | undefined;

    constructor(data?: IConversionCleanupReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.retentionDays = _data["retentionDays"];
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(ConversionCleanupReportModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConversionCleanupReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionCleanupReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retentionDays"] = this.retentionDays;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConversionCleanupReportResponse {
    retentionDays: number;
    records?: ConversionCleanupReportModel[] | undefined;
}

export class ConversionCleanupReportModel implements IConversionCleanupReportModel {
    id!: string;
    conversionName?: string | undefined;
    conversionType?: string | undefined;
    runType?: string | undefined;
    createdByName?: string | undefined;
    createdByEmail?: string | undefined;
    goLiveDate?: Date | undefined;
    createdDate!: Date;
    retentionCutoffDate!: Date;
    isEligibleForDeletion!: boolean;
    doNotArchive!: boolean;
    deletionException?: string | undefined;

    constructor(data?: IConversionCleanupReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conversionName = _data["conversionName"];
            this.conversionType = _data["conversionType"];
            this.runType = _data["runType"];
            this.createdByName = _data["createdByName"];
            this.createdByEmail = _data["createdByEmail"];
            this.goLiveDate = _data["goLiveDate"] ? new Date(_data["goLiveDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.retentionCutoffDate = _data["retentionCutoffDate"] ? new Date(_data["retentionCutoffDate"].toString()) : <any>undefined;
            this.isEligibleForDeletion = _data["isEligibleForDeletion"];
            this.doNotArchive = _data["doNotArchive"];
            this.deletionException = _data["deletionException"];
        }
    }

    static fromJS(data: any): ConversionCleanupReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionCleanupReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conversionName"] = this.conversionName;
        data["conversionType"] = this.conversionType;
        data["runType"] = this.runType;
        data["createdByName"] = this.createdByName;
        data["createdByEmail"] = this.createdByEmail;
        data["goLiveDate"] = this.goLiveDate ? this.goLiveDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["retentionCutoffDate"] = this.retentionCutoffDate ? this.retentionCutoffDate.toISOString() : <any>undefined;
        data["isEligibleForDeletion"] = this.isEligibleForDeletion;
        data["doNotArchive"] = this.doNotArchive;
        data["deletionException"] = this.deletionException;
        return data;
    }
}

export interface IConversionCleanupReportModel {
    id: string;
    conversionName?: string | undefined;
    conversionType?: string | undefined;
    runType?: string | undefined;
    createdByName?: string | undefined;
    createdByEmail?: string | undefined;
    goLiveDate?: Date | undefined;
    createdDate: Date;
    retentionCutoffDate: Date;
    isEligibleForDeletion: boolean;
    doNotArchive: boolean;
    deletionException?: string | undefined;
}

export class ConversionReportArchiveSummaryModel implements IConversionReportArchiveSummaryModel {
    id!: string;
    conversionName?: string | undefined;
    conversionType?: string | undefined;
    clientName?: string | undefined;
    runType?: string | undefined;
    createdByName?: string | undefined;
    goLiveDate?: Date | undefined;
    completionDate?: Date | undefined;
    createdDate!: Date;

    constructor(data?: IConversionReportArchiveSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conversionName = _data["conversionName"];
            this.conversionType = _data["conversionType"];
            this.clientName = _data["clientName"];
            this.runType = _data["runType"];
            this.createdByName = _data["createdByName"];
            this.goLiveDate = _data["goLiveDate"] ? new Date(_data["goLiveDate"].toString()) : <any>undefined;
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConversionReportArchiveSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionReportArchiveSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conversionName"] = this.conversionName;
        data["conversionType"] = this.conversionType;
        data["clientName"] = this.clientName;
        data["runType"] = this.runType;
        data["createdByName"] = this.createdByName;
        data["goLiveDate"] = this.goLiveDate ? this.goLiveDate.toISOString() : <any>undefined;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IConversionReportArchiveSummaryModel {
    id: string;
    conversionName?: string | undefined;
    conversionType?: string | undefined;
    clientName?: string | undefined;
    runType?: string | undefined;
    createdByName?: string | undefined;
    goLiveDate?: Date | undefined;
    completionDate?: Date | undefined;
    createdDate: Date;
}

export class ConversionReportArchiveItemModel implements IConversionReportArchiveItemModel {
    id!: string;
    category?: string | undefined;
    reportKey?: string | undefined;
    reportName?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    hasData!: boolean;
    archivedOn!: Date;
    downloadCount!: number;

    constructor(data?: IConversionReportArchiveItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.reportKey = _data["reportKey"];
            this.reportName = _data["reportName"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.hasData = _data["hasData"];
            this.archivedOn = _data["archivedOn"] ? new Date(_data["archivedOn"].toString()) : <any>undefined;
            this.downloadCount = _data["downloadCount"];
        }
    }

    static fromJS(data: any): ConversionReportArchiveItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionReportArchiveItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["reportKey"] = this.reportKey;
        data["reportName"] = this.reportName;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["hasData"] = this.hasData;
        data["archivedOn"] = this.archivedOn ? this.archivedOn.toISOString() : <any>undefined;
        data["downloadCount"] = this.downloadCount;
        return data;
    }
}

export interface IConversionReportArchiveItemModel {
    id: string;
    category?: string | undefined;
    reportKey?: string | undefined;
    reportName?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    hasData: boolean;
    archivedOn: Date;
    downloadCount: number;
}

export class ConversionServerModel implements IConversionServerModel {
    id!: string;
    serverInstanceName?: string | undefined;
    amS360Setup!: boolean;

    constructor(data?: IConversionServerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serverInstanceName = _data["serverInstanceName"];
            this.amS360Setup = _data["amS360Setup"];
        }
    }

    static fromJS(data: any): ConversionServerModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionServerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serverInstanceName"] = this.serverInstanceName;
        data["amS360Setup"] = this.amS360Setup;
        return data;
    }
}

export interface IConversionServerModel {
    id: string;
    serverInstanceName?: string | undefined;
    amS360Setup: boolean;
}

export class NewSplitByBusinessUnitModel implements INewSplitByBusinessUnitModel {
    serverId!: string;
    originalDatabaseName?: string | undefined;
    filteredDatabaseName?: string | undefined;
    agencyList?: string | undefined;
    branchList?: string | undefined;
    departmentList?: string | undefined;

    constructor(data?: INewSplitByBusinessUnitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverId = _data["serverId"];
            this.originalDatabaseName = _data["originalDatabaseName"];
            this.filteredDatabaseName = _data["filteredDatabaseName"];
            this.agencyList = _data["agencyList"];
            this.branchList = _data["branchList"];
            this.departmentList = _data["departmentList"];
        }
    }

    static fromJS(data: any): NewSplitByBusinessUnitModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewSplitByBusinessUnitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverId"] = this.serverId;
        data["originalDatabaseName"] = this.originalDatabaseName;
        data["filteredDatabaseName"] = this.filteredDatabaseName;
        data["agencyList"] = this.agencyList;
        data["branchList"] = this.branchList;
        data["departmentList"] = this.departmentList;
        return data;
    }
}

export interface INewSplitByBusinessUnitModel {
    serverId: string;
    originalDatabaseName?: string | undefined;
    filteredDatabaseName?: string | undefined;
    agencyList?: string | undefined;
    branchList?: string | undefined;
    departmentList?: string | undefined;
}

export class SplitByBusinessUnitModel implements ISplitByBusinessUnitModel {
    id!: string;
    executionId?: number | undefined;
    serverName?: string | undefined;
    originalDatabaseName?: string | undefined;
    filteredDatabaseName?: string | undefined;
    agencyList?: string | undefined;
    branchList?: string | undefined;
    departmentList?: string | undefined;
    status?: string | undefined;
    errorMessage?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    estimatedFinish?: Date | undefined;
    estimatedFinishEarly?: Date | undefined;
    estimatedFinishLate?: Date | undefined;

    constructor(data?: ISplitByBusinessUnitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.executionId = _data["executionId"];
            this.serverName = _data["serverName"];
            this.originalDatabaseName = _data["originalDatabaseName"];
            this.filteredDatabaseName = _data["filteredDatabaseName"];
            this.agencyList = _data["agencyList"];
            this.branchList = _data["branchList"];
            this.departmentList = _data["departmentList"];
            this.status = _data["status"];
            this.errorMessage = _data["errorMessage"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.estimatedFinish = _data["estimatedFinish"] ? new Date(_data["estimatedFinish"].toString()) : <any>undefined;
            this.estimatedFinishEarly = _data["estimatedFinishEarly"] ? new Date(_data["estimatedFinishEarly"].toString()) : <any>undefined;
            this.estimatedFinishLate = _data["estimatedFinishLate"] ? new Date(_data["estimatedFinishLate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SplitByBusinessUnitModel {
        data = typeof data === 'object' ? data : {};
        let result = new SplitByBusinessUnitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["executionId"] = this.executionId;
        data["serverName"] = this.serverName;
        data["originalDatabaseName"] = this.originalDatabaseName;
        data["filteredDatabaseName"] = this.filteredDatabaseName;
        data["agencyList"] = this.agencyList;
        data["branchList"] = this.branchList;
        data["departmentList"] = this.departmentList;
        data["status"] = this.status;
        data["errorMessage"] = this.errorMessage;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["estimatedFinish"] = this.estimatedFinish ? this.estimatedFinish.toISOString() : <any>undefined;
        data["estimatedFinishEarly"] = this.estimatedFinishEarly ? this.estimatedFinishEarly.toISOString() : <any>undefined;
        data["estimatedFinishLate"] = this.estimatedFinishLate ? this.estimatedFinishLate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISplitByBusinessUnitModel {
    id: string;
    executionId?: number | undefined;
    serverName?: string | undefined;
    originalDatabaseName?: string | undefined;
    filteredDatabaseName?: string | undefined;
    agencyList?: string | undefined;
    branchList?: string | undefined;
    departmentList?: string | undefined;
    status?: string | undefined;
    errorMessage?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    estimatedFinish?: Date | undefined;
    estimatedFinishEarly?: Date | undefined;
    estimatedFinishLate?: Date | undefined;
}

export class SplitTimingModel implements ISplitTimingModel {
    id!: string;
    splitId!: string;
    sequenceId!: number;
    tableName?: string | undefined;
    action?: string | undefined;
    recordCount?: number | undefined;
    startedOn?: Date | undefined;
    finishedOn?: Date | undefined;
    executionTimeInMilliseconds?: number | undefined;

    constructor(data?: ISplitTimingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.splitId = _data["splitId"];
            this.sequenceId = _data["sequenceId"];
            this.tableName = _data["tableName"];
            this.action = _data["action"];
            this.recordCount = _data["recordCount"];
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : <any>undefined;
            this.finishedOn = _data["finishedOn"] ? new Date(_data["finishedOn"].toString()) : <any>undefined;
            this.executionTimeInMilliseconds = _data["executionTimeInMilliseconds"];
        }
    }

    static fromJS(data: any): SplitTimingModel {
        data = typeof data === 'object' ? data : {};
        let result = new SplitTimingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["splitId"] = this.splitId;
        data["sequenceId"] = this.sequenceId;
        data["tableName"] = this.tableName;
        data["action"] = this.action;
        data["recordCount"] = this.recordCount;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["finishedOn"] = this.finishedOn ? this.finishedOn.toISOString() : <any>undefined;
        data["executionTimeInMilliseconds"] = this.executionTimeInMilliseconds;
        return data;
    }
}

export interface ISplitTimingModel {
    id: string;
    splitId: string;
    sequenceId: number;
    tableName?: string | undefined;
    action?: string | undefined;
    recordCount?: number | undefined;
    startedOn?: Date | undefined;
    finishedOn?: Date | undefined;
    executionTimeInMilliseconds?: number | undefined;
}

export class SelectOptionOfUInt64 implements ISelectOptionOfUInt64 {
    id!: number;
    description?: string | undefined;

    constructor(data?: ISelectOptionOfUInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SelectOptionOfUInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new SelectOptionOfUInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface ISelectOptionOfUInt64 {
    id: number;
    description?: string | undefined;
}

export class SelectOptionOfGuid implements ISelectOptionOfGuid {
    id!: string;
    description?: string | undefined;

    constructor(data?: ISelectOptionOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SelectOptionOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new SelectOptionOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface ISelectOptionOfGuid {
    id: string;
    description?: string | undefined;
}

export enum SupportedEntities {
    None = 0,
    Division = 1,
    AcquisitionCodes = 2,
    ActivitySuspenseActionTypes = 4,
    AttachedForms = 8,
    Brokers = 16,
    BillingTransactions = 32,
    BodyTypes = 64,
    CancellationReasons = 64,
    BusinessOrigins = 128,
    BusinessTypes = 256,
    Branch = 512,
    ClaimPaidByTypes = 1024,
    ClaimPaymentTypes = 2048,
    Company = 4096,
    CompanyPlans = 8192,
    ConstructionTypes = 16384,
    ContactTypes = 32768,
    CoverageCodes = 65536,
    CoverageOptions = 131072,
    CustomerNotations = 262144,
    DocumentCategories = 524288,
    DocumentClassifications = 1048576,
    Department = 4194304,
    DocumentTypes = 8388608,
    Employee = 16777216,
    Group = 33554432,
    HeatTypes = 67108864,
    InterestTypes = 134217728,
    JobTitles = 268435456,
    KindOfLoss = 536870912,
    LineOfBusiness = 1073741824,
    Occupations = 2147483648,
    PersonalPropertyClasses = 4294967296,
    PolicySubNotations = 8589934592,
    ProfileQuestion = 17179869184,
    Relationships = 34359738368,
    SubjectsOfInsurance = 68719476736,
    TextSetups = 137438953472,
    TypeEntities = 274877906944,
    UnlicensedExcludedDrivers = 549755813888,
    Violations = 1099511627776,
    WorkGroup = 2199023255552,
    All = 4398044413951,
}

export class EmployeeRefDto implements IEmployeeRefDto {
    sourceCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    isRep!: boolean;
    isProd!: boolean;
    isTeleMarketer!: boolean;
    isOther!: boolean;
    status?: string | undefined;

    constructor(data?: IEmployeeRefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.isRep = _data["isRep"];
            this.isProd = _data["isProd"];
            this.isTeleMarketer = _data["isTeleMarketer"];
            this.isOther = _data["isOther"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EmployeeRefDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeRefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["isRep"] = this.isRep;
        data["isProd"] = this.isProd;
        data["isTeleMarketer"] = this.isTeleMarketer;
        data["isOther"] = this.isOther;
        data["status"] = this.status;
        return data;
    }
}

export interface IEmployeeRefDto {
    sourceCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    isRep: boolean;
    isProd: boolean;
    isTeleMarketer: boolean;
    isOther: boolean;
    status?: string | undefined;
}

export class TableSize implements ITableSize {
    rows!: number;
    columns!: number;

    constructor(data?: ITableSize) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rows = _data["rows"];
            this.columns = _data["columns"];
        }
    }

    static fromJS(data: any): TableSize {
        data = typeof data === 'object' ? data : {};
        let result = new TableSize();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rows"] = this.rows;
        data["columns"] = this.columns;
        return data;
    }
}

export interface ITableSize {
    rows: number;
    columns: number;
}

export class RoleModel extends BaseEntityModel implements IRoleModel {
    description?: string | undefined;

    constructor(data?: IRoleModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface IRoleModel extends IBaseEntityModel {
    description?: string | undefined;
}

export class UserModel extends BaseEntityModel implements IUserModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: RoleModel | undefined;
    emailAddress?: string | undefined;
    password?: string | undefined;
    isActive!: boolean;
    emailList!: boolean;
    projectStatus!: boolean;

    constructor(data?: IUserModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.role = _data["role"] ? RoleModel.fromJS(_data["role"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.emailList = _data["emailList"];
            this.projectStatus = _data["projectStatus"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["emailList"] = this.emailList;
        data["projectStatus"] = this.projectStatus;
        super.toJSON(data);
        return data;
    }
}

export interface IUserModel extends IBaseEntityModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: RoleModel | undefined;
    emailAddress?: string | undefined;
    password?: string | undefined;
    isActive: boolean;
    emailList: boolean;
    projectStatus: boolean;
}

export class UserToConversionClientModel implements IUserToConversionClientModel {
    userId!: string;
    clientId!: string;

    constructor(data?: IUserToConversionClientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): UserToConversionClientModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserToConversionClientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IUserToConversionClientModel {
    userId: string;
    clientId: string;
}

export class UpdateUserToClientRequestModel implements IUpdateUserToClientRequestModel {
    insert?: UserToConversionClientModel[] | undefined;
    remove?: UserToConversionClientModel[] | undefined;

    constructor(data?: IUpdateUserToClientRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(UserToConversionClientModel.fromJS(item));
            }
            if (Array.isArray(_data["remove"])) {
                this.remove = [] as any;
                for (let item of _data["remove"])
                    this.remove!.push(UserToConversionClientModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateUserToClientRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserToClientRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item.toJSON());
        }
        if (Array.isArray(this.remove)) {
            data["remove"] = [];
            for (let item of this.remove)
                data["remove"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateUserToClientRequestModel {
    insert?: UserToConversionClientModel[] | undefined;
    remove?: UserToConversionClientModel[] | undefined;
}

export class UpdateUserToConversionRequestModel implements IUpdateUserToConversionRequestModel {
    insert?: UserToConversionModel[] | undefined;
    remove?: UserToConversionModel[] | undefined;

    constructor(data?: IUpdateUserToConversionRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(UserToConversionModel.fromJS(item));
            }
            if (Array.isArray(_data["remove"])) {
                this.remove = [] as any;
                for (let item of _data["remove"])
                    this.remove!.push(UserToConversionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateUserToConversionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserToConversionRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item.toJSON());
        }
        if (Array.isArray(this.remove)) {
            data["remove"] = [];
            for (let item of this.remove)
                data["remove"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateUserToConversionRequestModel {
    insert?: UserToConversionModel[] | undefined;
    remove?: UserToConversionModel[] | undefined;
}

export class UserToConversionModel implements IUserToConversionModel {
    userId!: string;
    conversionId!: string;

    constructor(data?: IUserToConversionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.conversionId = _data["conversionId"];
        }
    }

    static fromJS(data: any): UserToConversionModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserToConversionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["conversionId"] = this.conversionId;
        return data;
    }
}

export interface IUserToConversionModel {
    userId: string;
    conversionId: string;
}

export class PublishSingleDbModel implements IPublishSingleDbModel {
    conversionTypeId!: string;
    serverName?: string | undefined;
    databaseName?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: IPublishSingleDbModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversionTypeId = _data["conversionTypeId"];
            this.serverName = _data["serverName"];
            this.databaseName = _data["databaseName"];
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): PublishSingleDbModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublishSingleDbModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversionTypeId"] = this.conversionTypeId;
        data["serverName"] = this.serverName;
        data["databaseName"] = this.databaseName;
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IPublishSingleDbModel {
    conversionTypeId: string;
    serverName?: string | undefined;
    databaseName?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
}

export class PublishDBByConversionIdModel implements IPublishDBByConversionIdModel {
    conversionId!: string;

    constructor(data?: IPublishDBByConversionIdModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversionId = _data["conversionId"];
        }
    }

    static fromJS(data: any): PublishDBByConversionIdModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublishDBByConversionIdModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversionId"] = this.conversionId;
        return data;
    }
}

export interface IPublishDBByConversionIdModel {
    conversionId: string;
}

export class PublishDBByConversionTypeIdModel implements IPublishDBByConversionTypeIdModel {
    conversionTypeId!: string;
    serverName?: string | undefined;
    databaseName?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: IPublishDBByConversionTypeIdModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversionTypeId = _data["conversionTypeId"];
            this.serverName = _data["serverName"];
            this.databaseName = _data["databaseName"];
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): PublishDBByConversionTypeIdModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublishDBByConversionTypeIdModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversionTypeId"] = this.conversionTypeId;
        data["serverName"] = this.serverName;
        data["databaseName"] = this.databaseName;
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IPublishDBByConversionTypeIdModel {
    conversionTypeId: string;
    serverName?: string | undefined;
    databaseName?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
}

export class CompanyExcelDto implements ICompanyExcelDto {
    id!: number;
    rowVersion?: string | undefined;
    sourceParentShortName?: string | undefined;
    sourceParentName?: string | undefined;
    sourceWritingShortName?: string | undefined;
    sourceWritingName?: string | undefined;
    mappedParentShortName?: string | undefined;
    mappedParentName?: string | undefined;
    mappedWritingShortName?: string | undefined;
    mappedWritingName?: string | undefined;
    type?: string | undefined;
    parentDestinationDescription?: string | undefined;
    writingDestinationDescription?: string | undefined;

    constructor(data?: ICompanyExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
            this.sourceParentShortName = _data["sourceParentShortName"];
            this.sourceParentName = _data["sourceParentName"];
            this.sourceWritingShortName = _data["sourceWritingShortName"];
            this.sourceWritingName = _data["sourceWritingName"];
            this.mappedParentShortName = _data["mappedParentShortName"];
            this.mappedParentName = _data["mappedParentName"];
            this.mappedWritingShortName = _data["mappedWritingShortName"];
            this.mappedWritingName = _data["mappedWritingName"];
            this.type = _data["type"];
            this.parentDestinationDescription = _data["parentDestinationDescription"];
            this.writingDestinationDescription = _data["writingDestinationDescription"];
        }
    }

    static fromJS(data: any): CompanyExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        data["sourceParentShortName"] = this.sourceParentShortName;
        data["sourceParentName"] = this.sourceParentName;
        data["sourceWritingShortName"] = this.sourceWritingShortName;
        data["sourceWritingName"] = this.sourceWritingName;
        data["mappedParentShortName"] = this.mappedParentShortName;
        data["mappedParentName"] = this.mappedParentName;
        data["mappedWritingShortName"] = this.mappedWritingShortName;
        data["mappedWritingName"] = this.mappedWritingName;
        data["type"] = this.type;
        data["parentDestinationDescription"] = this.parentDestinationDescription;
        data["writingDestinationDescription"] = this.writingDestinationDescription;
        return data;
    }
}

export interface ICompanyExcelDto {
    id: number;
    rowVersion?: string | undefined;
    sourceParentShortName?: string | undefined;
    sourceParentName?: string | undefined;
    sourceWritingShortName?: string | undefined;
    sourceWritingName?: string | undefined;
    mappedParentShortName?: string | undefined;
    mappedParentName?: string | undefined;
    mappedWritingShortName?: string | undefined;
    mappedWritingName?: string | undefined;
    type?: string | undefined;
    parentDestinationDescription?: string | undefined;
    writingDestinationDescription?: string | undefined;
}

export class CompanyMapDto extends CompanyExcelDto implements ICompanyMapDto {
    companyId?: string | undefined;
    sourceParentType?: string | undefined;
    sourceWritingType?: string | undefined;
    mappedParentType?: string | undefined;
    agencyNo?: string | undefined;

    constructor(data?: ICompanyMapDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.sourceParentType = _data["sourceParentType"];
            this.sourceWritingType = _data["sourceWritingType"];
            this.mappedParentType = _data["mappedParentType"];
            this.agencyNo = _data["agencyNo"];
        }
    }

    static fromJS(data: any): CompanyMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["sourceParentType"] = this.sourceParentType;
        data["sourceWritingType"] = this.sourceWritingType;
        data["mappedParentType"] = this.mappedParentType;
        data["agencyNo"] = this.agencyNo;
        super.toJSON(data);
        return data;
    }
}

export interface ICompanyMapDto extends ICompanyExcelDto {
    companyId?: string | undefined;
    sourceParentType?: string | undefined;
    sourceWritingType?: string | undefined;
    mappedParentType?: string | undefined;
    agencyNo?: string | undefined;
}

export class CompanyRefDto implements ICompanyRefDto {
    id!: number;
    code?: string | undefined;
    parentCode?: string | undefined;
    typeId!: number;
    type?: string | undefined;
    shortName?: string | undefined;
    name?: string | undefined;
    naic?: string | undefined;

    constructor(data?: ICompanyRefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.parentCode = _data["parentCode"];
            this.typeId = _data["typeId"];
            this.type = _data["type"];
            this.shortName = _data["shortName"];
            this.name = _data["name"];
            this.naic = _data["naic"];
        }
    }

    static fromJS(data: any): CompanyRefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["parentCode"] = this.parentCode;
        data["typeId"] = this.typeId;
        data["type"] = this.type;
        data["shortName"] = this.shortName;
        data["name"] = this.name;
        data["naic"] = this.naic;
        return data;
    }
}

export interface ICompanyRefDto {
    id: number;
    code?: string | undefined;
    parentCode?: string | undefined;
    typeId: number;
    type?: string | undefined;
    shortName?: string | undefined;
    name?: string | undefined;
    naic?: string | undefined;
}

export class CompanyUpdateMapDto implements ICompanyUpdateMapDto {
    companyId?: string | undefined;
    rowVersion?: string | undefined;
    type?: string | undefined;
    mappedParentShortName?: string | undefined;
    mappedWritingShortName?: string | undefined;

    constructor(data?: ICompanyUpdateMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.rowVersion = _data["rowVersion"];
            this.type = _data["type"];
            this.mappedParentShortName = _data["mappedParentShortName"];
            this.mappedWritingShortName = _data["mappedWritingShortName"];
        }
    }

    static fromJS(data: any): CompanyUpdateMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyUpdateMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["rowVersion"] = this.rowVersion;
        data["type"] = this.type;
        data["mappedParentShortName"] = this.mappedParentShortName;
        data["mappedWritingShortName"] = this.mappedWritingShortName;
        return data;
    }
}

export interface ICompanyUpdateMapDto {
    companyId?: string | undefined;
    rowVersion?: string | undefined;
    type?: string | undefined;
    mappedParentShortName?: string | undefined;
    mappedWritingShortName?: string | undefined;
}

export abstract class BaseEntityDto implements IBaseEntityDto {
    id?: string | undefined;
    createdById!: string;
    createdDate!: Date;
    lastEditorId!: string;
    lastEditedDate!: Date;
    rowVersion?: string | undefined;

    constructor(data?: IBaseEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastEditorId = _data["lastEditorId"];
            this.lastEditedDate = _data["lastEditedDate"] ? new Date(_data["lastEditedDate"].toString()) : <any>undefined;
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): BaseEntityDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntityDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastEditorId"] = this.lastEditorId;
        data["lastEditedDate"] = this.lastEditedDate ? this.lastEditedDate.toISOString() : <any>undefined;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IBaseEntityDto {
    id?: string | undefined;
    createdById: string;
    createdDate: Date;
    lastEditorId: string;
    lastEditedDate: Date;
    rowVersion?: string | undefined;
}

export class ConversionDisplayDto extends BaseEntityDto implements IConversionDisplayDto {
    description?: string | undefined;
    conversionType?: string | undefined;

    constructor(data?: IConversionDisplayDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
            this.conversionType = _data["conversionType"];
        }
    }

    static fromJS(data: any): ConversionDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionDisplayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["conversionType"] = this.conversionType;
        super.toJSON(data);
        return data;
    }
}

export interface IConversionDisplayDto extends IBaseEntityDto {
    description?: string | undefined;
    conversionType?: string | undefined;
}

export class LineOfBusinessExcelDto implements ILineOfBusinessExcelDto {
    id!: string;
    rowVersion?: string | undefined;
    referenceId?: string | undefined;
    sourceType?: string | undefined;
    sourceShortName?: string | undefined;
    sourceName?: string | undefined;
    mappedType?: string | undefined;
    mappedShortName?: string | undefined;
    mappedName?: string | undefined;
    mappedValue?: string | undefined;

    constructor(data?: ILineOfBusinessExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
            this.referenceId = _data["referenceId"];
            this.sourceType = _data["sourceType"];
            this.sourceShortName = _data["sourceShortName"];
            this.sourceName = _data["sourceName"];
            this.mappedType = _data["mappedType"];
            this.mappedShortName = _data["mappedShortName"];
            this.mappedName = _data["mappedName"];
            this.mappedValue = _data["mappedValue"];
        }
    }

    static fromJS(data: any): LineOfBusinessExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new LineOfBusinessExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        data["referenceId"] = this.referenceId;
        data["sourceType"] = this.sourceType;
        data["sourceShortName"] = this.sourceShortName;
        data["sourceName"] = this.sourceName;
        data["mappedType"] = this.mappedType;
        data["mappedShortName"] = this.mappedShortName;
        data["mappedName"] = this.mappedName;
        data["mappedValue"] = this.mappedValue;
        return data;
    }
}

export interface ILineOfBusinessExcelDto {
    id: string;
    rowVersion?: string | undefined;
    referenceId?: string | undefined;
    sourceType?: string | undefined;
    sourceShortName?: string | undefined;
    sourceName?: string | undefined;
    mappedType?: string | undefined;
    mappedShortName?: string | undefined;
    mappedName?: string | undefined;
    mappedValue?: string | undefined;
}

export class LineOfBusinessMapDto extends LineOfBusinessExcelDto implements ILineOfBusinessMapDto {
    agencyNo?: string | undefined;

    constructor(data?: ILineOfBusinessMapDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyNo = _data["agencyNo"];
        }
    }

    static fromJS(data: any): LineOfBusinessMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new LineOfBusinessMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyNo"] = this.agencyNo;
        super.toJSON(data);
        return data;
    }
}

export interface ILineOfBusinessMapDto extends ILineOfBusinessExcelDto {
    agencyNo?: string | undefined;
}

export class LineOfBusinessRefDto implements ILineOfBusinessRefDto {
    id!: string;
    categoryId!: number;
    category?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: ILineOfBusinessRefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): LineOfBusinessRefDto {
        data = typeof data === 'object' ? data : {};
        let result = new LineOfBusinessRefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface ILineOfBusinessRefDto {
    id: string;
    categoryId: number;
    category?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export class LineOfBusinessUpdateMapDto implements ILineOfBusinessUpdateMapDto {
    id!: string;
    rowVersion?: string | undefined;
    mappedValue?: string | undefined;

    constructor(data?: ILineOfBusinessUpdateMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
            this.mappedValue = _data["mappedValue"];
        }
    }

    static fromJS(data: any): LineOfBusinessUpdateMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new LineOfBusinessUpdateMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        data["mappedValue"] = this.mappedValue;
        return data;
    }
}

export interface ILineOfBusinessUpdateMapDto {
    id: string;
    rowVersion?: string | undefined;
    mappedValue?: string | undefined;
}

export class WorkGroupDto implements IWorkGroupDto {
    id!: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop!: boolean;
    exclude!: boolean;
    rowVersion?: string | undefined;
    isMapped!: boolean;
    isUserMapped!: boolean;

    constructor(data?: IWorkGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceDescription = _data["sourceDescription"];
            this.destinationCode = _data["destinationCode"];
            this.destinationDescription = _data["destinationDescription"];
            this.isDrop = _data["isDrop"];
            this.exclude = _data["exclude"];
            this.rowVersion = _data["rowVersion"];
            this.isMapped = _data["isMapped"];
            this.isUserMapped = _data["isUserMapped"];
        }
    }

    static fromJS(data: any): WorkGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceDescription"] = this.sourceDescription;
        data["destinationCode"] = this.destinationCode;
        data["destinationDescription"] = this.destinationDescription;
        data["isDrop"] = this.isDrop;
        data["exclude"] = this.exclude;
        data["rowVersion"] = this.rowVersion;
        data["isMapped"] = this.isMapped;
        data["isUserMapped"] = this.isUserMapped;
        return data;
    }
}

export interface IWorkGroupDto {
    id: number;
    sourceCode?: string | undefined;
    sourceDescription?: string | undefined;
    destinationCode?: string | undefined;
    destinationDescription?: string | undefined;
    isDrop: boolean;
    exclude: boolean;
    rowVersion?: string | undefined;
    isMapped: boolean;
    isUserMapped: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}